export const es = {
  inventory_history_reference: {
    fefo_override: {
      title: 'Excepción FEFO #{{id}}',
      earlier_lot: 'lote anterior {{lot}}',
      expiring: 'vence {{date}}',
      at_location: 'en {{location}}',
      acknowledged: 'advertencia confirmada',
      no_warning: 'sin advertencia',
    },
  },
  general: {
    product: {
      insert: 'Injerto',
    },
    messages: {
      no_options: 'No se encontraron opciones',
    },
  },

  dropdown_menu: {
    warehouse_associated_one: '{{count}} almacén asociado',
    warehouse_associated_other: '{{count}} almacenes asociados',
    role_assigned_one: '{{count}} rol asignado',
    role_assigned_other: '{{count}} roles asignados',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
  },

  inputPlaceholder: {
    pdfFiles: 'Presiona aquí o arrastra tus archivos PDF.',
    addImage: 'Presiona aquí o arrastra imágenes.',
    select: 'Seleccionar',
    required_field: 'Este campo es requerido',
  },
  claims: {
    motives: {
      delivery_delay: 'El pedido ha sido recolectado y no presenta movimiento',
      false_delivery: 'El estatus del pedidPo indica que fue entregado, pero mi cliente no lo recibió',
      package_stolen: 'El estatus del pedido indica que fue robado.',
      package_lost: 'El estatus del pedido indica que fue extraviado.',
      damaged_product: 'Mi cliente recibió productos dañados o en mal estado.',
      incorrect_content: 'Lo que recibió mi cliente, no coincide con lo que ordenó',
      none_of_the_above: 'Ninguno de los anteriores',
      missing_products: 'Faltaron productos en el pedido',
      unwanted_products: 'Se recibieron productos no ordenados',
      wrong_order: 'Mi cliente recibió un pedido completo que no era el suyo',
    },
    reimbursables: {
      /*
            cost_cubbo: "Costo operativo de Cubbo",
            cost_shipping: "Costo de guía del pedido",
            product_value: "Valor indicado del producto",
            cost_shipping_replace: "Costo de guía para enviar reemplazo de pedido",
            cost_shipping_reposition: "Costo de guía para enviar reposición de pedido",
            return_cost: 'Costo de la guía de retorno del producto incorrecto'
            */
      cost_cubbo: 'Costo procesamiento del pedido',
      cost_shipping: 'Costo de guía de envío',
      product_value: 'Precio de venta de los productos',
      cost_return_shipping: 'Precio de guía de retorno',
      cost_shipping_replace: 'Costo de guía para enviar reemplazo de pedido',
      cost_shipping_reposition: 'Costo de guía para enviar reposición de pedido',
      return_cost: 'Costo de la guía de retorno del producto',
      other: 'Otros costos',
    },
    operations: {
      unwanted_products: {
        description: 'Producto incorrecto',
        recomendation:
          'Te recordamos que puedes duplicar el pedido con incidencia y ajustar los productos a reenviar para hacerle llegar a tu cliente los productos pendientes.',
      },
      missing_products: {
        description: 'Producto faltante',
        recomendation:
          'Te recordamos que puedes duplicar el pedido con incidencia y ajustar los productos a reenviar para hacérselos llegar a tu cliente y brindar una mejor experiencia.',
      },
      wrong_order: {
        description: 'Guía cruzada',
        recomendation:
          'Te recordamos que puedes duplicar el pedido con incidencia para hacerle llegar a tu cliente los productos que ordenó y brindar una mejor experiencia.',
      },
      operations_others: {
        description: 'Otros - Operaciones',
        recomendation: '',
      },
      damaged_product: {
        description: 'Dañado',
        recomendation:
          'Te recordamos que puedes duplicar el pedido con incidencia para hacerle llegar a tu cliente los productos que ordenó y brindar una mejor experiencia.',
      },
    },
    commercial: {
      unwanted_products: {
        description: 'Producto incorrecto',
        recomendation:
          'Te recordamos que puedes duplicar el pedido con incidencia para hacerle llegar a tu cliente los productos que ordenó y brindar una mejor experiencia.',
      },
      wrong_order: {
        description: 'Guía cruzada',
        recomendation:
          'Te recordamos que puedes duplicar el pedido con incidencia para hacerle llegar a tu cliente los productos que ordenó y brindar una mejor experiencia.',
      },
      operations_others: {
        description: 'Otros - Operaciones',
        recomendation: '',
      },
      damaged_product: {
        description: 'Dañado',
        recomendation:
          'Te recordamos que puedes duplicar el pedido con incidencia para hacerle llegar a tu cliente los productos que ordenó y brindar una mejor experiencia.',
      },
      package_lost: {
        description: 'Perdido',
        recomendation:
          'Te recordamos que puedes duplicar el pedido con incidencia para hacerle llegar a tu cliente los productos que ordenó y brindar una mejor experiencia.',
      },
      delivery_delay: {
        description: 'Demora en entrega',
        recomendation:
          'Te recordamos que puedes duplicar el pedido con incidencia para hacerle llegar a tu cliente los productos que ordenó y brindar una mejor experiencia.',
      },
      false_delivery: {
        description: 'Entrega Incorrecta',
        recomendation:
          'Te recordamos que puedes duplicar el pedido con incidencia para hacerle llegar a tu cliente los productos que ordenó y brindar una mejor experiencia.',
      },
      package_stolen: {
        description: 'Robo',
        recomendation:
          'Te recordamos que puedes duplicar el pedido con incidencia para hacerle llegar a tu cliente los productos que ordenó y brindar una mejor experiencia.',
      },
      missing_products_delivery: {
        description: 'Producto faltante - Paquetería',
        recomendation:
          'Te recordamos que puedes duplicar el pedido con incidencia para hacerle llegar a tu cliente los productos que ordenó y brindar una mejor experiencia.',
      },
      missing_products_operations: {
        description: 'Producto faltante - Operaciones',
        recomendation:
          'Te recordamos que puedes duplicar el pedido con incidencia para hacerle llegar a tu cliente los productos que ordenó y brindar una mejor experiencia.',
      },
    },
    client: {
      origin_error: {
        description: 'Error de origen',
        recomendation: '',
      },
    },
    delivery: {
      package_lost: {
        description: 'Perdido',
        recomendation:
          'Te recordamos que puedes duplicar el pedido con incidencia para hacerle llegar a tu cliente los productos que ordenó y brindar una mejor experiencia.',
      },
      damaged_product: {
        description: 'Dañado',
        recomendation:
          'Te recordamos que puedes duplicar el pedido con incidencia y ajustar los productos a reenviar para hacérselos llegar a tu cliente y brindar una mejor experiencia.',
      },
      delivery_delay: {
        description: 'Demora en entrega',
        recomendation: 'Te recordamos que puedes duplicar el pedido con incidencia para hacerle llegar sus productos a tu cliente.',
      },
      false_delivery: {
        description: 'Entrega Incorrecta',
        recomendation:
          'Te recordamos que puedes duplicar el pedido para hacerle llegar sus productos a tu cliente e iniciar el retorno del pedido con incidencia para retornarlo al almacén en caso de ser recuperado.',
      },
      package_stolen: {
        description: 'Robo',
        recomendation:
          'Te recordamos que puedes duplicar el pedido con incidencia para hacerle llegar a tu cliente los productos que ordenó y brindar una mejor experiencia.',
      },
      delivery_others: {
        description: 'Otros - Paquetería',
        recomendation: '',
      },
      missing_products: {
        description: 'Producto faltante',
        recomendation:
          'Te recordamos que puedes duplicar el pedido con incidencia y ajustar los productos a reenviar para hacérselos llegar a tu cliente y brindar una mejor experiencia.',
      },
    },
    html: {
      rejected: {
        message_initial: 'Hemos tenido que rechazar la disputa del pedido',
        category: 'categorizada como',
        apologies: 'lamentamos el inconveniente.',
        reazon: 'El motivo del rechazo se debe a que',
        evidence: 'Adjunto a este correo te compartimos la eviencia que respalda esta decisión.',
        recommendation: 'Para brindar la mejor experiencia posible a tu cliente, te recomendamos',
        contact: 'Puedes contactarnos desde el chat en la plataforma si requieres más detalles.',
        farewell: 'Será un placer atenderte',
        sender: 'Cubbo',
      },
      accepted: {
        message_initial: 'Hemos aceptado la disputa del pedido',
        category: 'categorizada como',
        apologies: 'lamentamos el inconveniente.',
        resolution:
          'El monto a reembolsar lo verás reflejado en tu próxima factura como crédito a favor. Estos son los conceptos considerados para el reembolso:',
        contact: 'Puedes contactarnos desde el chat en la plataforma si requieres más detalles.',
        farewell: 'Será un placer atenderte',
        sender: 'Cubbo',
      },
    },

    status: {
      accepted: 'Aceptado',
      rejected: 'Rechazado',
    },
    messages: {
      none: 'Ninguna',
      without_reason: 'Sin motivo',
      success_message: 'La disputa fue resuelta correctamente',
      success_update_message: 'La disputa fue actualizada.',
      error_message: 'Error al guardar disputa',
    },
  },

  formatted_relative_time: {
    today: 'Hoy',
    yesterday: 'Ayer',
    tomorrow: 'Mañana',
    date: '{{day}} {{month}}',
    from_now: 'Hace {{days}} días',
  },

  orders: {
    filters: {
      order_number: 'Número de pedido',
      paste_order_numbers: 'Pega el número de los pedidos',
      paste_shipping_numbers: 'Pega el número de las guías',
      shipping_number: 'Número de guía',
      channel_name: 'Canal de venta',
      shipping_method: 'Método de envío',
      status: 'Estado del pedido',
      shipping_status: 'Estado de envío',
      shipping_date: 'Fecha de envío',
      channel_name_placeholder: 'Selecciona un canal de venta',
      shipping_method_placeholder: 'Selecciona un método de envío',
      shipping_status_placeholder: 'Selecciona un estado de envío',
      tracking_description: 'Motivo del incidente',
      tracking_description_placeholder: 'Selecciona un motivo',
      tracking_description_none: 'Sin motivo ni subestado',
      shipping_incident_category_placeholder: 'Cualquier tipo',
      shipping_incident_status_placeholder: 'Cualquier estado',
      status_placeholder: 'Selecciona un estado',
      multifilter_bulk: 'Búsqueda en bulk order o tracking',
      store: 'Tienda',
      is_delayed: 'Demorados',
      first_delivery_on_time: 'Intento de entrega a tiempo',
      failed_delivery: 'Entrega fallida',
      shipping_incident: 'Con incidente',
      without_shipping_incident: 'Sin incidente',
      unsolved_shipping_incident: 'Incidente sin resolver',
    },
    incidents_bar: {
      select_action: 'Selecciona una acción',
      deselect_all_orders: 'Deseleccionar todos los pedidos',
      orders_selected: 'Pedidos seleccionados',
      update_incident: 'Actualizar estado de incidente',
      update_shipping_status: 'Actualizar estado de envío',
      orders: 'Pedidos',
      update_current_status_for: 'Actualizar estado actual por',
      update_current_shipping_status_for: 'Actualizar estado de envío actual por',
      create_incident: 'Crear incidente por',
      dialog: {
        create_title: '¿Estás seguro de que deseas crear incidente por',
        for: 'para',
        orders_selected: 'pedidos seleccionados?',
        errors_intro: 'Pedidos para os quais não é possível criar este incidente',
      },
    },
    incidents_container: {
      previous_delivery_date: 'Fecha de entrega anterior',
      new_address: 'Nueva dirección de entrega',
      address: 'Dirección ',
      number: 'Número ',
      neighborhood: 'Barrio ',
      city: 'Ciudad ',
      zip_code: 'CP ',
      state: 'Estado ',
    },
    list: {
      created_at: 'Creado el',
      create_incident: 'Crear incidente',
      resolve_incident: 'Resolver incidente',
      update_status_incident: 'Actualizar estado de incidente',
      update_shipping_status: 'Actualizar estatus de Envio',
      eta: 'Entrega estimada',
      at: 'El',
      sure_to_report: ' ¿Estás seguro de que deseas crear un incidente por ',
      requiring_monitoring: 'Requieren monitoreo',
      no_information: 'Sin estado de envío',
      no_pieces: 'Sin productos a enviar',
    },
    shipping_incident: {
      incident: 'incidente',
      status: {
        PENDING: 'Pendiente',
        IN_REVIEW: 'En revisión',
        RESOLVED: 'Resuelto',
        NO_INCIDENT: 'Sin incidente',
      },
      category: {
        CANCELED: 'Cancelación solicitada',
        CANCEL_ATTEMPT: 'Intento de cancelación',
        DELAYED: 'Demora de entrega',
        MISSING_REFERENCES: 'Complementar dirección',
        DAMAGED: 'Producto dañado',
        MISSING_PRODUCT: 'Faltan productos',
        FALSE_DELIVERY: 'Entrega incorrecta',
        CHANGE_ADDRESS: 'Cambiar dirección',
        RESCHEDULE: 'Reprogramar fecha de entrega',
        LOADING_ERROR: 'Pedido con error de carga',
      },
      resolution: {
        STOLEN: ' Pedido robado',
        LOST: ' Pedido extraviado',
        NON_REFUNDABLE_DAMAGED: 'Pedido dañado no reembolsable',
        RETURNED: ' Retornó al almacén',
        REENTERED: 'reentered',
        DELIVERED: ' Pedido entregado',
        REFUNDABLE: ' Reembolsable',
      },
      cant_update: 'Ninguno de los pedidos seleccionados tienen incidentes creados por lo que no hay elementos que actualizar',
      cant_create: {
        order_returned: 'El pedido ya ha sido devuelto',
        order_not_shipped_or_returning: 'El pedido no ha sido enviado o está en proceso de devolución',
        unresolved_same_category_incident: 'El pedido ya tiene un incidente de este tipo sin resolver',
        only_damaged_missing_product_false_delivery_incidents_allowed: 'Sólo se permiten incidentes de tipo dañado, faltan productos o entrega incorrecta',
        only_delayed_canceled_missing_references_incidents_allowed:
          'Sólo se permiten incidentes de tipo demora de entrega, cancelación solicitada o complementar dirección',
        remove_stock_order: 'No se puede crear un incidente para un pedido de stock',
        temporarily_disabled: 'Estamos trabajando en esto, por favor seguir usando el form',
      },
      errors: {
        codes: {
          INVALID_CATEGORY_FOR_ORDER_STATUS: 'La categoría de incidente no es válida para el estado del pedido',
          ORDER_ALREADY_RETURNED: 'El pedido ya ha sido devuelto',
          ORDER_NOT_SHIPPED: 'El pedido no ha sido enviado',
          UNRESOLVED_INCIDENT: 'El pedido ya tiene un incidente de este tipo sin resolver',
          DESCRIPTION_REQUIRED: 'La descripción del incidente es requerida',
          INCIDENT_ALREADY_RESOLVED: 'El incidente ya ha sido resuelto',
          INCOMPATIBLE_ORDER: 'Este tipo de pedido no puede crear incidencias',
          ORDER_HAS_RETURN: 'El Pedido ya ha sido devuelto o regresando.',
          ORDER_HAS_DELIVERY: 'El pedido ya ha sido entregado.',
          NO_INCIDENT_CREATED: 'El pedido no tiene un incidente creado.',
        },
        error_modal: {
          confirmations: {
            CREATE_INCIDENT: '¿Estás seguro de que deseas crear incidentes de tipo {incident_type} para los {order_count} pedidos seleccionados?',
            RESOLVE_INCIDENT: '¿Estás seguro de que deseas resolver incidentes para los {order_count} pedidos seleccionados?',
            UPDATE_STATUS_INCIDENT: '¿Estás seguro de que deseas actualizar estado {status} para los incidentes de {order_count} pedidos seleccionados?',
            UPDATE_SHIPPING_STATUS:
              '¿Estás seguro de que deseas actualizar el estatus de envio {shipping_status} para los {order_count} pedidos seleccionados?',
            omit_errors_and_submit: 'Omitir y aceptar el resto',
            no_valid_elements: 'No hay pedidos válidos para esta acción',
          },
          messages: {
            action_not_possible: 'Para {quantity_errors} de {quantity} pedidos selecionados, no será posible realizar esta acción',
            omit_errors_and_submit_question: '¿Quieres omitir estos pedidos y aceptar el resto de la selección?',
            order_labels_with_errors: 'Guías de los pedidos con errores',
            no_valid_elements_tooltip: 'No es posible realizar esta acción para ninguno de los pedidos seleccionados',
          },
        },
      },
    },

    show_shipping_incidents: {
      from_date: '. El ',
      created_by: {
        RECIPIENT: 'Creado por el comprador final ',
        CUBBO: 'Creado por Cubbo ',
      },
      info_types: {
        important: 'Importante: ',
      },
      toggle_description: {
        hide: 'Ocultar ',
        show: 'Ver ',
      },
      description_title: {
        MISSING_REFERENCES: 'dirección compartida',
        OTHER: 'evidencia compartida',
      },
      categories: {
        DELAYED: 'Incidente: Demora de entrega',
        MISSING_REFERENCES: 'Incidente: Complementar dirección',
        CANCELED: 'Incidente: Cancelar entrega',
        CANCEL_ATTEMPT: 'Incidente: Intento de cancelación',
        DAMAGED: 'Incidente: Producto dañado',
        MISSING_PRODUCT: 'Incidente: Faltan productos',
        FALSE_DELIVERY: 'Incidente: Entrega incorrecta',
        CHANGE_ADDRESS: 'Incidente: Cambiar dirección',
        RESCHEDULE: 'Incidente: Reprogramar fecha de entrega',
      },
      status: {
        PENDING: 'Pendiente',
        IN_REVIEW: 'En revisión',
        RESOLVED: 'Resuelto',
      },

      evidence_type: {
        product_images: 'Fotos a detalle del incidente.',
        label_images: 'Fotos de etiqueta de envío.',
        package_images: 'Fotos del paquete.',
      },
    },
    pod: {
      download: 'Descargar',
      received_by: 'Recibido por',
      title: 'Evidencia de entrega',
      not_provided: 'Esta paquetería no recolecta evidencias en la entrega',
      unavailable: 'No tenemos evidencia de entrega para esta orden',
      proof: 'Comprobante',
      download_success: 'Se ha descargado el comprobante de entrega',
      download_error: 'Ocurrió un error al descargar, por favor inténtalo de nuevo más tarde',
    },
    order_details: {
      title: 'Ver Orden',
      order_number: 'Número de orden',
      tracking_number: 'Número de rastreo',
      status: 'Estado',
      shipping_status: 'Estado de envío',
      creation_date: 'Fecha de creación',
      proof_of_delivery: 'Comprobante de entrega',
      packing_video: 'Video de packing',
      romaneios: 'Manifiesto de salida',
      store: 'Tienda',
      shipping_method: 'Método de envío',
      shipping_information: 'Información de envío',
      name: 'Nombre',
      phone: 'Teléfono',
      email: 'Email',
      address: 'Dirección',
      country: 'País',
      state: 'Estado',
      city: 'Ciudad',
      zip_code: 'CP',
      billing_name: 'Nombre',
      billing_address: 'Dirección',
      billing_country: 'País',
      billing_state: 'Estado',
      billing_city: 'Ciudad',
      billing_zip_code: 'CP',
      billing_information: 'Información de Facturación',
      edit_billing: 'Editar Información',
      picking: 'Picking',
      picker: 'Picker',
      assigned: 'Asignado',
      started: 'Iniciado',
      tote: 'Tote',
      list: 'Lista',
      download: 'Descargar',
      completed: 'Completado',
      packing: 'Packing',
      products: 'Productos',
      quantity: 'Cantidad',
      no_packing_evidence: 'No hay evidencias de packing para esta orden.',
      shipping_incidents: 'Incidentes creados a paquetería',
      partial_shipment: 'Envío Parcial',
      items_removed: 'Artículos removidos del envío',
      upc: 'UPC:',
      sku: 'SKU:',
      kit: 'Kit',
      damaged: 'Dañado',
      downloading: 'Descargando...',
      download_failed: 'No se pudo descargar el video. Intenta de nuevo.',
      mb: 'MB',
      printed_guide: 'Guía Impresa',
    },
    packing_material: {
      BUBBLE_WRAP: 'Plástico burbuja',
      KRAFT_PAPER: 'Papel Kraft',
      CORN_EXTRUDATE: 'Extruido de maíz',
      KRAFT_PAPER_AND_BUBBLE_WRAP: 'Papel Kraft + Plástico burbuja',
    },
  },

  cubbo_lastmile_events: {
    order_events: 'Historial',
    created_email: 'Por {{user_email}}',
    created_email_xdock: 'Por {{user_email}} en {{xdock_name}}',
    no_events: 'No existen eventos disponibles',
    errors: 'Conflicto registrado: {{error_codes}}',
    is_collapsed: 'Ver todo',
    is_not_collapsed: 'Contraer',
    event_types: {
      CREATED_LABEL: 'Guía generada',
      ASSIGN_ROUTE: 'Ruta asignada',
      RECEIVED_AT_XDOCK: 'Recibido en Xdock',
      CREATED_DELIVERY_ROUTE: 'Ruta de entrega generada',
      GROUPING_PACKAGES: 'Empacando guía',
      GROUPED_PACKAGES: 'Guía empacada',
      DISPATCHED_TO_MIDDLE_MILE: 'Despachado a Middle Mile',
      MIDDLE_MILE_IN_TRANSIT: 'En transito por Middle Mile',
      DISPATCHED_FOR_DELIVERY: 'Despachado a driver',
      IN_DELIVERY: 'En ruta de entrega',
      DELIVERED: 'Entregado',
      SHIPPING_INCIDENT: 'Incidente',
      FAILED_DELIVERY_ATTEMPT: 'Intento de entrega fallido',
      RESCHEDULED_DELIVERY: 'Entrega reprogramada',
      CANCELLED: 'Cancelado',
      RETURNING: 'Retornando',
      DISPATCHED_TO_XDOCK: 'Despachado a Xdock',
      RETURNED: 'Retornado',
      LOST: 'Paquete reportado como perdido',
      DAMAGED: 'Paquete reportado como dañado',
      STOLEN: 'Paquete reportado como robado',
      SHIPPING_INCIDENT_DELAYED: 'Incidente: Demora de entrega',
      SHIPPING_INCIDENT_MISSING_REFERENCES: 'Incidente: Complementar dirección',
      SHIPPING_INCIDENT_MISSING_PRODUCT: 'Incidente: Faltan productos',
      SHIPPING_INCIDENT_FALSE_DELIVERY: 'Incidente: Entrega incorrecta',
      SHIPPING_INCIDENT_CHANGE_ADDRESS: 'Incidente: Cambiar dirección',
      DISPATCHED_TO_WAREHOUSE: 'Despachado a almacén de origen ',
      INVALID_LABEL: 'Guía inválidada',
      PACKAGING_LABEL: 'Empacando guía',
      UNPACKED_LABEL: 'Guía desempacada',
      PACKED_LABEL: 'Guía empacada',
      ARRIVED_AT_PICKUP_POINT: 'Llegó a punto de recolección',
      COLLECTED_BY_CUSTOMER: 'Recolectado por el cliente',
    },
    error_codes: {
      LABEL_NOT_FOUND: 'Guía no encontrada',
      LABEL_WRONG_CARRIER: 'Paquetería incorrecta',
      LABEL_INVALID_STATUS: 'Guía con status incorrecto',
      WRONG_OPERATION: 'Operación incorrecta',
      WRONG_ROUTE: 'Ruta incorrecta',
      NO_ROUTE: 'Sin ruta',
      CANCELLED: 'Pedido cancelado',
      PROCESS_REVERSE_LOGISTICS: 'Procesando logística inversa',
      REPROGRAMMED: 'Entrega reprogramada',
      WRONG_STATUS: 'Status incorrecto',
      INCIDENT_LOST: 'Incidente: Extravío',
      INCIDENT_DAMAGED: 'Incidente: Dañado',
      INCIDENT_STOLEN: 'Incidente: Robado',
      LABEL_NOT_RECEIVED: 'Guía no fue recibida en Xdock',
    },
  },

  returns: {
    proof_videos: {
      title: 'Video de la recepción',
      loading: 'Cargando video...',
      empty: 'No hay video grabado para esta devolución.',
      error: 'No fue posible cargar el video ahora.',
      recorded_at: 'Grabado el {{date}} · {{size}} MB',
      download: 'Descargar',
      watch: 'Ver',
      hide: 'Ocultar',
      processing: 'El video se está enviando. Aparecerá aquí en unos momentos.',
      refresh_error: 'No fue posible actualizar los enlaces de los videos. Intenta de nuevo en unos momentos.',
      unavailable: 'Este video ya no está disponible.',
      playback_failed: 'No fue posible reproducir este video en el navegador. Usa Descargar.',
    },
    lot_label: 'Lote',
    unidentified: 'No identificado',
    errors: {
      cubbito_wrong_warehouse: 'Esta devolución va a {{warehouse_code}}: apártala para traslado.',
      not_belong_to_warehouse:
        "El retorno de la order #{{order_number}} pertenece al almacén '{{warehouse_name}}', !SEPARALO¡ para procesarlo en el almacén correcto.",
      return_not_found: 'El retorno del pedido #{{order_number}} necesita ser escaneado por la ZEBRA antes de empezar el BOT-BOV.',
      order_not_found: 'El pedido #{{order_number}} no fue encontrado.',
      received_more_products_than_expected:
        'No es posible recibir más productos de los enviados, se esperan recibir {{quantity}} piezas del producto con upc: {{upc}}',
      unidentified_returns_disabled: 'Pedido no encontrado. La recepción de devoluciones no identificadas no está habilitada en este almacén.',
      warehouse_config_unavailable:
        'Pedido no encontrado. No se pudo leer la configuración de este almacén, así que no es posible verificar si acepta devoluciones no identificadas. Vuelve a intentarlo; si el mensaje persiste, recarga la página y reporta a soporte.',
      error_codes: {
        no_approved_sale_invoice:
          'No hay nota fiscal de venta aprobada para este pedido, por lo que no es posible emitir la nota de devolución. Contacta al equipo fiscal.',
        no_products: 'No se informó ningún producto para la recepción de la devolución.',
        all_missing_not_confirmed:
          'Todos los productos están marcados como faltantes y no se confirmó el cierre sin éxito. Recarga la página y guarda de nuevo para ver la confirmación.',
        certificate_invalid: 'El certificado fiscal de la tienda es inválido o está vencido. Contacta al equipo fiscal.',
        no_icms_rate:
          'Esta devolución contiene ítem(s) sin alícuota de ICMS registrada, por lo que no es posible emitir la nota de devolución. Contacta al equipo fiscal.',
        estorno_missing_subtotal: 'Falta el subtotal del producto para calcular el estorno de crédito (CFOP de pérdida de stock). Contacta al equipo fiscal.',
        product_invalid_price: 'Hay un ítem con precio unitario inválido (menor o igual a cero). Corrige el registro del producto.',
        fiscal_rejection: 'La nota fiscal de devolución fue rechazada por la SEFAZ:',
        invoice_generation_failed: 'Falló la generación de la nota fiscal de devolución. Inténtalo de nuevo; si el error persiste, contacta a soporte.',
        transient_retry: 'Error temporal del sistema. Espera unos instantes e inténtalo de nuevo.',
        unidentified_not_enabled: 'La recepción de devoluciones no identificadas no está habilitada en este almacén.',
        unidentified_require_webmania: 'Las devoluciones no identificadas requieren facturación Webmania para tiendas brasileñas. Contacta al equipo fiscal.',
        unidentified_require_replenishment_invoices:
          'Las devoluciones no identificadas requieren notas fiscales de reposición habilitadas para la tienda. Contacta al equipo fiscal.',
      },
    },
    return_types: {
      unknown: 'Desconocido',
      simple_return: 'Devolución',
      exchange: 'Cambio',
      immediate_exchange: 'Cambio inmediato',
      returned_by_carrier: 'Paquetería',
      unidentified: 'No identificado',
    },
    return_new_order_labels: {
      SIMPLE_RETURN: 'No Aplica',
      EXCHANGE: 'Esperando retorno',
      RETURNED_BY_CARRIER: 'Llegó al almacén',
      UNIDENTIFIED: 'No Aplica',
    },
    receive_return: {
      all_sealed_question: '¿Todos los productos están sellados?',
      all_sealed_yes: 'Sí',
      all_sealed_no: 'No',
      inspection_modal_title: 'Separa el pedido para inspección',
      inspection_modal_description: 'El pedido fue marcado como pendiente de inspección. Sepáralo físicamente para inspección.',
      inspection_modal_confirm: 'Entendido',
      confirm_receipt_title: 'Confirmar Recepción de Retorno',
      confirm_receipt_description: 'Confirma que retornaron un total de {{count}} producto{{plural}}.',
      missing_products_header: 'Los siguientes productos se esperaban pero no se recibieron y se marcarán como faltantes:',
      all_missing_title: '¿No llegó nada en esta devolución?',
      all_missing_description:
        'Todos los productos esperados están marcados como faltantes. Al confirmar, la devolución se cerrará sin éxito, sin recibo, y las unidades de abajo se registrarán como pérdida.',
      all_missing_products_header: 'Se registrarán como pérdida:',
      all_missing_quantity: 'Cantidad: {{quantity}}',
      all_missing_irreversible: 'Esta acción no se puede deshacer.',
      all_missing_confirm: 'Confirmar que no llegó nada',
      resolve_scanned_products_first: 'Antes de guardar, marca cada producto escaneado como recibido, dañado o faltante.',
      nothing_booked_to_save: 'Escanea o busca al menos un producto y márcalo como recibido, dañado o faltante antes de guardar.',
      expected: 'Esperadas',
      received: 'Recibidas',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      save: 'Guardar',
      return_label_title: 'Guía de retorno',
      no_products_found: 'No se encontraron productos',
      product_not_in_order: 'Este producto no pertenece al pedido',
      no_upc: 'Sin UPC',
      search_lot_placeholder: 'Buscar lote',
      product_marked_damaged: 'El producto está marcado como dañado en el retorno',
      view_order: 'Ver Orden',
      page_title_receive_by_courier: 'Recibir Retorno Por Paquetería',
      page_title_receive_order: 'Recibir Orden En Devolución',
      damaged_pieces: '(Piezas Dañadas)',
      no_lot_required: 'No requiere lote',
      await_inspection_failed: 'No se pudo enviar el retorno a inspección. Inténtalo de nuevo.',
      scan_unit_code_placeholder: 'Escanea el código único',
      select_unit_code_first: 'Selecciona el código único de la unidad antes de recibirla.',
      unit_code_not_for_product: 'Este código único no pertenece a este producto.',
      unit_code_already_used: 'Este código único ya fue seleccionado.',
      receive: 'Recibir',
      remove_product: 'Quitar producto',
      lot_tooltip: 'Si no encuentras el lote del producto puedes crear uno.',
      create_new_lot: 'Crear un nuevo lote',
      select_lot_first: 'Para poder recibir éste producto,<br/>primero debes seleccionar <strong>a qué<br/>lote pertenece</strong>.',
      damaged: 'Dañado',
      missing: 'Faltante',
      returned_undamaged_pieces: 'Piezas retornadas sin daños',
      returned_damaged_pieces: 'Piezas retornadas con daños',
      missing_pieces: 'Piezas faltantes',
      returns_breadcrumb: 'Retornos →',
    },
  },

  generic: {
    order: 'Pedido',
    orders: 'Pedidos',
    error: 'Error',
    store: 'Tienda',
    warehouse: 'Almacén',
    country: 'País',
    status: 'Estado',
    from: 'Desde',
    to: 'Hasta',
    usages: 'Usos',
    billing_statements: 'Cortes',
    empty_table: 'No hay elementos para mostrar',
    undefined: 'No definido',
    active: 'Activo',
    pending: 'Pendiente',
    disabled: 'Desactivado',
    not_having_current_billing_configuration: 'No configurados',
    having_current_billing_configuration: 'Configurados',
    store: 'Tienda',
    stores: 'Tiendas',
    store_name: 'Nombre de la tienda',
    cancel: 'Cancelar',
    completed: 'Completado',
    close: 'Cerrar',
  },

  access_denied: 'Lo sentimos, no tienes permisos para acceder a esta página',

  filter: {
    button: 'Filtrar',
    reset: 'Limpiar filtros',
    apply: 'Aplicar filtros',
    select: 'Selecciona un estado',
    from_to: 'de-hasta',
    export: 'Exportar',
    in: 'en',
  },

  dialog: {
    yes: 'Si',
    no: 'No',
  },

  statuses: {
    order_statuses: {
      unknown: 'Sin status',
      initial: 'Sincronizando',
      empty: 'Pedido vacío',
      pending: 'Pendiente',
      processing: 'Procesando',
      shipped: 'Enviado',
      returning: 'Retornando a Cubbo',
      returned: 'Recibiendo retorno',
      canceled: 'Cancelado',
      error: 'Falta Información',
      entirely_dropshipping: 'Fulfilleado Externamente',
      backorder: 'Sin Stock',
      unpaid: 'Sin pagar',
      cancelation_window: 'En Ventana de Cancelación',
      hold: 'En pausa',
      interrupted: 'Interrumpido',
      waiting_pick_up: 'Esperando recolección',
      awaiting_pick_up: 'Pendiente de recolectar',
      picked_up: 'Recolectado',
      in_warehouse: 'Recibido en almacén',
      return_arrived: 'Retornó a Cubbo',
      reentered: 'Retorno reingresado',
      delayed: 'Demorado',
      picking: 'En picking',
      packing: 'En packing',
    },
    tracking_statuses: {
      unknown: 'Sin status',
      in_transit: 'En tránsito',
      shipment_in_transit: 'En tránsito',
      shipment_delivered: 'Entregado',
      shipment_with_incident: 'Incidente',
      shipment_canceled: 'Entrega Cancelada',
      shipment_to_be_self_collected: 'Recolectar en oficina',
      shipment_out_for_delivery: 'En ruta de entrega',
      shipment_with_incident_lost: 'Incidente: Extravío',
      shipment_with_incident_stolen: 'Incidente: Robado',
      shipment_with_incident_damaged: 'Incidente: Dañado',
      delayed: 'Demorado',
      shipment_returned: 'Retornado por paquetería',
      shipment_with_incident_missing_references: 'Incidente: Dirección incorrecta',
      shipment_with_incident_refused_package: 'Incidente: Paquete rechazado',
      shipment_with_incident_client_requested: 'Incidente: Entrega Cancelada por Natura',
      shipment_with_incident_carrier_requested: 'Incidente: Duplicidad',
    },
    tracking_descriptions: {
      second_try: 'Segundo intento',
      third_try: 'Tercer intento',
      client_requested: 'Solicitud del comprador',
      missing_references: 'Faltan referencias',
      not_at_home: 'El comprador estaba ausente',
      refused_payment: 'El comprador se rehusó a pagar',
      refused_package: 'El comprador rechazó el paquete',
      cubbo_requested: 'Solicitud de Cubbo',
      carrier_requested: 'Por paquetería',
      stolen: 'Robo',
      lost: 'Pérdida',
      damaged: 'Dañado',
      delivery_failed: 'Entrega fallida',
      returned_by_carrier: 'Por entrega no exitosa',
      returned_by_client: 'Por devolución solicitada',
      in_return: 'En retorno por paquetería',
    },
    returns_statuses: {
      unknow: 'Sin status',
      requested: 'Esperando retorno',
      pending: 'Decisión Pendiente',
      cancelled: 'Reenvío Cancelado',
      ordered: 'Reenvío ordernado',
      received: 'Recibiendo retorno',
      arrived_at_warehouse: 'Llegó al almacén',
      awaiting_inspection: 'Esperando inspección',
      reentered: 'Retorno reingresado',
    },
  },
  billing: {
    copy_config_filter: 'Selecciona la tienda de la que deseas duplicar la configuración',
    copy_config_duplicate: 'Escribe el nombre de la tienda de la que deseas duplicar la configuración',
    copy_config_results: 'Se muestran los primeros 5 resultados, refina tu búsqueda para encontrar la tienda que deseas',
    copy_config: 'Copiar configuración de otra tienda',
    create_error_title: 'Ocurrió un error, inténtalo más tarde',
    create_invalid_content_error_title: 'Completa la información requerida y/o corrígela para poder crear la configuración de cobro',
    from_prefix: 'Más de ',
    title: 'Cobranza',
    continue: 'Continuar',
    save: 'Terminar y guardar configuración',
    create: 'Crear configuración',
    disable: 'Desactivar',
    duplicate: 'Duplicar',
    disable_title: 'Desactivar billing al corte',
    already_disabled: 'Billing ya ha sido desactivado',
    billing_configurations_history: 'Historial de configuraciones de cobro',
    billing_custom_services: 'Cobros/Descuentos adicionales',
    statements_section_title: 'Historial de cortes',
    statements_empty: 'No hay cortes disponibles',
    view_statement_history: 'Ver historial',
    disable_billing_for_store_success: 'Se desactivará la configuración de cobro en el próximo corte',
    status: {
      ACTIVE: 'Activo',
      DISABLED: 'Desactivado',
      UNREQUIRED: 'No requerido',
      PENDING: 'Pendiente',
    },
    stores: {
      start_date: 'Inicio de vigencia',
      end_date: 'Siguiente corte',
      empty: 'No hay Tiendas que mostrar.',
      about: 'Sobre la tienda',
      no_data: 'Sin información',
      configure: 'Configurar tarifas de cobro',
      next_cutoff_at: 'Fecha de corte',
      due_next_week: 'Vence la próxima semana',
      download_preview: 'Descargar previsualización de Billing del mes actual',
      export_generating: 'Generando archivo...',
      export_completed: 'Archivo generado',
      export_description: 'Se generará un archivo con la previsualización de Billing del mes actual para este almacén',
      export_success_message: 'El archivo se ha generado exitosamente',
      export_already_in_progress: 'Ya hay una exportación en progreso para este almacén',
      export_error: 'Error al generar el archivo',
      export_progress_error: 'Error al obtener el progreso',
      missing_channel_tech_fee: 'Tech Fee sin configurar por canal',
      missing_channel_tech_fee_select_channel: 'Selecciona canal',
    },
    channels: {
      manual: 'Manual',
      unidentified: 'No identificado',
    },
    save_dialog: {
      title: 'Crear configuración de cobro',
      description: 'Confirma la creación de la configuración de cobro',
      confirm_button: 'Confirmar',
      cancel_button: 'Cancelar',
    },
    discard_channel_prices_dialog: {
      title: 'Se eliminarán los precios por canal',
      description:
        'La configuración actual tiene precios de Tech Fee por canal y la nueva no los incluye. Si continúas, todos los canales se cobrarán con el precio general.',
      confirm_button: 'Eliminar y guardar',
      cancel_button: 'Cancelar',
    },
    confirm_disable_dialog: {
      title: 'Desactivar en el próximo corte',
      description: 'Confirma la desactivación de la configuración de cobro en el próximo corte',
      confirm: 'Confirmar',
      cancel: 'Cancelar',
    },
    confirm_delete_dialog: {
      title: 'Eliminar configuración de cobro',
      description: '¿Estás seguro de que deseas eliminar esta configuración de cobro? Esta acción no se puede deshacer.',
      confirm: 'Eliminar',
      cancel: 'Cancelar',
    },
    delete_config: {
      button: 'Eliminar',
      success_message: 'Configuración de cobro eliminada exitosamente',
      error_has_usages:
        'No se puede eliminar esta configuración porque tiene cobros asociados a cortes. Recalcula el corte con una configuración diferente primero.',
      error_replacement_in_progress: 'No se puede eliminar la configuración mientras hay un reemplazo en progreso para esta tienda',
      error_operation_in_progress: 'Ya hay otra operación de configuración en progreso para esta tienda',
      error_generic: 'Ocurrió un error al eliminar la configuración',
    },
    confirm_exit_dialog: {
      title: 'Se descartarán los cambios ¿Deseas continuar?',
    },
    replace_config: {
      title: 'Sustituir configuración actual',
      description: 'Seleccione una configuración futura para reemplazar la configuración actual',
      warning: 'Esta acción eliminará todas las configuraciones futuras.',
      select_future_config: 'Seleccionar configuración futura',
      no_future_configs: 'No hay configuraciones futuras disponibles',
      confirm: 'Confirmar sustitución',
      replacing: 'Sustituyendo configuración...',
      completed: 'Sustitución completada',
      success_message: 'La configuración ha sido sustituida exitosamente',
      already_in_progress: 'Ya hay una sustitución en progreso para esta tienda',
      error: 'Error al sustituir la configuración',
      progress_error: 'Error al obtener el progreso',
      stages: {
        validation: 'Validando configuración...',
        config_validation: 'Validación completada',
        database_operations: 'Ejecutando operaciones de base de datos...',
        rake_task: 'Ejecutando tareas del sistema...',
        completing: 'Finalizando...',
      },
    },
    recalculate_statement: {
      title: 'Recalcular corte',
      description: 'Seleccione un corte y una configuración de cobro para recalcular',
      warning: 'Esta acción recalculará todos los cobros del corte seleccionado con la configuración elegida. Los cobros actuales serán reemplazados.',
      select_statement: 'Seleccionar corte',
      no_statements: 'No hay cortes disponibles',
      select_config: 'Seleccionar configuración de cobro',
      custom_services_title: 'Ajustes al corte',
      custom_services_description: 'Revise los cobros/descuentos existentes y opcionalmente agregue nuevos que se aplicarán durante el recálculo',
      existing_section_title: 'Cobros/descuentos existentes',
      new_section_title: 'Agregar nuevo cobro/descuento',
      add_new_toggle: '+ Agregar cobro/descuento',
      add_custom_service: 'Agregar',
      is_discount: 'Es descuento',
      title_label: 'Título',
      description_label: 'Descripción',
      amount_label: 'Monto',
      send_email: 'Enviar notificación por email al finalizar',
      send_email_warning: 'Al activar esta opción, se reenviará el correo del corte a la tienda con los nuevos montos',
      pending_overrides: 'Nuevos cobros/descuentos a agregar',
      original_value: 'Original',
      reset_field: 'Restaurar valor original',
      type_charge: 'Cargo',
      type_discount: 'Descuento',
      confirm: 'Recalcular',
      next: 'Siguiente',
      back: 'Atrás',
      recalculating: 'Recalculando corte...',
      completed: 'Recálculo completado',
      success_message: 'El corte ha sido recalculado exitosamente',
      result_summary: 'Resumen de cambios',
      result_total: 'Total sin impuestos',
      result_credit: 'Créditos',
      result_tax: 'Impuestos',
      result_no_changes: 'Los totales del corte no cambiaron con esta configuración',
      already_in_progress: 'Ya hay un recálculo en progreso para este corte',
      error: 'Error al recalcular el corte',
      progress_error: 'Error al obtener el progreso',
      timeout_error: 'El recálculo está tardando demasiado. Por favor, verifique el estado del corte e intente nuevamente si es necesario.',
      statement_cutoff: 'Corte',
      statement_total: 'Total sin impuestos',
      statement_tax: 'Impuestos',
      statement_credits: 'Créditos/descuentos',
      statement_pay_before: 'Pago antes de',
      statement_created_at: 'Generado',
      statement_status_GENERATED: 'Generado',
      statement_status_FILES_READY: 'Archivos listos',
      statement_status_NOTIFIED: 'Notificado',
      statement_status_NOT_NOTIFIED: 'No notificado',
      statement_status_BILLED: 'Facturado',
      existing_services_title: 'Cobros/descuentos existentes del corte',
      existing_services_loading: 'Cargando servicios existentes...',
      existing_services_empty: 'No hay cobros/descuentos personalizados en este corte',
      existing_services_error: 'Error al cargar los servicios existentes',
      edit_action: 'Editar',
      remove_action: 'Eliminar',
      save_edit_action: 'Guardar',
      cancel_edit_action: 'Cancelar',
      marked_for_removal: 'Marcado para eliminar',
      undo_action: 'Deshacer',
      edited_label: 'Editado',
      stages: {
        validation: 'Validando configuración...',
        processing: 'Recalculando cobros...',
        completing: 'Finalizando...',
      },
    },
    configuration_history: {
      title: 'Historial de cambios',
      event: 'Evento',
      details: 'Detalles',
      config_statement: 'Config / Corte',
      user: 'Usuario',
      date: 'Fecha',
      system_user: 'Sistema',
      no_history: 'No hay historial de cambios disponible',
      refresh: 'Actualizar',
      event_CONFIGURATION_CREATED: 'Configuración creada',
      event_CONFIGURATION_REPLACED: 'Configuración reemplazada',
      event_CONFIGURATION_DELETED: 'Configuración eliminada',
      event_CONFIGURATION_DISABLED: 'Configuración desactivada',
      event_STATEMENT_GENERATED: 'Corte generado',
      event_STATEMENT_RECALCULATED: 'Corte recalculado',
      event_CUSTOM_SERVICE_ADDED: 'Cobro/descuento agregado',
      event_CUSTOM_SERVICE_EDITED: 'Cobro/descuento editado',
      event_CUSTOM_SERVICE_REMOVED: 'Cobro/descuento eliminado',
      config_id: 'Config',
      from_config: 'Config anterior',
      to_config: 'Config nueva',
      valid_from: 'Vigente desde',
      valid_to: 'Vigente hasta',
      scenario: 'Escenario',
      scenario_standard_replacement: 'Reemplazo estándar',
      scenario_current_cutoff_no_billed_usages: 'Sin cobros en periodo actual — eliminada',
      scenario_current_cutoff_preserved_for_analysis: 'Con cobros en periodo actual — preservada',
      service_title: 'Título',
      amount: 'Monto',
      description: 'Descripción',
      source: 'Origen',
      source_standalone: 'Creación directa',
      source_recalculation: 'Durante recálculo',
      statement_id: 'Corte',
      services_count: 'Servicios creados',
      previous_config: 'Config previa',
      reason: 'Razón',
      reason_manual_deletion: 'Eliminación manual',
      reason_replaced_during_current_cutoff: 'Reemplazada durante periodo actual',
      reason_unused_future_configuration_cleanup: 'Limpieza de config futura no utilizada',
      deleted_config: 'Config eliminada',
      restored_valid_to: 'Vigencia restaurada a',
      replaced_by_config: 'Reemplazada por config',
      deleted_during_replacement: 'Eliminada durante reemplazo de config',
      future_configs_deleted: 'Configs futuras eliminadas',
      none: 'Ninguna',
      usages_count: 'Cobros incluidos',
      cutoff_date: 'Fecha de corte',
      total_before: 'Total antes',
      total_after: 'Total después',
      credit_before: 'Crédito antes',
      credit_after: 'Crédito después',
      tax_before: 'Impuesto antes',
      tax_after: 'Impuesto después',
      overrides_applied: 'Ajustes aplicados',
      service_id: 'Servicio ID',
    },
    tabTitles: {
      billing_date: 'Fecha de facturación',
      storage: 'Almacenamiento',
      pick_and_pack: 'Pick and Pack',
      shipping_label: 'Envíos nacionales',
      international_shipping_label: 'Envíos internacionales',
      replenishment: 'Recibo de inventario',
      returns: 'Retornos',
      work_orders: 'Maquilas',
      difal: 'Difal',
      shipping_insurance: 'Garantía Cubbo',
      packing_material: 'Materiales de empaque',
      tech_fee: 'Tech Fee',
      natura_shipping_label: 'Natura - Guía de Envío',
      natura_additional_label: 'Natura - Guía Adicional',
      natura_pick_and_pack: 'Natura - Pick and Pack',
    },
    ongoing: 'En curso',
    billed: 'Anterior',
    future: 'Futura',
    duplicate_configuration: 'Duplicar configuración de cobro',
    show_configuration: 'Ver configuración de cobro',
    store_billing_config: {
      cutoff_interval: {
        title: 'Frecuencia del corte',
        options: {
          YEAR: 'Anual',
          MONTH: 'Mensual',
          WEEK: 'Semanal',
        },
      },
    },
    range_billing_price_config_table: {
      errors: {
        MISSING_FROM_VALUE: 'Ingresa un valor',
        MISSING_TO_VALUE: 'Ingresa un valor',
        MISSING_PRICE_VALUE: 'Ingresa un precio',
        MISSING_UNIT_VALUE: 'Selecciona una unidad',
        FROM_IS_GREATER_THAN_TO: "'Desde' debe ser menor que 'Hasta'",
        FROM_AND_TO_ARE_EQUAL: "'Desde' debe ser menor que 'Hasta'",
        EXCESS_IS_ONLY_ALLOWED_AT_END: "'Exceso' solo puede ser el último elemento",
        MISSING_PRICE_MODE: '',
        INVALID_UNIT_VALUE: 'Selecciona una unidad',
      },
      unit_options: {
        PER_UNIT: 'Cargo por pieza',
        TOTAL: 'Cargo por total',
        EXCESS_PER_UNIT: 'Cargo extra por pieza excedida',
        EXCESS_TOTAL: 'Cargo extra fijo por exceso',
      },
      last_row_placeholder: 'Sin límite',
    },
    table_headers: {
      from_piece: 'Desde pieza',
      to_piece: 'Hasta pieza',
      from_weight: 'Desde kg',
      to_weight: 'Hasta kg',
      price: 'Precio',
      percentage: 'Porcentaje',
      unit: 'Unidad del cargo',
      package: 'Paquete',
      packing_material: 'Material de empaque',
      location_type: 'Tipo de ubicación',
      tariff: 'Tarifa por ubicación',
      NORTH_AMERICA: 'Precio Norte América',
      LATIN_AMERICA: 'Precio América Latina',
      CARIBBEAN: 'Precio Caribe',
      EUROPE: 'Precio Europa',
      ASIA: 'Precio Asia',
      AFRICA: 'Precio África',
    },
    pick_and_pack_services: {
      picking_title: 'Picking',
      insert_title: 'Por injerto añadido',
      serial_number_title: 'Control de salida por número de serie',
      fragile_title: 'Embalaje de paquete frágil',
      packages_title: 'Empaques',
      package_title: {
        parcel_bag: 'Bolsa de paquetería',
        jiffy_envelope: 'Sobre Jiffy',
        cubbo_box: 'Caja Cubbo',
        customer_box: 'Caja cliente',
      },
      picking_unit_options: {
        PER_UNIT: 'Cargo por pieza',
        TOTAL: 'Cargo por pedido',
        EXCESS_PER_UNIT: 'Cargo extra por pieza excedida',
        EXCESS_TOTAL: 'Cargo extra fijo por exceso',
      },
      package_unit_options: {
        TOTAL: 'Cargo por paquete',
      },
      fragile_picking_unit_options: {
        TOTAL: 'Cargo por paquete',
      },
    },
    billing_storage_table: {
      STORAGE_BY_LOCATION: 'Cargo por ubicación',
      STORAGE_BY_PRODUCT: 'Cargo por pieza almacenada',
      missing_picking_standard_error: 'ERROR: Ubicación PICKING STANDARD inexistente',
      category_codes: {
        PICKING_STANDARD: 'Regular',
        LOST: 'Lost',
        DAMAGED: 'Dañados',
        PALLET: 'Pallet',
        RECEPTION: 'Recepción',
        PRESALE: 'Preventa',
        RELOCATION: 'Reubicación',
        OFF_PREMISES: 'Off premises',
        PICKING_MINIBIN: 'Picking minibin',
        PULMAO: 'Pulmão',
        CURVA_A: 'Curva A',
        ESTANTE: 'Estante',
        FLOW_RACK: 'Flow rack',
        CESTO: 'Cesto',
        PRATELEIRA_LONGARINA: 'Prateleira longarina',
        CAIXOTE_GDG: 'Caixote GDG',
        PRATELEIRA_NATURA: 'Prateleira',
        PORTA_PALLET: 'Porta-palete',
        MINI_CAIXOTE: 'Mini-caixote',
        PRATELEIRA_G: 'Prateleira grande',
        PRATELEIRA_M: 'Prateleira média',
        PRATELEIRA_P: 'Prateleira pequena',
        CAIXA_PLASTICA: 'Caixa plástica',
        CAIXA_BIN: 'Caixa bin',
        MINI_RACK: 'Mini rack',
      },
      calculated_tariff_tooltip: 'Monto calculado con base en el precio definido de la ubicación regular',
      tariff_error_message: 'Ingresa la tarifa',
      units: 'ubicación/mes',
    },
    billing_stroage_table_by_unit: {
      unit_options: {
        PER_UNIT: 'Cargo por pieza almacenada',
      },
    },
    replenishment_services: {
      replenishment_title: 'Recibo de piezas regulares',
      replenishment_lots_title: 'Recibo de piezas con control de lote',
      unit_options: {
        PER_UNIT: 'Cargo por pieza recibida',
        TOTAL: 'Cargo por recibo',
        EXCESS_PER_UNIT: 'Cargo extra por pieza excedida',
        EXCESS_TOTAL: 'Cargo extra fijo por exceso',
      },
    },
    minimum_fee_services: {
      minimum_fee_title: 'Facturación mínima',
      amount_label: 'Monto mínimo mensual',
      add: 'Agregar facturación mínima',
      remove: 'Quitar facturación mínima',
      helper: 'Si la facturación del mes de la tienda queda por debajo de este monto, la tienda paga la diferencia.',
      errors: {
        INVALID_AMOUNT: 'Ingresa un monto mayor a 0',
      },
    },
    difal_services: {
      difal_title: 'Difal',
      unit_options: {
        TOTAL: 'Cargo por pedido',
      },
    },
    shipping_insurance_services: {
      shipping_insurance_title: 'Garantía Cubbo',
      unit_options: {
        TOTAL: 'Cargo por pedido',
      },
    },
    packing_material_services: {
      packing_material_title: 'Materiales de empaque',
      packing_material_codes: {
        BUBBLE_WRAP: 'Plástico burbuja',
        CORN_EXTRUDATE: 'Extruido de maíz',
        KRAFT_PAPER: 'Papel Kraft',
        KRAFT_PAPER_AND_BUBBLE_WRAP: 'Papel Kraft + Plástico burbuja',
      },
      unit_options: {
        TOTAL: 'Cargo por paquete',
      },
    },
    return_services: {
      return_order_title: 'Recibo de piezas regulares',
      return_order_lots_title: 'Recibo de piezas con control de lote',
      return_shipping_label_title: 'Guías de retorno',
      unit_options: {
        PER_UNIT: 'Cargo por pieza recibida',
        TOTAL: 'Cargo por recibo',
        EXCESS_PER_UNIT: 'Cargo extra por pieza excedida',
        EXCESS_TOTAL: 'Cargo extra fijo por exceso',
      },
      return_label_unit_options: {
        TOTAL: 'Cargo por guía',
        EXCESS_PER_UNIT: 'Cargo extra por kilo excedido',
      },
    },
    shipping_method_prices: {
      extended_zone_row: 'zona extendida',
      import_extended_zone_filled: '{{count}} zonas extendidas completadas.',
      import_shipping_method_note:
        'Toda zona del archivo pasó a tener precio propio de esta paquetería. Para mantener una zona en el precio estándar, usa "Usar precio estándar" en ella o borra la columna antes de importar.',
      excess_row: 'kg adicional',
      import_error_unordered_weight_ranges:
        'Los rangos de peso del archivo están fuera de orden en la línea {{row}}: cada rango debe terminar después del anterior.',
      import_csv: 'Importar CSV',
      download_template: 'Exportar tabla actual (CSV)',
      import_filled: '{{count}} zonas completadas en esta pestaña. Revisa y guarda la configuración para aplicar.',
      import_not_covered: 'Zonas ignoradas, no forman parte de esta pestaña: {{zones}}',
      import_invalid: 'Zonas ignoradas, con precio vacío, inválido o ambiguo (para $1,200, escribe 1200 o 1,200.00): {{zones}}',
      import_invalid_extended_zone: 'Zona extendida no importada en estas zonas, con precio inválido o ambiguo (queda el valor anterior): {{zones}}',
      import_ignored_columns: 'Columnas ignoradas, no son zonas: {{columns}}',
      import_error_no_zone_columns: 'Ninguna columna del archivo es una zona. Usa la plantilla: Weight min, Weight max, ...',
      import_error_no_weight_ranges: 'El archivo no tiene ningún rango de peso.',
      import_error_unreadable_weight_row:
        'El peso de la línea {{row}} no es un número: corrige el rango (ej.: 0.5) para no juntar los precios con el rango siguiente.',
      default_tab: 'Estándar',
      not_added_notice: 'Las zonas no agregadas en esta paquetería usan el precio estándar.',
      remove_confirm: 'Se quitarán todos los precios de esta paquetería y las zonas volverán a usar el precio estándar.',
      cancel: 'Cancelar',
      select_shipping_method: 'Selecciona una paquetería',
      add: 'Agregar precio por paquetería',
      remove: 'Quitar precios de la paquetería',
      use_default: 'Usar precio estándar',
      set_price: 'Definir precio',
      no_longer_covered: 'la paquetería ya no cubre esta zona',
      uses_default: 'Usa el precio estándar',
      loading: 'Cargando paqueterías...',
      load_error: 'No fue posible cargar las paqueterías del almacén.',
    },
    tech_fee_services: {
      order_tech_fee_title: 'Tech Fee por pedido',
      return_tech_fee_title: 'Tech Fee por retorno',
      order_unit_options: {
        TOTAL: 'Cargo por pedido',
      },
      return_unit_options: {
        TOTAL: 'Cargo por retorno',
      },
      channel_prices: {
        title: 'Precios por canal de venta (opcional)',
        description: 'Los canales sin precio propio se cobran con el precio general de arriba.',
        headers: {
          channel: 'Canal de venta',
          business_type: 'Tipo de negocio',
          price: 'Precio',
        },
        select_channel: 'Selecciona un canal',
        select_business_type: 'Selecciona un tipo',
        add_channel: '+ Agregar canal',
        loading_channels: 'Cargando canales...',
        load_error: 'No se pudieron cargar los canales de venta. Recarga la página para configurar precios por canal.',
        mixed_store_hint: 'Esta tienda vende D2C y B2B, así que cada canal necesita su precio para los dos.',
        business_types: {
          d2c: 'D2C',
          b2b: 'B2B',
          not_applicable: 'No aplica',
        },
        errors: {
          channel_required: 'Selecciona un canal',
          price_required: 'Captura un precio',
          duplicated_row: 'Ya hay una fila para este canal y tipo de negocio',
          channel_unavailable: 'Este canal no está disponible para esta tienda',
          business_type_required: 'Selecciona el tipo de negocio',
          business_type_pair_required: 'Este canal necesita precio para D2C y para B2B',
        },
      },
    },
    work_orders_services: {
      work_order_title: 'Maquilas',
      unit_options: {
        PER_UNIT: 'Cargo de persona por día',
      },
    },
    national_shipping_label_services: {
      titles: {
        SUPER_SAVER: 'Super saver',
        LOCAL: 'Local',
        PREMIUM: 'Premium',
        ECONOMY: 'Economy',
        SAVER_PRINCIPAL_CITIES: 'Saver Ciudades Principales',
        SAVER_NATIONAL: 'Saver Nacional',
        SAVER_LOCAL: 'Saver Local',
        CUBBO_PRINCIPAL_CITIES: 'Cubbo Ciudades Principales',
        CUBBO_NATIONAL: 'Cubbo Nacional',
        CUBBO_LOCAL: 'Cubbo Local',
        GROUND_PRINCIPAL_CITIES: 'Ground Ciudades Principales',
        GROUND_NATIONAL: 'Ground Nacional',
        GROUND_LOCAL: 'Ground Local',
        EXPRESS_PRINCIPAL_CITIES: 'Exprés Ciudades Principales',
        EXPRESS_NATIONAL: 'Exprés Nacional',
        EXPRESS_LOCAL: 'Exprés Local',
        PICKUP: 'Recolección en almacén',
        GROUND_SP_CAP: 'Ground SP Capital',
        GROUND_SP_INT: 'Ground SP Interior',
        GROUND_RJ_CAP: 'Ground RJ Capital',
        GROUND_RJ_INT: 'Ground RJ Interior',
        GROUND_ES_CAP: 'Ground ES Capital',
        GROUND_ES_INT: 'Ground ES Interior',
        GROUND_MG_CAP: 'Ground MG Capital',
        GROUND_MG_INT: 'Ground MG Interior',
        GROUND_BA_CAP: 'Ground BA Capital',
        GROUND_BA_INT: 'Ground BA Interior',
        GROUND_SE_CAP: 'Ground SE Capital',
        GROUND_SE_INT: 'Ground SE Interior',
        GROUND_PE_CAP: 'Ground PE Capital',
        GROUND_PE_INT: 'Ground PE Interior',
        GROUND_AL_CAP: 'Ground AL Capital',
        GROUND_AL_INT: 'Ground AL Interior',
        GROUND_PB_CAP: 'Ground PB Capital',
        GROUND_PB_INT: 'Ground PB Interior',
        GROUND_RN_CAP: 'Ground RN Capital',
        GROUND_RN_INT: 'Ground RN Interior',
        GROUND_CE_CAP: 'Ground CE Capital',
        GROUND_CE_INT: 'Ground CE Interior',
        GROUND_PI_CAP: 'Ground PI Capital',
        GROUND_PI_INT: 'Ground PI Interior',
        GROUND_MA_CAP: 'Ground MA Capital',
        GROUND_MA_INT: 'Ground MA Interior',
        GROUND_PA_CAP: 'Ground PA Capital',
        GROUND_PA_INT: 'Ground PA Interior',
        GROUND_AP_CAP: 'Ground AP Capital',
        GROUND_AP_INT: 'Ground AP Interior',
        GROUND_AM_CAP: 'Ground AM Capital',
        GROUND_AM_INT: 'Ground AM Interior',
        GROUND_RR_CAP: 'Ground RR Capital',
        GROUND_RR_INT: 'Ground RR Interior',
        GROUND_AM_INT_2: 'Ground AM Interior 2',
        GROUND_AC_CAP: 'Ground AC Capital',
        GROUND_AC_INT: 'Ground AC Interior',
        GROUND_DF_CAP: 'Ground DF Capital',
        GROUND_DF_INT: 'Ground DF Interior',
        GROUND_GO_CAP: 'Ground GO Capital',
        GROUND_DF_INT_2: 'Ground DF Interior 2',
        GROUND_GO_CAP_2: 'Ground GO Capital 2',
        GROUND_GO_INT: 'Ground GO Interior',
        GROUND_RO_CAP: 'Ground RO Capital',
        GROUND_RO_INT: 'Ground RO Interior',
        GROUND_TO_CAP: 'Ground TO Capital',
        GROUND_TO_INT: 'Ground TO Interior',
        GROUND_MT_CAP: 'Ground MT Capital',
        GROUND_MT_INT: 'Ground MT Interior',
        GROUND_RO_INT_2: 'Ground RO Interior 2',
        GROUND_RO_INT_3: 'Ground RO Interior 3',
        GROUND_MS_CAP: 'Ground MS Capital',
        GROUND_MS_INT: 'Ground MS Interior',
        GROUND_PR_CAP: 'Ground PR Capital',
        GROUND_PR_INT: 'Ground PR Interior',
        GROUND_SC_CAP: 'Ground SC Capital',
        GROUND_SC_INT: 'Ground SC Interior',
        GROUND_RS_CAP: 'Ground RS Capital',
        GROUND_RS_INT: 'Ground RS Interior',
        /*
                EXPRESS_SP_CAP: "Express SP Capital",
                EXPRESS_SP_INT: "Express SP Interior",
                EXPRESS_RJ_CAP: "Express RJ Capital",
                EXPRESS_RJ_INT: "Express RJ Interior",
                EXPRESS_ES_CAP: "Express ES Capital",
                EXPRESS_ES_INT: "Express ES Interior",
                EXPRESS_MG_CAP: "Express MG Capital",
                EXPRESS_MG_INT: "Express MG Interior",
                EXPRESS_BA_CAP: "Express BA Capital",
                EXPRESS_BA_INT: "Express BA Interior",
                EXPRESS_SE_CAP: "Express SE Capital",
                EXPRESS_SE_INT: "Express SE Interior",
                EXPRESS_PE_CAP: "Express PE Capital",
                EXPRESS_PE_INT: "Express PE Interior",
                EXPRESS_AL_CAP: "Express AL Capital",
                EXPRESS_AL_INT: "Express AL Interior",
                EXPRESS_PB_CAP: "Express PB Capital",
                EXPRESS_PB_INT: "Express PB Interior",
                EXPRESS_RN_CAP: "Express RN Capital",
                EXPRESS_RN_INT: "Express RN Interior",
                EXPRESS_CE_CAP: "Express CE Capital",
                EXPRESS_CE_INT: "Express CE Interior",
                EXPRESS_PI_CAP: "Express PI Capital",
                EXPRESS_PI_INT: "Express PI Interior",
                EXPRESS_MA_CAP: "Express MA Capital",
                EXPRESS_MA_INT: "Express MA Interior",
                EXPRESS_PA_CAP: "Express PA Capital",
                EXPRESS_PA_INT: "Express PA Interior",
                EXPRESS_AP_CAP: "Express AP Capital",
                EXPRESS_AP_INT: "Express AP Interior",
                EXPRESS_AM_CAP: "Express AM Capital",
                EXPRESS_AM_INT: "Express AM Interior",
                EXPRESS_RR_CAP: "Express RR Capital",
                EXPRESS_RR_INT: "Express RR Interior",
                EXPRESS_AM_INT_2: "Express AM Interior 2",
                EXPRESS_AC_CAP: "Express AC Capital",
                EXPRESS_AC_INT: "Express AC Interior",
                EXPRESS_DF_CAP: "Express DF Capital",
                EXPRESS_DF_INT: "Express DF Interior",
                EXPRESS_GO_CAP: "Express GO Capital",
                EXPRESS_DF_INT_2: "Express DF Interior 2",
                EXPRESS_GO_CAP_2: "Express GO Capital 2",
                EXPRESS_GO_INT: "Express GO Interior",
                EXPRESS_RO_CAP: "Express RO Capital",
                EXPRESS_RO_INT: "Express RO Interior",
                EXPRESS_TO_CAP: "Express TO Capital",
                EXPRESS_TO_INT: "Express TO Interior",
                EXPRESS_MT_CAP: "Express MT Capital",
                EXPRESS_MT_INT: "Express MT Interior",
                EXPRESS_RO_INT_2: "Express RO Interior 2",
                EXPRESS_RO_INT_3: "Express RO Interior 3",
                EXPRESS_MS_CAP: "Express MS Capital",
                EXPRESS_MS_INT: "Express MS Interior",
                EXPRESS_PR_CAP: "Express PR Capital",
                EXPRESS_PR_INT: "Express PR Interior",
                EXPRESS_SC_CAP: "Express SC Capital",
                EXPRESS_SC_INT: "Express SC Interior",
                EXPRESS_RS_CAP: "Express RS Capital",
                EXPRESS_RS_INT: "Express RS Interior"
                */
      },
      extended_zone_titles: {
        SAVER_PRINCIPAL_CITIES: 'Saver Ciudades Principales zona extendida',
        SAVER_NATIONAL: 'Saver Nacional zona extendida',
        SAVER_LOCAL: 'Saver Local zona extendida',
        CUBBO_PRINCIPAL_CITIES: 'Cubbo Ciudades Principales zona extendida',
        CUBBO_NATIONAL: 'Cubbo Nacional zona extendida',
        CUBBO_LOCAL: 'Cubbo Local zona extendida',
        GROUND_PRINCIPAL_CITIES: 'Ground Ciudades Principales zona extendida',
        GROUND_NATIONAL: 'Ground Nacional zona extendida',
        GROUND_LOCAL: 'Ground Local zona extendida',
        EXPRESS_PRINCIPAL_CITIES: 'Exprés Ciudades Principales zona extendida',
        EXPRESS_NATIONAL: 'Exprés Nacional zona extendida',
        EXPRESS_LOCAL: 'Exprés Local zona extendida',
        GROUND_SP_CAP: 'Zona estendida Ground SP Capital',
        GROUND_SP_INT: 'Zona estendida Ground SP Interior',
        GROUND_RJ_CAP: 'Zona estendida Ground RJ Capital',
        GROUND_RJ_INT: 'Zona estendida Ground RJ Interior',
        GROUND_ES_CAP: 'Zona estendida Ground ES Capital',
        GROUND_ES_INT: 'Zona estendida Ground ES Interior',
        GROUND_MG_CAP: 'Zona estendida Ground MG Capital',
        GROUND_MG_INT: 'Zona estendida Ground MG Interior',
        GROUND_BA_CAP: 'Zona estendida Ground BA Capital',
        GROUND_BA_INT: 'Zona estendida Ground BA Interior',
        GROUND_SE_CAP: 'Zona estendida Ground SE Capital',
        GROUND_SE_INT: 'Zona estendida Ground SE Interior',
        GROUND_PE_CAP: 'Zona estendida Ground PE Capital',
        GROUND_PE_INT: 'Zona estendida Ground PE Interior',
        GROUND_AL_CAP: 'Zona estendida Ground AL Capital',
        GROUND_AL_INT: 'Zona estendida Ground AL Interior',
        GROUND_PB_CAP: 'Zona estendida Ground PB Capital',
        GROUND_PB_INT: 'Zona estendida Ground PB Interior',
        GROUND_RN_CAP: 'Zona estendida Ground RN Capital',
        GROUND_RN_INT: 'Zona estendida Ground RN Interior',
        GROUND_CE_CAP: 'Zona estendida Ground CE Capital',
        GROUND_CE_INT: 'Zona estendida Ground CE Interior',
        GROUND_PI_CAP: 'Zona estendida Ground PI Capital',
        GROUND_PI_INT: 'Zona estendida Ground PI Interior',
        GROUND_MA_CAP: 'Zona estendida Ground MA Capital',
        GROUND_MA_INT: 'Zona estendida Ground MA Interior',
        GROUND_PA_CAP: 'Zona estendida Ground PA Capital',
        GROUND_PA_INT: 'Zona estendida Ground PA Interior',
        GROUND_AP_CAP: 'Zona estendida Ground AP Capital',
        GROUND_AP_INT: 'Zona estendida Ground AP Interior',
        GROUND_AM_CAP: 'Zona estendida Ground AM Capital',
        GROUND_AM_INT: 'Zona estendida Ground AM Interior',
        GROUND_AM_INT_2: 'Zona estendida Ground AM Interior 2',
        GROUND_RR_CAP: 'Zona estendida Ground RR Capital',
        GROUND_RR_INT: 'Zona estendida Ground RR Interior',
        GROUND_AC_CAP: 'Zona estendida Ground AC Capital',
        GROUND_AC_INT: 'Zona estendida Ground AC Interior',
        GROUND_DF_CAP: 'Zona estendida Ground DF Capital',
        GROUND_DF_INT: 'Zona estendida Ground DF Interior',
        GROUND_DF_INT_2: 'Zona estendida Ground DF Interior 2',
        GROUND_GO_CAP: 'Zona estendida Ground GO Capital',
        GROUND_GO_CAP_2: 'Zona estendida Ground GO Capital 2',
        GROUND_GO_INT: 'Zona estendida Ground GO Interior',
        GROUND_RO_CAP: 'Zona estendida Ground RO Capital',
        GROUND_RO_INT: 'Zona estendida Ground RO Interior',
        GROUND_RO_INT_2: 'Zona estendida Ground RO Interior 2',
        GROUND_RO_INT_3: 'Zona estendida Ground RO Interior 3',
        GROUND_TO_CAP: 'Zona estendida Ground TO Capital',
        GROUND_TO_INT: 'Zona estendida Ground TO Interior',
        GROUND_MT_CAP: 'Zona estendida Ground MT Capital',
        GROUND_MT_INT: 'Zona estendida Ground MT Interior',
        GROUND_MS_CAP: 'Zona estendida Ground MS Capital',
        GROUND_MS_INT: 'Zona estendida Ground MS Interior',
        GROUND_PR_CAP: 'Zona estendida Ground PR Capital',
        GROUND_PR_INT: 'Zona estendida Ground PR Interior',
        GROUND_SC_CAP: 'Zona estendida Ground SC Capital',
        GROUND_SC_INT: 'Zona estendida Ground SC Interior',
        GROUND_RS_CAP: 'Zona estendida Ground RS Capital',
        GROUND_RS_INT: 'Zona estendida Ground RS Interior',
        /*
                EXPRESS_SP_CAP: "Zona estendida Express SP Capital",
                EXPRESS_SP_INT: "Zona estendida Express SP Interior",
                EXPRESS_RJ_CAP: "Zona estendida Express RJ Capital",
                EXPRESS_RJ_INT: "Zona estendida Express RJ Interior",
                EXPRESS_ES_CAP: "Zona estendida Express ES Capital",
                EXPRESS_ES_INT: "Zona estendida Express ES Interior",
                EXPRESS_MG_CAP: "Zona estendida Express MG Capital",
                EXPRESS_MG_INT: "Zona estendida Express MG Interior",
                EXPRESS_BA_CAP: "Zona estendida Express BA Capital",
                EXPRESS_BA_INT: "Zona estendida Express BA Interior",
                EXPRESS_SE_CAP: "Zona estendida Express SE Capital",
                EXPRESS_SE_INT: "Zona estendida Express SE Interior",
                EXPRESS_PE_CAP: "Zona estendida Express PE Capital",
                EXPRESS_PE_INT: "Zona estendida Express PE Interior",
                EXPRESS_AL_CAP: "Zona estendida Express AL Capital",
                EXPRESS_AL_INT: "Zona estendida Express AL Interior",
                EXPRESS_PB_CAP: "Zona estendida Express PB Capital",
                EXPRESS_PB_INT: "Zona estendida Express PB Interior",
                EXPRESS_RN_CAP: "Zona estendida Express RN Capital",
                EXPRESS_RN_INT: "Zona estendida Express RN Interior",
                EXPRESS_CE_CAP: "Zona estendida Express CE Capital",
                EXPRESS_CE_INT: "Zona estendida Express CE Interior",
                EXPRESS_PI_CAP: "Zona estendida Express PI Capital",
                EXPRESS_PI_INT: "Zona estendida Express PI Interior",
                EXPRESS_MA_CAP: "Zona estendida Express MA Capital",
                EXPRESS_MA_INT: "Zona estendida Express MA Interior",
                EXPRESS_PA_CAP: "Zona estendida Express PA Capital",
                EXPRESS_PA_INT: "Zona estendida Express PA Interior",
                EXPRESS_AP_CAP: "Zona estendida Express AP Capital",
                EXPRESS_AP_INT: "Zona estendida Express AP Interior",
                EXPRESS_AM_CAP: "Zona estendida Express AM Capital",
                EXPRESS_AM_INT: "Zona estendida Express AM Interior",
                EXPRESS_AM_INT_2: "Zona estendida Express AM Interior 2",
                EXPRESS_RR_CAP: "Zona estendida Express RR Capital",
                EXPRESS_RR_INT: "Zona estendida Express RR Interior",
                EXPRESS_AC_CAP: "Zona estendida Express AC Capital",
                EXPRESS_AC_INT: "Zona estendida Express AC Interior",
                EXPRESS_DF_CAP: "Zona estendida Express DF Capital",
                EXPRESS_DF_INT: "Zona estendida Express DF Interior",
                EXPRESS_DF_INT_2: "Zona estendida Express DF Interior 2",
                EXPRESS_GO_CAP: "Zona estendida Express GO Capital",
                EXPRESS_GO_CAP_2: "Zona estendida Express GO Capital 2",
                EXPRESS_GO_INT: "Zona estendida Express GO Interior",
                EXPRESS_RO_CAP: "Zona estendida Express RO Capital",
                EXPRESS_RO_INT: "Zona estendida Express RO Interior",
                EXPRESS_RO_INT_2: "Zona estendida Express RO Interior 2",
                EXPRESS_RO_INT_3: "Zona estendida Express RO Interior 3",
                EXPRESS_TO_CAP: "Zona estendida Express TO Capital",
                EXPRESS_TO_INT: "Zona estendida Express TO Interior",
                EXPRESS_MT_CAP: "Zona estendida Express MT Capital",
                EXPRESS_MT_INT: "Zona estendida Express MT Interior",
                EXPRESS_MS_CAP: "Zona estendida Express MS Capital",
                EXPRESS_MS_INT: "Zona estendida Express MS Interior",
                EXPRESS_PR_CAP: "Zona estendida Express PR Capital",
                EXPRESS_PR_INT: "Zona estendida Express PR Interior",
                EXPRESS_SC_CAP: "Zona estendida Express SC Capital",
                EXPRESS_SC_INT: "Zona estendida Express SC Interior",
                EXPRESS_RS_CAP: "Zona estendida Express RS Capital",
                EXPRESS_RS_INT: "Zona estendida Express RS Interior"
                */
      },
      unit_options: {
        TOTAL: 'Cargo por guía',
        EXCESS_PER_UNIT: 'Cargo extra por kilo excedido',
      },
      pickup_unit_options: {
        TOTAL: 'Cargo por pedido',
      },
    },
    international_shipping_label_services: {
      unit_options: {
        TOTAL: 'Cargo por guía',
        EXCESS_PER_UNIT: 'Cargo extra por kilo excedido',
      },
    },
    natura_services: {
      shipping_label_title: 'Guía de Envío Natura Venta Directa',
      additional_label_title: 'Guía Adicional Natura Venta Directa',
      pick_and_pack_title: 'Pick and Pack Natura Venta Directa',
      shipping_unit_options: {
        TOTAL: 'Cargo por guía',
        EXCESS_PER_UNIT: 'Cargo extra por kilo excedido',
      },
      pick_and_pack_unit_options: {
        PER_UNIT: 'Cargo por pieza',
        TOTAL: 'Cargo por pedido',
        EXCESS_PER_UNIT: 'Cargo extra por pieza excedida',
        EXCESS_TOTAL: 'Cargo extra fijo por exceso',
      },
    },
    custom_services: {
      create_current_title: 'Crear cobro/descuento adicional para el corte actual',
      create_button: 'Crear cobro/descuento adicional',
      types: {
        discount: 'Descuento',
        charge: 'Cargo',
      },
      no_services: 'Sin información',
      create_custom_service: {
        init_error: 'Ocurrió un error al inicializar, inténtalo más tarde',
        create_error: 'Ocurrió un error durante la creación, inténtalo más tarde',
        store_name: 'Tienda: ',
        warehouse_name: 'Almacén: ',
        is_discount: '¿Es descuento?',
        title: 'Título',
        title_placeholder: 'Ingresa un título',
        description: 'Descripción',
        description_placeholder: 'Ingresa una descripción',
        amount_discount: 'Monto de descuento',
        amount_placeholder_discount: 'Ingresa un monto de descuento',
        amount_charge: 'Monto de cobro',
        amount_placeholder_charge: 'Ingresa un monto de cobro',
        no_amount: 'El monto no puede ser 0',
        create_button: 'Crear servicio personalizado',
        remaining_text_length: 'Caracteres disponibles restantes: ',
        confirm_create_dialog: {
          title_DISCOUNT: 'Crear descuento adicional',
          title_CHARGE: 'Crear cobro adicional',
          description_DISCOUNT: 'Confirma la creación del descuento adicional para la tienda {STORE_NAME} en almacén {WAREHOUSE_NAME}',
          description_CHARGE: 'Confirma la creación del cobro adicional para la tienda {STORE_NAME} en almacén {WAREHOUSE_NAME}',
          confirm_button: 'Confirmar',
          cancel_button: 'Cancelar',
        },
      },
      list_custom_services: {
        table_columns: {
          id: 'ID',
          billed_total_price: 'Monto',
          type: 'Tipo',
          title: 'Título',
          description: 'Descripción',
        },
        init_error: 'Ocurrió un error al inicializar, inténtalo más tarde',
        table_filters: {
          title: 'Título',
          title_placeholder: 'Busca por título',
          billed_total_price: 'Monto',
          greater_or_equal_than_billed_total_price: 'Mayor o igual que monto',
          less_or_equal_than_billed_total_price: 'Menor o igual que monto',
          is_discount: 'Es descuento',
          is_charge: 'Es cargo',
          description: 'Descripción',
        },
      },
    },
  },
  workforce: {
    tabs: {
      costs: 'Análisis',
      rates: 'Tarifas',
      shifts: 'Turnos',
      schedule: 'Programación',
      operators: 'Operadores',
      attendance: 'Asistencia',
    },
    days: {
      sun: 'Dom',
      mon: 'Lun',
      tue: 'Mar',
      wed: 'Mié',
      thu: 'Jue',
      fri: 'Vie',
      sat: 'Sáb',
    },
    cancel: 'Cancelar',
    save: 'Guardar',
    saving: 'Guardando...',
    edit: 'Editar',
    updating: 'Actualizando...',
    errors: {
      generic: 'Ocurrió un error.',
      save_failed: 'No se pudo guardar.',
    },
    rates: {
      title: 'Tarifas de operadores',
      add_new: 'Nueva tarifa',
      info_add_title: 'Agregar tarifa',
      info_add_body: 'Crea una nueva tarifa vigente a partir de una fecha.',
      info_fix_title: 'Corregir tarifa',
      info_fix_body: 'La corrección sobreescribe la tarifa actual sin crear historial. Usar solo para errores.',
      all_types: 'Todos los tipos',
      all_contracts: 'Todos los contratos',
      operator_type: 'Tipo de operador',
      contract: 'Contrato',
      daily_rate: 'Tarifa diaria',
      extra_hour_rate: 'Tarifa hora extra',
      day_rates: 'Tarifas diurnas',
      night_rates: 'Tarifas nocturnas',
      day_daily_rate: 'Tarifa día (diaria)',
      day_extra_hour_rate: 'Hora extra día',
      night_daily_rate: 'Tarifa noche (diaria)',
      night_extra_hour_rate: 'Hora extra noche',
      daily_short: 'Diaria',
      extra_hour_short: 'Hora extra',
      night_seed_banner: 'Las tarifas nocturnas se inicializaron con los valores diurnos — revísalas y ajústalas si difieren.',
      effective_from: 'Vigente desde',
      status: 'Estado',
      status_active: 'Activa',
      status_history: 'Histórica',
      fix_mistake: 'Corregir',
      hide_history: 'Ocultar histórico',
      show_history: 'Ver histórico',
      empty: 'Sin tarifas configuradas.',
      add_title: 'Agregar tarifa',
      fix_title: 'Corregir tarifa',
      fix_warning: 'Vas a sobreescribir la tarifa actual. Esta acción no crea historial.',
      select_operator_type: 'Selecciona un tipo',
      operator_type_placeholder: 'ej. WAREHOUSE_AUXILIARY',
      operator_type_hint: 'Elige uno existente o escribe uno nuevo. Se creará al guardar la tarifa.',
      select_contract: 'Selecciona un contrato',
      currency: 'Moneda',
      effective_from_hint: 'Los costos para días posteriores se recalcularán en ~1 minuto.',
      save_new: 'Guardar tarifa',
      review_fix: 'Revisar corrección',
      confirm_fix: 'Confirmar corrección',
      errors: {
        required: 'Campo obligatorio',
        positive: 'Debe ser mayor a 0',
      },
    },
    costs: {
      title: 'Costos de operadores',
      from: 'Desde',
      to: 'Hasta',
      apply: 'Aplicar',
      fix_in_rates: 'Corregir en Tarifas →',
      empty: 'Aún no hay asistencias registradas en el rango seleccionado.',
      total_cost: 'Costo total',
      primary_cost: 'Costo principal',
      extra_cost: 'Costo extra',
      total_present: 'Operadores presentes',
      daily_cost: 'Costo por día',
      breakdown: 'Desglose',
      breakdown_empty: 'Sin datos en el rango.',
      operator_type: 'Tipo de operador',
      contract: 'Contrato',
      row_type: 'Tipo',
      shift_period: 'Periodo',
      units: 'Unidades',
      rate: 'Tarifa',
      total: 'Total',
      extra: 'Extra',
      primary: 'Principal',
      hours_ops: '{{hours}}h · {{ops}} ops',
      days: '{{days}} días',
      no_rate_linked: 'Sin tarifa vinculada',
      errors: {
        from_before_to: 'La fecha inicial debe ser anterior o igual a la final.',
        max_range: 'El rango máximo es de {{max}} días.',
      },
    },
    analytics: {
      title: 'Análisis de asistencia',
      from: 'Desde',
      to: 'Hasta',
      apply: 'Aplicar',
      empty: 'Aún no hay asistencias registradas en el rango seleccionado.',
      kpi_present: 'Operadores presentes',
      kpi_present_hint: 'Día: {{day}} · Noche: {{night}}',
      kpi_active_days: 'Días con asistencia',
      kpi_extras_ops: 'Turnos extra',
      kpi_extras_hours: 'Horas extra',
      daily_attendance: 'Asistencia diaria',
      breakdown: 'Desglose por contrato y turno',
      breakdown_empty: 'Sin datos en el rango.',
      contract: 'Contrato',
      shift_period: 'Turno',
      operator_types: 'Tipos de operador',
      row_type: 'Tipo',
      primary: 'Principal',
      extra: 'Extra',
      present_days: 'Asistencias',
      extra_ops: 'Ops. extra',
      extra_hours: 'Horas extra',
      series_day: 'Día (principal)',
      series_night: 'Noche (principal)',
      series_unknown: 'Sin periodo',
      series_extras: 'Extras',
      axis_operators: 'Operadores',
      errors: {
        from_before_to: 'La fecha inicial debe ser anterior o igual a la final.',
        max_range: 'El rango máximo es de {{max}} días.',
      },
    },
    shifts: {
      title: 'Turnos de trabajo',
      create: 'Nuevo turno',
      create_title: 'Crear turno',
      edit_title: 'Editar turno',
      show_inactive: 'Mostrar inactivos',
      empty: 'Sin turnos configurados.',
      name: 'Nombre',
      schedule_days: 'Días',
      start_time: 'Hora de inicio',
      end_time: 'Hora de fin',
      is_active: 'Activo',
      overnight_hint: 'El turno termina al día siguiente.',
      overnight_badge: 'Nocturno',
      next_day: 'día siguiente',
      no_days: 'Sin días',
      edit_shift: 'Editar turno',
      operators_assigned: '{{count}} operadores asignados',
      shift_period: 'Periodo del turno',
      period_day: 'Día',
      period_night: 'Noche',
      period_hint:
        'Día: horario diurno. Noche: si el turno cae principalmente entre las 22:00 y las 06:00. Determina qué columna de tarifa se aplica al costo.',
      help_title: '¿Cuándo crear un turno nuevo o editar uno existente?',
      help_create_title: 'Crea un turno nuevo cuando:',
      help_create_1:
        'Los horarios de inicio o fin cambian hacia adelante (por ejemplo, "Mañana" pasa de 8-15 a 7-14). La asistencia pasada queda asociada al turno antiguo, para que los reportes reflejen las horas realmente trabajadas.',
      help_create_2: 'Se introduce un nuevo patrón de turno (añadir un turno nocturno, turno de fin de semana, etc.).',
      help_create_3: 'Los días programados cambian de forma significativa (Lun-Vie → Mar-Sáb).',
      help_create_note:
        'Al crear un reemplazo, desactiva el turno antiguo (activo: no) — el historial de asistencia se mantiene, pero el selector solo muestra los turnos vigentes.',
      help_edit_title: 'Edita un turno existente cuando:',
      help_edit_1: 'Corriges un error de tipeo en el nombre ("Mañna" → "Mañana").',
      help_edit_2: 'Pausas o reanudas un turno (activar/desactivar).',
      help_edit_3:
        'Corriges un dato que estuvo mal desde el inicio (por ejemplo, escribiste 8:15 pero siempre fue 8:00) — es seguro porque no hay un "antes" que pueda quedar mal representado.',
      errors: {
        name_required: 'El nombre es obligatorio',
        days_required: 'Selecciona al menos un día',
        period_required: 'Selecciona el periodo del turno (día o noche)',
      },
    },
    operators: {
      title: 'Operadores del almacén',
      assign: 'Asignar operador',
      assign_title: 'Asignar operador',
      edit_title: 'Editar operador',
      search_user: 'Buscar usuario',
      search_placeholder: 'Nombre o email...',
      all_shifts: 'Todos los turnos',
      all_types: 'Todos los tipos',
      include_inactive: 'Incluir inactivos',
      empty: 'Sin operadores asignados.',
      name: 'Nombre',
      operator_type: 'Tipo',
      contract_type: 'Contrato',
      work_shift: 'Turno',
      status: 'Estado',
      active: 'Activo',
      inactive: 'Inactivo',
      select_type: 'Selecciona tipo',
      select_contract: 'Selecciona contrato',
      select_shift: 'Selecciona turno',
      is_active: 'Activo',
      searching: 'Buscando...',
      no_results: 'Sin resultados',
      clear: 'Limpiar',
      start_date: 'Fecha de inicio',
      start_date_hint: 'Si el operador se registró después de su primer día, adelanta la fecha de inicio.',
      effective_date: 'Válido a partir de',
      end_date: 'Fecha de baja',
      history: 'Historial',
      history_current: 'actual',
      columns: {
        start_date: 'Inicio',
        end_date: 'Baja',
      },
      errors: {
        user_required: 'Debes seleccionar un usuario',
        operator_type_required: 'Selecciona un tipo',
        contract_type_required: 'Selecciona un contrato',
        shift_required: 'Selecciona un turno',
        codes: {
          FUTURE_DATE: 'La fecha no puede ser posterior a hoy.',
          SHIFT_NOT_IN_WAREHOUSE: 'El turno no pertenece a este almacén.',
          NO_RATE: 'No hay tarifa para este tipo y contrato en esa fecha.',
          BEFORE_LATEST_ASSIGNMENT: 'La fecha cae dentro de una asignación anterior del operador.',
          BEFORE_TERMINATION: 'La fecha es anterior al inicio de la última asignación, ya terminada.',
          NOT_ACTIVE: 'El operador no tiene una asignación activa para terminar.',
          BEFORE_START: 'La fecha de baja es anterior al inicio de la asignación actual.',
          ATTENDANCE_AFTER_END_DATE: 'El operador tiene asistencia registrada después de la fecha de baja. Quita esa asistencia primero.',
          ASSIGNMENT_CHANGED: 'Otra persona modificó al operador mientras guardabas. Recarga e inténtalo de nuevo.',
          TERMINATED: 'El operador está dado de baja. Reactívalo para cambiar su asignación.',
          WAREHOUSE_NOT_MEMBER: 'No puedes gestionar operadores de un almacén al que no perteneces.',
        },
      },
    },
    attendance: {
      title: 'Asistencia',
      off_roster: 'Fuera de la escala en esta fecha',
      date: 'Fecha',
      no_shifts: 'No hay turnos configurados.',
      assigned_operators: 'Operadores asignados',
      no_assigned: 'Sin operadores asignados a este turno.',
      extra_shift: 'Turno extra',
      add_extra: 'Agregar extra',
      add: 'Agregar',
      remove: 'Quitar',
      no_extras: 'Sin extras.',
      extra_hours: 'Horas extra',
      search_operator: 'Buscar operador',
      summary: '{{present}} de {{total}} presentes · {{extra}} extras',
      unsaved: 'cambios sin guardar',
      unsaved_prompt: 'Hay cambios sin guardar. ¿Salir de todos modos?',
      saved: 'Asistencia guardada',
      saved_note: 'Los costos se recalcularán en ~1 minuto.',
      overnight_hint: 'Turno nocturno: se registra contra la fecha de inicio.',
      not_scheduled_title: 'Este turno no está programado para esta fecha',
      not_scheduled_body: 'No hay un periodo activo del turno que cubra el {{date}}. Programa el turno primero para poder registrar asistencia.',
      schedule_this_shift: 'Ir a Programación',
      errors: {
        future_date: 'No se puede registrar asistencia en fechas futuras.',
        duplicate_operator: 'Este operador ya está en la lista.',
      },
    },
    schedule: {
      title: 'Programación de turnos',
      roster_until: 'hasta {{date}}',
      schedule_shift: 'Programar turno',
      today: 'Hoy',
      all_shifts: 'Todos los turnos',
      shift: 'Turno',
      no_shifts: 'Aún no hay turnos. Crea un turno desde la pestaña Turnos.',
      schedule_on: 'Programar este turno el {{date}}',
      always_on_tag: 'Continuo (migración)',
      create_title: 'Programar turno',
      edit_title: 'Editar periodo',
      select_shift: 'Selecciona un turno',
      start_date: 'Desde',
      end_date: 'Hasta',
      range_hint: 'Un periodo abarca un rango de fechas. Para un solo día, usa la misma fecha en ambos campos.',
      shift_inactive_hint: 'Este turno está desactivado. Reactívalo antes de programarlo.',
      delete: 'Eliminar periodo',
      confirm_delete: 'Confirmar eliminación',
      delete_warning: 'Al eliminar este periodo, las fechas dejarán de aceptar asistencia. La acción falla si ya hay registros de asistencia.',
      period_roster: 'Roster del periodo',
      edit_period: 'Editar periodo',
      roster_hint:
        'Los operadores predeterminados vienen del turno asignado a cada operador. Excluye a los que no estarán en este periodo (vacaciones, ausencia) o suma operadores que no pertenecen al turno (cobertura temporal).',
      default_operators: 'Predeterminados',
      no_defaults: 'No hay operadores asignados a este turno por defecto.',
      added_operators: 'Agregados a este periodo',
      no_added: 'Sin agregados.',
      add_operator: 'Agregar operador',
      included: 'Incluido',
      excluded: 'Excluido',
      errors: {
        shift_required: 'Selecciona un turno',
        start_required: 'Selecciona una fecha de inicio',
        end_required: 'Selecciona una fecha final',
        end_before_start: 'La fecha final debe ser posterior o igual a la de inicio.',
      },
    },
  },
  work_orders: {
    work_order_details: {
      work_orders: 'Maquilas',
      work_order_details: 'Detalles de solicitud de maquila',
      work_order_number: 'Nº de maquila',
      solicitant: 'Solicitante',
      work_order_status: 'Estado de maquila',
      on_date: 'El',
      comments_to_the_brand: 'Comentarios para la marca',
      next_status: 'Al guardar los datos, se actualizará el estado de la maquila a',
      processing_work_order: 'Procesando maquila',
      product_origin: 'Origen del material requerido',
      rem_order: 'Retiro de inventario',
      no_rem_order: 'Esta maquila no tiene pedido de retiro de inventario',
      work_order: 'Solicitud de maquila',
      work_order_type: 'Tipo de proceso',
      notes: 'Notas',
      instruction: 'Instrucción',
      activity: 'Actividad',
      replenishment: 'Ingreso de producto maquilado',
      replenishment_id: 'Recibo de inventario de producto maquilado',
      replenishment_note: 'Desde este recibo de inventario podrás ver el progreso del ingreso a tu inventario del producto maquilado',
      resolve_order: 'Resolver solicitud',
      notification_message: {
        success_update_message: 'Estado de maquila actualizado correctamente',
        error_update_message: 'Error al actualizar estado de maquila',
      },
      work_order_statuses: {
        REQUESTED: 'Solicitado',
        IN_VALIDATION: 'En validación',
        SCHEDULED: 'Próxima a iniciar',
        IN_PROGRESS: 'En progreso',
        COMPLETED: 'Completada',
        REJECTED: 'Rechazada',
        CANCELED: 'Cancelada',
      },
      work_order_types: {
        LABELING_PLASTISEAL: 'De etiquetado o plastifechado',
        PRODUCT_VALIDATION: 'De validación de producto',
        KIT_ASSEMBLY_SHRINKWRAP: 'De armado de kits y/o aplicación de termoencogido',
        PACKAGING: 'De empaquetado',
        PRODUCT_SEGREGATION: 'De segregación de producto',
      },
      work_order_product_origin: {
        ALL_INVENTORY_AT_WAREHOUSE: 'Todo el material se encuentra en mi inventario almacenado en Cubbo disponible para vender',
        MATERIAL_IN_TRANSIT_TO_WAREHOUSE: 'El material va en camino al almacén',
        PARTIAL_MATERIAL_INVENTORY_IN_TRANSIT_TO_WAREHOUSE: 'Parte del material se encuentra almacenado en Cubbo y otra parte va en camino al almacén',
      },
      work_order_card: {
        update_work_order_status: 'Pasar maquila a estatus',
        save_button: 'Guardar actualización',
        start_progress_button: 'Iniciar progreso',
        complete_work_order_button: 'Completar maquila',
        reject_work_order_button: 'Rechazar maquila',
        complete_the_information_requested: 'Completa la información cuando se desee comenzar la validación operativa de la maquila',
        validate_order: 'La solicitud cuenta con todo lo necesario para pasar a validación operativa?',
        confirm_validation: 'Sí, aceptar solicitud',
        reject_validation: 'No, rechazar solicitud',
        complete_the_information_in_validation: 'Completa la información una vez que se haya concluido la validación de la solicitud de maquila',
        necessary_pieces: 'Se cuentan con todos las piezas necesarias para realizar la maquila?',
        estimated_operator_quantity: 'Cuántas personas se estima se asignarán para procesar la maquila?',
        estimated_labor_days_quantity: 'Días estimados de procesamiento',
        scheduled_order: 'Esta solicitúd ha sido colocada cómo próxima a iniciar',
        complete_the_information_in_progress: 'Completa la información una vez que haya concluido la maquila',
        confirm_operator_quantity: 'Confirma el total de personas utilizadas en la maquila',
        estimated_labor_days_quantity: 'Confirma los días estimadas de procesamiento',
        completed_work_order: 'Esta maquila ha sido completada',
        rejected_work_order: 'Esta maquila ha sido rechazada',
        canceled_work_order: 'Esta maquila ha sido cancelada',
        files_placeholder: 'Presiona aquí o arrastra tus archivos PDF, Excel o imágenes',
      },
    },
    work_order_list: {
      header: {
        work_order_id: 'Nº MAQUILA',
        customer: 'CLIENTE',
        work_order_type: 'TIPO',
        status: 'ESTATUS',
        created_at: 'FECHA DE SOLICITUD',
      },
      filters: {
        work_order_id: 'Nº maquila',
        status: 'Estatus',
        work_order_type: 'Tipo de maquila',
      },
      footer: {
        no_work_orders: 'No hay maquilas para mostrar',
        work_order: 'maquilas',
      },
      queued: 'En cola',
      view_work_order: 'Ver maquila',
      on_date: 'El',
    },
  },
  shipping_packages: {
    title: 'Cajas',
    add_package: 'Crear caja',
    edit_package: 'Editar caja',
    delete_package: 'Desactivar caja',
    confirm_delete: '¿Estás seguro de que deseas desactivar esta caja?',
    delete_warning: 'La caja será desactivada.',
    package_deleted: 'Caja desactivada correctamente',
    package_created: 'Caja creada correctamente',
    package_updated: 'Caja actualizada correctamente',
    package_restored: 'Caja reactivada correctamente',
    restore_package: 'Reactivar caja',
    confirm_restore: '¿Estás seguro de que deseas reactivar esta caja?',
    restore_warning: 'La caja será reactivada.',
    empty_table: 'No hay cajas para mostrar',
    footer_text: 'cajas',
    form: {
      name: 'Nombre',
      name_placeholder: 'Nombre de la caja',
      length: 'Largo (cm)',
      width: 'Ancho (cm)',
      height: 'Alto (cm)',
      calculating: 'Calculando...',
      bar_code: 'Código de barras',
      bar_code_placeholder: 'Código de barras opcional',
      package_type: 'Tipo de paquete',
      volume_liters: 'Volumen (litros)',
      cost: 'Costo',
      weight_kg: 'Peso (kg)',
      volumetric_weight: 'Peso volumétrico',
      store: 'Tienda',
      store_placeholder: 'Buscar tienda...',
      store_selected: 'Tienda seleccionada',
      save: 'Guardar',
      cancel: 'Cancelar',
      create: 'Crear',
      update: 'Actualizar',
      weight_will_be_overwritten: 'El peso volumétrico se actualizará al guardar',
    },
    headers: {
      name: 'Nombre',
      dimensions: 'Dimensiones (cm)',
      length: 'Largo',
      width: 'Ancho',
      height: 'Alto',
      package_type: 'Tipo',
      store: 'Tienda',
      bar_code: 'Código de barras',
      volume_liters: 'Volumen (L)',
      weight_kg: 'Peso (kg)',
      volumetric_weight: 'Peso volumétrico',
      cost: 'Costo',
      actions: 'Acciones',
    },
    package_types: {
      parcel_bag: 'Bolsa de paquetería',
      jiffy_envelope: 'Jiffy',
      cubbo_box: 'Caja Cubbo',
      packageless: 'Sin empaque',
      customer_box: 'Caja del cliente',
    },
    filters: {
      package_type: 'Tipo de paquete',
      store: 'Tienda',
      name: 'Nombre de caja',
      store_name: 'Nombre de tienda',
      bar_code: 'Código de barras',
      global_packages_only: 'Solo cajas globales',
      active: 'Estado',
      active_only: 'Activas',
      inactive_only: 'Inactivas',
      all: 'Todas',
    },
    store_allowed: {
      title: 'Cajas por marca',
      store_label: 'Marca',
      store_placeholder: 'Busca una marca por nombre',
      searching: 'Buscando…',
      no_results: 'No se encontraron marcas',
      search_error: 'No se pudo buscar marcas',
      change_store: 'Cambiar marca',
      select_prompt: 'Elige una marca para configurar sus cajas en este almacén.',
      explanation: '{{store}} solo podrá empacar en las cajas marcadas. Sin ninguna marcada puede usar todas.',
      own_tag: 'propia de la marca',
      inactive_tag: 'inactiva',
      empty: 'No hay cajas disponibles para esta marca en este almacén.',
      save: 'Guardar',
      save_success: 'Cajas de la marca actualizadas',
      save_error: 'No se pudieron guardar las cajas de la marca',
      not_a_candidate: 'La lista se actualizó; revisa las cajas y guarda de nuevo.',
      not_in_warehouse: 'Esta marca no opera en este almacén.',
      load_error: 'No se pudieron cargar las cajas de la marca',
      retry: 'Reintentar',
    },
    errors: {
      fetch_error: 'Error al cargar las cajas',
      create_error: 'Error al crear la caja',
      update_error: 'Error al actualizar la caja',
      delete_error: 'Error al desactivar la caja',
      restore_error: 'Error al reactivar la caja',
      required_fields: 'Por favor completa todos los campos requeridos',
      no_access: 'No tienes acceso a esta página',
    },
    history: {
      title: 'Historial de cambios',
      view_history: 'Ver historial',
      no_history: 'No hay historial disponible',
      action: 'Acción',
      changes: 'Cambios',
      user: 'Usuario',
      date: 'Fecha',
      action_create: 'Creación',
      action_update: 'Actualización',
      action_destroy: 'Desactivación',
      action_restore: 'Reactivación',
      field_name: 'Nombre',
      field_length_cm: 'Largo (cm)',
      field_width_cm: 'Ancho (cm)',
      field_height_cm: 'Alto (cm)',
      field_package_type: 'Tipo de paquete',
      field_volume_liters: 'Volumen (litros)',
      field_cost: 'Costo',
      field_bar_code: 'Código de barras',
      field_weight_kg: 'Peso (kg)',
      field_volumetric_weight: 'Peso volumétrico',
      field_store_id: 'Tienda',
      field_active: 'Estado',
      refresh: 'Actualizar',
    },
  },
  replenishment_labels: {
    dialog_title: 'Imprimir ID de recibo de inventario',
    label_title: 'Identificador de recibo de inventario',
    label_instructions: 'Imprime y pega esta etiqueta en el paquete retornado para identificar el retorno al realizar putaway.',
    store: 'Tienda',
    warehouse: 'Almacén',
    replenishment_id: 'ID de recibo',
  },
  replenishment: {
    expected_quantity: 'piezas pendientes de recibir',
    error_unexpected_stock_start: 'El máximo de piezas a recibir por producto es la cantidad esperada. ',
    error_unexpected_stock_middle: 'Ajusta la cantidad que se recibirá limitando las piezas pendientes a recibir',
    error_unexpected_stock_end: ' y separa las piezas sobrantes para procesarlas en otro recibo.',
  },
  generate_shipment: {
    generate_label: 'Generar Guía',
    store: 'Tienda',
    order: 'Orden',
    tote: 'Tote',
    go_to_next_order: 'Ir a la siguiente orden para este producto',
    picking_incomplete: 'El picking de esta orden no se ha completado',
    no_multiple_packages: 'El método de envío seleccionado no permite multi-paquete',
    cod_not_allowed: 'El método de envío seleccionado no permite pago contra reembolso',
    print_label: 'Imprimir Guía',
    print_bundle: 'Imprimir documentos de empaque',
    print_bundle_with_skipped: 'Imprimir documentos de empaque ({{count}} no se pudieron preparar)',
    missing_information: 'Falta información en la orden',
    cannot_generate_more_labels: 'No puede generar más guías para esta orden, por favor avise al equipo de operaciones para realizar esta acción',
    label_being_generated: 'La guía aún se está generando. Espera unos instantes y vuelve a hacer clic en "Generar guía" para finalizar la orden.',
    order_shipped_print_below: 'El pedido ya fue enviado y la guía está lista. Imprímela desde la sección de guías emitidas más abajo.',
    coverage_reassignment_notice:
      'Esta paquetería fue cambiada automáticamente por el proceso de recálculo de coberturas después de detectar que la paquetería original {{from}} no tenía cobertura para el código postal asignado.',
    shortcut_blocked_use_button: 'No se puede generar la guía con el atajo Ctrl+G en este momento. Usa el botón del pie de página, que indica el motivo.',
    no_more_orders:
      'Ya no hay más pedidos pendientes de empacar para esta SKU, en este tote. Regresa al módulo de generar guías y escanea otro tote o producto.',
    surplus_product: 'Hay un excedente de este producto.',
    imei_duplicate: 'IMEI duplicado',
    unit_code_duplicate: 'unit_code ya escaneado en esta confirmación',
    unit_code_not_in_order: 'unit_code no pertenece a este pedido',
    enter_unit_code: 'Escanea el unit_code',
    unit_code_missing_for_stock_unit: 'unit_code ausente para una unidad reservada — escalar al supervisor',
    product_not_in_order: 'Este producto no pertenece a la orden o ya ha sido revisado.',
    error_codes: {
      difal_invoice_exists: 'Este pedido tiene documentos fiscales de DIFAL. No se puede modificar desde el WMS.',
      store_edit_restriction: 'Este pedido pertenece a una tienda con restricciones de edición. No se puede generar guía desde el WMS.',
      order_not_modifiable: 'Este pedido no puede ser modificado.',
      order_locked_by_process: 'La guía ya se está generando, intenta de nuevo en unos segundos.',
      order_already_packed: 'Este pedido ya fue despachado.',
      order_not_authorized: 'No tienes permisos para generar guía en este pedido.',
      invoice_generation_in_progress: 'La factura está en proceso de generación. Espera un momento e intenta de nuevo.',
      carrier_no_coverage:
        'El transportista no tiene cobertura para este destino y no hay método alternativo disponible. El pedido quedó marcado para revisión — repórtalo a lastmile y continúa con el siguiente.',
      packing_incomplete: 'Aún hay piezas sin empacar. Escanéalas y colócalas en una caja antes de generar la guía.',
      boxes_still_open: 'Aún hay cajas abiertas. Ciérralas todas antes de generar la guía.',
      missing_pieces_detail: 'Faltan: {{pieces}}.',
    },
    edit_restriction: {
      title: 'No se puede editar la dirección de este pedido',
      default_message: 'Este pedido no puede ser editado.',
    },
    restriction_reasons: {
      order_not_editable: 'Si crees necesario editar el pedido, por favor comunica a tech para valorar la situación',
      order_difal_invoice_exists: 'Este pedido tiene documentos fiscales de DIFAL y no puede ser editado.',
      store_edit_restriction: 'Los pedidos de esta tienda solo pueden ser editados por miembros de la tienda.',
    },
    shipping_address: {
      order_details: 'Detalle del pedido',
      see_details: 'Ver detalle',
      hide_details: 'Ocultar detalle',
      name: 'Nombres',
      surname: 'Apellidos',
      phone: 'Teléfono',
      email: 'E-mail',
      address: 'Dirección',
      address_2: 'Apartamento, local, colonia, etc. (opcional)',
      country: 'País',
      city: 'Ciudad',
      province: 'Estado / Provincia',
      zip_code: 'Código Postal',
      copy_address: 'Copiar dirección completa',
      address_copied: 'Dirección copiada!',
      number: 'Número exterior',
      references: 'Referencias (opcional)',
    },
    product_list: {
      required_products: 'Productos requeridos',
      scan_all_items: 'Escanea todas las piezas del tote',
      order_complete: '¡El pedido está completo!',
      sku: 'SKU',
      upc: 'UPC',
      quantity: 'Piezas requeridas',
      processed_quantity: 'Piezas revisadas',
      actions: 'Estado de revisión',
      no_data: 'Sin datos',
      complete: 'Completas',
      pending: 'Pendiente',
      product_search: {
        placeholder: 'Escanea la etiqueta de un producto',
        placeholder_with_unit_code: 'Escanea la etiqueta del producto o su código único',
      },
      products_total: {
        item: 'pieza',
        complete_singular: 'Se revisaron',
        complete_plural: 'Se revisaron',
        pending_singular: 'pendiente de revisar',
        pending_plural: 'pendiente de revisar',
      },
      see_products: 'See products',
      hide_products: 'Ocultar productos',
    },
    missing_picking_pieces: {
      title: '¿Faltaron piezas por pickear?',
      scan_all_products: 'Escanea todos los productos del tote. ',
      missing_items: 'Si tras finalizar, aún hay piezas faltantes, envía el pedido a revisión.',
      action: 'Enviar pedido a revisión',
      action_disabled_tooltip:
        'Esta acción no está disponible ahora. Revisa que la dirección esté completa, que no haya una petición en curso y que el pedido siga en empaque y sin revisión pendiente',
      action_to_error: 'Enviar pedido a falta de información',
      action_to_error_disabled_tooltip: 'Disponible solo cuando hay falta de información en la dirección',
      send_to_review_title_confirmation: 'Enviar pedido del tote {{tote}} a revisión',
      send_to_missing_info_title_confirmation: 'Enviar pedido del tote {{tote}} a falta de información',
      send_to_review_question: '¿Seguro que deseas enviar el pedido de este tote a revisión?',
      send_to_missing_info_question: '¿Seguro que deseas enviar el pedido de este tote a falta de información?',
      missing_info_last_confirmation_title: 'Enviar pedido a falta de información',
      missing_info_last_confirmation_description: '¿Deseas mandar este pedido a falta de información?',
      in_review_last_confirmation_title: 'Enviar pedido a revisión',
      // Shown instead of the server's internal 422 string when put_in_review refuses
      // because units are already PACKED (BUGS-8501 tracks the refusal itself).
      review_blocked_pieces_packed:
        'No se pudo enviar el pedido a revisión porque ya hay piezas empacadas. Reabre las cajas y desescanea las piezas, o usa la tarja.',
      missing_info_blocked_pieces_packed:
        'No se pudo enviar el pedido a falta de información porque ya hay piezas empacadas. Reabre las cajas y desescanea las piezas, o usa la tarja.',
      // Shown when the request failed with no server message at all (red, timeout,
      // a 500 with an HTML body): do NOT name a cause we did not hear.
      request_failed_retry: 'No se pudo completar la acción. Revisa tu conexión e intenta de nuevo; si sigue fallando, repórtalo a Tecnología.',
      // Shown when the server DID refuse, with an internal diagnostic we cannot attribute
      // to a cause (six refusals share one prefix). Names no cause on purpose: telling the
      // operator "ya hay piezas empacadas" on a shipped order is a false cause plus a
      // recovery that cannot work.
      request_refused_report:
        'No se pudo completar la acción. El servidor la rechazó por un motivo que no podemos mostrar aquí: repórtalo a Tecnología con el número de pedido.',
      in_review_last_confirmation_description: '¿Deseas mandar este pedido a revisión?',
    },
    fragile_notification: {
      title: 'Añade material de protección',
      description: 'Este pedido contiene producto frágil',
      fragile_label: 'Etiqueta Frágil',
    },
    recommended_package: {
      title: 'Empaque recomendado',
      text_1: 'Sólo si no viene ',
      text_2: 'caja cliente',
      text_3: ' en los injertos, utiliza:',
    },
    shipping_package_data: {
      title: 'Empaque utilizado',
      description: 'Registra cómo se enviará el paquete',
      package: 'Paquete',
      select_similar_package: 'Selecciona un paquete con medidas semejantes',
      shipping_method: 'Paquetería',
      search_placeholder: 'Escanea un código o selecciona un paquete',
      no_allowed_packages_for_store: 'No hay cajas permitidas para esta marca en este almacén. Avisa a ops para que revise "Cajas por marca".',
    },
    footer: {
      cancel: 'Cancelar',
      generate_label: 'Generar Guía',
      invalidate_previous_labels: 'Invalidar Guías Anteriores y Generar Guía',
      finish_order: 'Finalizar pedido',
      generate_shipping_labels: 'Generar etiquetas de envío',
      generate_label_confirm: '¿Deseas generar esta guía?',
      generating_label: 'Generando guía…',
      labels_invalidated: 'Se invalidarán todas las guías anteriores y se generarán nuevas guías. ¿Confirmas Proceder?',
    },
    view: {
      tote_or_unit_code_not_found: 'Tote o código único no encontrado. Revisa el código o avisa a tu supervisor.',
      unit_code_no_open_replenishment: 'Este código único no tiene un recibo abierto. Avisa a tu supervisor.',
      unit_code_on_multiple_orders: 'Este código único está en más de un pedido. Avisa a tu supervisor.',
      unit_code_product_has_expiration: 'Este producto no se puede empacar con su código único. Avisa a tu supervisor.',
      unit_code_unavailable: 'Este código único está bloqueado o ya fue asignado. Avisa a tu supervisor.',
      unit_code_format: 'Este código único no tiene el formato esperado. Revisa el código o avisa a tu supervisor.',
      unexpected_error: 'Ha ocurrido un error inesperado.',
      order_in_review: 'Este pedido está en revisión y no se puede empacar. Deja el tote como está y avisa a tu supervisor.',
      order_in_review_with_number: 'El pedido #{{order_number}} está en revisión y no se puede empacar. Deja el tote como está y avisa a tu supervisor.',
      order_canceled_in_review: 'Este pedido fue cancelado. Lleva el tote a la estación de revisión para vaciarlo.',
      order_canceled_in_review_with_number: 'El pedido #{{order_number}} fue cancelado. Lleva el tote a la estación de revisión para vaciarlo.',
      order_canceled_in_review_with_totes: 'El pedido #{{order_number}} fue cancelado. Lleva los totes {{totes}} a la estación de revisión para vaciarlos.',
      order_not_packing: 'La orden perteneciente a este tote no se encuentra en estatus Packing',
      order_not_found: 'No se encontró un pedido con ese producto.',
      generate_label_title: 'Generar Guía',
      generate_label_button: 'Generar Guía Agrupada',
      scan_tote_title: 'Escanea el tote o el código único y ajusta la cámara',
      scan_tote_label: 'Buscar tote o código único',
      scan_tote_placeholder: 'Escanea un tote o código único',
      multiple_orders: 'Este Tote contiene varios pedidos. Escanea un producto del Tote.',
      scan_product_title: 'Este Tote contiene varios pedidos. Escanea un producto del Tote.',
      scan_product_label: 'Buscar UPC ó SKU',
      scan_product_placeholder: 'Escanea un producto',
      tote_pending_title: 'Pendientes en este tote ({{count}})',
      tote_pending_scan_prompt: 'Escanea el siguiente producto físico del tote',
      tote_all_packed: 'Todos los pedidos de este tote están empacados. Escanea otro tote.',
      tote_pending_show: 'Ver productos',
      tote_pending_hide: 'Ocultar productos',
      tote_pending_in_review_badge: 'En revisión',
      tote_pending_in_review_count: '{{count}} en revisión',
      missing_information: 'Falta información en la orden',
      picking_not_completed: 'El picking de esta orden no se ha completado',
      shipping_method_no_multipackage: 'El método de envío seleccionado no permite multi-paquete',
      shipping_method_no_cod: 'El método de envío seleccionado no permite pago contra reembolso',
      next_order_for_product: 'Ir a la siguiente orden para este producto',
      invalidate_and_generate: 'Invalidar Guías Anteriores y Generar Guía',
      invalidate_confirm: 'Se invalidarán todas las guías anteriores y se generarán nuevas guías. ¿Confirmas Proceder?',
      generate_confirm: '¿Deseas generar esta guía?',
      product_not_in_order: 'Este producto no pertenece a la orden o ya ha sido revisado.',
      order_invoice_not_ready: 'La factura aún no está lista para este pedido. Aparta el pedido y vuelve a intentarlo más tarde.',
      order_notfis_not_ready: 'El NOTFIS aún no está listo para este pedido. Aparta el pedido y vuelve a intentarlo más tarde.',
      order_boleto_not_ready: 'El boleto aún no está listo para este pedido. Aparta el pedido y vuelve a intentarlo más tarde.',
      camera_preview_card_title: 'Tu cámara debe apuntar hacia la mesa de empaque',
      camera_preview_card_subtitle: 'Si en la imagen no se ven el tote y los productos, acomoda la cámara para asegurar una buena evidencia de empaque.',
    },
    label_pending: {
      title: 'Preparando la guía',
      subtitle: 'La paquetería ya aceptó el envío. Estamos descargando el PDF, normalmente tarda unos segundos. Se imprime sola en cuanto llegue.',
      still_working: 'Sigue descargando. No generes otra guía: esta ya está creada con la paquetería.',
      expired: 'No pudimos confirmar el estado de la guía. Vuelve a intentar generarla.',
      blue_express_large_shipment: {
        title: 'Generando las guías de Blue Express',
        subtitle:
          'Este envío tiene más de 100 bultos, así que Blue Express arma las guías en tandas de 100 y puede tardar un par de minutos. No cierres esta pantalla ni vuelvas a generar la guía: cada intento crea un envío nuevo en Blue Express. Se imprimen solas en cuanto estén listas.',
        still_working:
          'Blue Express sigue armando las guías. No cierres esta pantalla ni vuelvas a generar la guía: cada intento crea un envío nuevo en Blue Express.',
      },
      multipackage_switch: {
        title: 'Cambiando a un método que admite varios paquetes',
        subtitle:
          'El método de este pedido no genera una guía por paquete. Estamos eligiendo otro método de la marca que sí lo haga y generando las guías con él, lo que puede tardar unos momentos. No cierres esta pantalla ni vuelvas a generar la guía: se imprimen solas en cuanto estén listas.',
      },
    },
    camera_blocked_banner: {
      title: 'Cámara no detectada',
      default_message: 'No se pudo iniciar la grabación de video. Verifica que la cámara esté conectada y con permisos habilitados antes de generar la guía.',
      permission_denied_message: 'El acceso a la cámara fue bloqueado. Pulsa el botón para ver cómo habilitarlo en la configuración de tu navegador.',
      retry_button: 'Reintentar detección',
      permission_denied_cta: 'Ver cómo permitir cámara',
      detecting: 'Detectando cámara...',
    },
    camera_permission_instructions: {
      dialog_title: 'Permite el acceso a la cámara',
      intro: 'Sigue estos pasos en Chrome para habilitar la cámara y luego recarga la página.',
      step_1: 'Haz clic en el ícono de candado o controles del sitio en la barra de direcciones.',
      step_2: 'Busca "Cámara" y selecciona "Permitir".',
      step_3: 'Recarga la página con el botón de abajo.',
      browser_note: 'Estas instrucciones son para Google Chrome.',
      reload_button: 'Cerrar y recargar página',
      reload_warning: 'Al recargar se perderá el progreso del empaque actual.',
      close_aria: 'Cerrar',
    },
    camera_blocked_dialog: {
      title: 'No es posible empacar sin cámara',
      description: 'Este pedido requiere grabación de video para poder empacarlo. Verifica que la cámara esté conectada y con permisos habilitados.',
      instruction: 'No escanees productos ni continúes con el empaque hasta resolver el problema con la cámara.',
      retry_button: 'Reintentar detección',
      detecting: 'Detectando cámara...',
    },
    camera_mini_preview_title: 'Vista previa de cámara',
    camera_mini_preview_pill: {
      unavailable: 'Cámara no disponible',
      denied: 'Permite el acceso',
    },
    multi_box: {
      bulk_labels_notice: 'Con esta paquetería se generarán todas las guías. Pega cada una en la caja correspondiente.',
      panel_title: 'Paquetes del pedido',
      panel_subtitle_one: '{{count}} cerrada · una guía por caja',
      panel_subtitle_other: '{{count}} cerradas · una guía por caja',
      shipping_method_label: 'Paquetería',
      add_box: '+ Añadir otra caja',
      add_box_title: 'Añadir otra caja',
      box_label: 'PAQUETE {{n}}',
      box_closed_pill: 'Cerrada',
      no_empaque_hint: 'Selecciona el empaque que utilizarás para enviar este paquete',
      empaque_selected_prefix: 'Empaque seleccionado:',
      empaque_used: 'Empaque utilizado',
      pieces_packed: 'Piezas empacadas',
      pieces_one: '{{count}} pieza',
      pieces_other: '{{count}} piezas',
      show_more: 'Ver más',
      show_less: 'Ver menos',
      fragile_pill: 'Frágil',
      fragile_banner_title: 'Contiene producto frágil',
      fragile_banner_subtitle: 'Añade material de protección antes de cerrar',
      scan_at_least_one: 'Escanea al menos 1 pieza',
      scan_prompt: 'Escanea las piezas que se enviarán en este empaque.',
      inserts_only_prompt: 'Este pedido solo contiene injertos (no escaneables). Cierra la caja para continuar.',
      close_box: 'Cerrar caja',
      close_box_in_flight_label: 'Generando packing list…',
      close_box_in_flight_label_with_label: 'Generando guía…',
      delete_box: 'Eliminar caja',
      delete_box_disabled_has_items: 'Saca las piezas antes de eliminar la caja',
      delete_box_disabled_last: 'Debe quedar al menos una caja',
      delete_box_confirm_description: 'Esta caja tiene {{count}} piezas. Al eliminarla se devolverán al tote para que puedas reasignarlas a otra caja.',
      delete_box_confirm_yes: 'Sí, eliminar',
      print_packing_list: 'Imprimir packing list',
      print_shipping_label: 'Imprimir guía',
      print_invoice: 'Imprimir factura (NF-e)',
      packing_context_label: 'Estás empacando en',
      no_open_box_alert: 'No hay una caja abierta donde incluir el producto. Crea otra caja antes de escanear.',
      pick_empaque_first_alert: 'Selecciona el empaque del paquete antes de escanear piezas.',
      session_not_ready_alert:
        'La sesión de empaque aún no puede iniciar: el pedido está en «{{status}}». Reintentando automáticamente — vuelve a escanear en cuanto pase a packing.',
      reopen_box: 'Reabrir caja',
      reopen_box_hint: 'Reabrir caja para corregir cantidades o empaque',
      reopen_confirm_description:
        'La caja volverá a estado editable; su packing list se regenerará al cerrarla y, si tiene guía de transporte propia, esta se invalidará.',
      reopen_confirm_yes: 'Sí, reabrir',
      reopen_confirm_cancel: 'Cancelar',
      reopen_in_flight: 'Reabriendo caja…',
      delete_in_flight: 'Eliminando caja…',
      could_not_reopen_box: 'No se pudo reabrir la caja',
      reopen_not_available_yet: 'Reabrir caja aún no está disponible en este ambiente. Contacta a soporte.',
      reopen_session_concluded: 'No se puede reabrir: el pedido ya fue enviado.',
      bulk_add_hint: 'Agregar varias piezas de este SKU',
      bulk_add_disabled: 'La función de agregar piezas sin escanear está desactivada en este almacén',
      bulk_unscan_partial: 'Se quitaron {{unscanned}} de {{requested}} piezas (algunas no estaban en la caja).',
      finalizing: 'Procesando…',
      cannot_close_box_with_items: 'No se puede eliminar la Caja {{n}}: tiene piezas dentro.',
      cannot_close_session_with_items: 'No se puede cerrar la sesión: la Caja {{n}} tiene piezas. Sácalas o cierra la caja manualmente.',
      could_not_adjust_boxes: 'No se pudo ajustar las cajas en la sesión',
      could_not_open_box: 'No se pudo abrir la caja',
      could_not_start_session: 'No se pudo iniciar la sesión de empaque',
      could_not_register_unit: 'No se pudo registrar la pieza en la caja',
      could_not_unscan: 'No se pudo deshacer la pieza',
      could_not_change_empaque: 'No se pudo cambiar el empaque',
      could_not_close_box: 'No se pudo cerrar la caja',
      could_not_delete_box: 'No se pudo eliminar la caja',
      could_not_add_units: 'No se pudo agregar las piezas',
      could_not_finalize: 'No se pudo finalizar el pedido',
      // conclude (scenario A) refusals from the BUGS-8257 server gate. The label path
      // localizes the same packing_incomplete code through error_codes above; these are
      // the conclude wording ("antes de finalizar") and must exist in pt too.
      conclude_packing_incomplete: 'Aún hay piezas sin empacar. Escanéalas y colócalas en una caja antes de finalizar.',
      conclude_override_not_authorized:
        'La cantidad empacada no coincide con la requerida y tu rol no puede autorizar la excepción. Pide a un super admin que finalice.',
      pre_close_warning_one: 'Tienes {{count}} pieza en el tote sin asignar a una caja. ¿Continuar de todos modos?',
      pre_close_warning_other: 'Tienes {{count}} piezas en el tote sin asignar a una caja. ¿Continuar de todos modos?',
      close_last_box_pending_title: 'Cerrar la caja',
      close_last_box_pending_one: 'Queda {{count}} pieza sin empacar. Podrás continuar en otra caja o reabrir esta.',
      close_last_box_pending_other: 'Quedan {{count}} piezas sin empacar. Podrás continuar en otra caja o reabrir esta.',
      close_last_box_pending_confirm: 'Cerrar la caja',
      close_last_box_pending_cancel: 'Seguir empacando',
      tote_label: 'TOTE',
      per_box_format: '{{count}} × Paquete {{n}}',
      per_tote_format: '{{count}} × TOTE',
      remove_many_pieces_hint: 'Quitar varias piezas de este SKU',
      remove_one_piece: 'Quitar 1 pieza',
      bulk_remove_submit: 'Quitar',
      bulk_remove_in_flight: 'Quitando…',
      quantity_header: 'Cantidad',
      bulk_add_submit: 'Agregar',
      // Recommended package strip; keys mirror RecommendedPackageSection/constants.js.
      package_option_titles: {
        PARCEL_BAG: 'Bolsa',
        JIFFY_ENVELOPE: 'Sobre burbuja',
        CUBBO_BOX: 'Caja Cubbo',
        PACKAGELESS: 'Enviar sin empaque',
      },
      package_selection_titles: {
        0: 'Preferida',
        1: '2º opción',
        2: '3º opción',
        3: '4º opción',
        4: '5º opción',
      },
      container_scan_in_flight: 'Ese código ya se está procesando — espera antes de volver a escanear',
      address_frozen_after_labels: 'Ya se generaron las guías — la dirección quedó congelada en las etiquetas',
      active_box_label: 'Paquete {{n}}',
      bulk_add_skipped_already_packed: '{{n}} ya empacadas en otra caja',
      bulk_add_skipped_not_picked: '{{n}} sin stock PICKED',
      bulk_add_partial: 'Solo se agregaron {{packed}} de {{requested}} piezas',
      product_table: {
        title: 'Productos del pedido',
        subtitle: 'Escanea las piezas y colocalas dentro de la caja de envío.',
        open_box_title: 'Caja en proceso',
        show_closed_boxes: 'Ver cajas cerradas',
        closed_boxes_summary: '{{total}} en {{boxes}} cerradas',
        closed_box_title: 'Caja cerrada',
        hide_closed_boxes: 'Ocultar cajas cerradas',
        quantity_column: 'CANTIDAD',
        scanned_required: 'Escaneadas / Requeridas',
        packed_in_column: 'EMPACADO EN',
      },
      // Keyed by the backend error code; GenerateShipment.js spreads the whole object into
      // SCAN_ERROR_MESSAGES, so es and pt must hold the same codes.
      scan_errors: {
        box_not_open: 'La caja activa está cerrada — selecciona otra',
        unit_not_found: 'Código no pertenece a este pedido — revisa la etiqueta',
        unit_not_pickable: 'Esta unidad no está PICKED o no es de este pedido',
        unit_already_packed: 'Esta unidad o todas sus piezas ya están empacadas',
        packed_unit_not_in_box: 'Esa pieza no está en esta caja — revisa la caja correcta',
        unit_tracked_not_bulkable: 'Este producto requiere código por unidad — escanea cada pieza por separado',
        invalid_quantity: 'Cantidad inválida — usa un número mayor a 0',
        box_has_units: 'La caja tiene piezas — sácalas antes de cambiar el empaque',
        box_closed: 'La caja ya está cerrada — no se puede modificar',
        boxes_still_open: 'Aún hay cajas abiertas — ciérralas todas antes de finalizar',
        no_closed_boxes: 'No hay cajas cerradas para finalizar',
        box_carrier_label_missing: 'Una caja cerrada no tiene su etiqueta de envío — reintenta antes de finalizar',
        quality_check_failed: 'La cantidad empacada no coincide con la requerida',
        order_not_in_packing: 'El pedido ya fue enviado — no se puede modificar',
        box_not_closed: 'La caja debe estar cerrada primero',
        label_generation_failed: 'La paquetería no pudo generar la etiqueta — reintenta',
        shipping_preparation_failed: 'No se pudo aplicar la dirección — revisa los datos del destinatario',
        shipping_method_invalid: 'No se puede usar esta paquetería (pickup-only, click-and-collect o inexistente)',
        invoice_generation_failed: 'Falló la generación de la factura fiscal — reintenta',
        carrier_label_failed: 'La paquetería no generó la guía — reintenta',
        sale_invoice_missing: 'Falta la nota fiscal del pedido — escala a supervisor',
        invoice_contingency: 'Nota fiscal en contingencia — escala a supervisor',
        invoice_processing: 'Nota fiscal aún procesándose — reintenta en un momento',
        imei_required: 'Este producto requiere IMEI — captúralo antes de continuar',
        imei_duplicate: 'Este IMEI ya fue capturado en este pedido — revisa la unidad',
        imei_requires_individual_scan: 'Los productos con IMEI no se pueden agregar en bulk — escanéalos uno por uno',
        imei_missing: 'Una unidad con IMEI quedó sin capturar — escanea el IMEI faltante antes de cerrar la caja',
        container_has_foreign_products: 'El contenedor trae un producto que no pertenece a este pedido',
        container_product_not_picked: 'El contenedor trae un producto que no se pickeó para este pedido',
        container_exceeds_picked: 'El contenedor trae más piezas de las que faltan por empacar',
        container_lot_not_picked: 'El lote del contenedor no es el que se pickeó',
        container_lot_exceeds_picked: 'El contenedor excede las piezas pendientes de ese lote',
        container_requires_individual_scan: 'El contenedor trae productos con IMEI o código unitario — escanéalos pieza por pieza',
        container_already_scanned: 'Ese contenedor ya está en este pedido',
        container_empty: 'Ese contenedor no tiene contenido registrado — empaca las piezas una por una',
        container_holds_blocked_stock: 'El contenedor trae piezas que no pueden salir (retenidas, vencidas o sin acomodar) — empaca las buenas una por una',
        container_not_found: 'No hay ninguna caja con ese código — empaca las piezas una por una',
        box_template_invalid_item: 'La plantilla de esa caja está mal capturada — empaca las piezas una por una y avisa a soporte',
        container_ambiguous: 'Hay varias cajas con ese código y contenidos distintos — empaca por pieza',
        scan_needs_confirmation: 'Ese código es a la vez un producto y una caja — empaca pieza por pieza',
        pallet_ambiguous: 'Hay varias tarimas pickeadas con ese código y contenidos distintos — empaca caja por caja',
        container_not_picked_for_order: 'Ese contenedor está asignado a otro pedido',
      },
    },
    print_titles: {
      box_packing_list: 'Packing list — Paquete {{n}}',
      box_shipping_label: 'Etiqueta — Paquete {{n}}',
      box_invoice: 'Factura (NF-e) — Paquete {{n}}',
      shipping_documents: 'Imprimir Documentos de Envío',
      extra_shipping_labels: 'Imprimir Etiquetas Extras',
    },
    label_view: {
      bundle_count: 'Impresiones <bold>{{n}}</bold>',
      print_type: 'Tipo de impresión <bold>{{type}}</bold>',
      type_label: 'Etiqueta',
      type_document: 'Documento',
      bundle_prepare_failed: 'No se pudo preparar {{failed}} de {{total}} impresiones.',
      print_failed: 'No se pudo imprimir la etiqueta desde este visor.',
      preview_failed: 'No se pudo previsualizar la etiqueta.',
      open_in_new_tab: 'Abrir la etiqueta en una nueva pestaña',
      opened_in_new_tab:
        'La etiqueta se abrió en una pestaña nueva. Si el navegador la bloqueó, haz click en el enlace de abajo e imprime desde ahí (Ctrl+P / ⌘+P).',
      cancel: 'Cancelar',
      print: 'Imprimir',
    },
  },
  packing_audit: {
    banner: {
      default: 'ATENCIÓN: Este pedido está en AUDITORÍA. No generes guía sin autorización.',
      critical: 'CLIENTE CRÍTICO — AUDITORÍA OBLIGATORIA. ¡Revisa cada ítem con atención redoblada!',
    },
    questions: {
      missing_items: {
        title: '¿Faltaron productos en el tote?',
        quantity_prompt: '¿Cuántos productos faltaron?',
      },
      extra_items: {
        title: '¿Sobraron productos en el tote?',
        quantity_prompt: '¿Cuántos productos sobraron?',
      },
      debris_present: {
        title: '¿Había basura o ítems extraños en el tote?',
      },
      yes: 'Sí',
      no: 'No',
      submit_error: 'No se pudieron enviar las respuestas. Inténtalo de nuevo.',
    },
    answered_confirmation: '✓ Auditoría respondida',
    label_blocked: {
      title: 'Auditoría pendiente',
      message: 'Las preguntas de la auditoría de empaque deben responderse antes de generar la guía. La página se actualizó.',
    },
  },
  generate_shared_label: {
    cancel: 'Cancelar',
    generate_label: 'Generar Guía',
    generate_label_confirm: '¿Deseas generar esta guía?',
    yes: 'Si',
    print_invoice: 'Imprimir Factura Comercial',
    print_invoice_brazil: 'Imprimir Factura Brasil',
    order_details: 'Detalle del pedido',
    on_collapsed_text: 'Ver detalle',
    on_not_collapsed_text: 'Ocultar detalle',
    address: 'Dirección',
    address_2: 'Apartamento, local, colonia, etc. (opcional)',
    city: 'Ciudad',
    province: 'Estado / Provincia',
    zip_code: 'Código Postal',
    grouped_orders: 'Ordenes Agrupadas',
    scan_all_orders: 'Escanea todas las ordenes que se enviarán',
    scan_order_placeholder: 'Escanea la etiqueta del pedido',
    used_package: 'Empaque utilizado',
    register_package_shipping: 'Registra cómo se enviará el paquete',
    package: 'Empaque',
    shipping_method: 'Método de Envío',
    select_shipping_method_error: 'Por favor seleccione el método de envío',
    error_fetching_shipping_methods: 'Error al cargar los métodos de envío. Intente de nuevo.',
  },
  top_menu: {
    warehouses: 'Almacenes',
    billing: 'Billing',
  },
  sidebar: {
    cambiar_almacen: 'Cambiar almacén',
    sign_out: 'Cerrar sesión',
    logout_error: 'Error al cerrar sesión',
    expand_to_logout: 'Expandir para cerrar sesión',
  },
  select_warehouse: {
    subtitle: 'Selecciona un almacén para continuar',
    error_loading: 'Error al cargar almacenes',
    no_warehouses: 'Tu cuenta no tiene almacenes asignados. Contacta a un administrador para que te los asigne.',
  },
  navegation_routes: {
    warehouses: 'Almacenes',
    billing: 'Billing',
    dashboard: 'Dashboard',
    pending: 'Pendientes',
    pick_and_pack: 'Pick & Pack',
    boxes_to_break: 'Cajas por romper',
    shipments: 'Envíos',
    generate_labels: 'Generar Guías',
    returns: 'Retornos',
    inventory: 'Inventario',
    load: 'Recibo',
    inbound_appointments: 'Citas de recibo',
    cubbitos: 'Cubbitos',
    pending_prints: 'Impresiones pendientes',
    romaneios: 'Manifiestos de salida',
    proof_video_coverage: 'Cobertura de video',
    claims: 'Disputas',
    maquilas: 'Maquilas',
    operators: 'Operadores',
    natura_replenishments: 'Recibos Natura',
    natura_operations: 'Natura Operaciones',
    natura_ops_create_order: 'Crear pedido',
    natura_ops_picking: 'Reenviar confirmación de picking',
    natura_ops_nota_fiscal: 'Nota Fiscal',
    natura_ops_deposit_transfer: 'Transferencia de materiales',
    natura_ops_confirmation_resend: 'Reenviar confirmación de remesa',
    natura_ops_notfis_upload: 'Carga de NOTFIS',
    shipping_packages: 'Cajas',
    lastmile_shipping_methods: 'Métodos de envío',
    dispatch_schedules: 'Horarios de despacho',
    automated_coverage_deactivations: 'Coberturas auto-desactivadas',
    uber_batches: 'Lotes Uber',
    configurations: 'Configuraciones',
    cycle_counts: 'Conteos Ciclicos',
    workforce: 'Fuerza laboral',
    fulfillment_errors: 'Errores de fulfillment',
  },
  natura_operations: {
    create_order: {
      title: 'Crear pedido manualmente',
      instructions_heading: 'Cómo usar esta página',
      instructions_step1: 'Solicita al equipo de Natura el IDoc no-integrado (transacción WE02/WE05, exportar como "Salida dinámica de lista").',
      instructions_step2: 'Guarda el archivo .txt o .csv en tu computadora.',
      instructions_step3: 'Súbelo abajo. El sistema lo parseará, mostrará un preview y creará el pedido en Cubbo.',
      instructions_step4: 'Confirma con el equipo que el pedido aparece en "Pendientes".',
      warning: 'Usa este recurso solo para IDocs corruptos o pedidos manuales.',
      file_picker_hint: 'Suelta el archivo aquí o haz clic para buscar — .txt, .csv hasta 5MB',
      submit: 'Subir y crear pedido',
      result_success: 'Pedido {{delivery_number}} creado',
      result_partial: 'Pedido {{delivery_number}} creado con avisos',
      result_failed: 'Falló la creación del pedido',
      result_label_customer: 'Cliente',
      result_label_items: 'Items',
      result_label_shipping_method: 'Método de envío',
      submit_loading: 'Cargando…',
      view_pending: 'Ver en Pendientes',
    },
    nfe_status: {
      title: 'Nota Fiscal — consulta de estado',
      instructions_heading: 'Cómo usar esta página',
      instructions_step1: 'Pega hasta 25 números de pedido Natura abajo (uno por línea, coma o espacio).',
      instructions_step2: 'Haz clic en "Consultar" — buscamos el estado de la NF-e de cada pedido en el SAP de Natura.',
      instructions_step3: 'La tabla muestra el estado, acción y mensaje devuelto por pedido. Haz clic en una fila para ver el detalle.',
      warning_wait: 'La consulta puede tardar hasta 90 segundos para 25 pedidos. No cierres la página mientras carga.',
      input_count: '{{count}} pedidos · máx. {{max}}',
      input_too_many: 'Máximo de {{max}} pedidos por consulta.',
      submit: 'Consultar estado',
      submit_loading: 'Verificando {{count}} pedidos…',
      summary: '{{total}} verificados · {{ok}} OK · {{errored}} con error · {{not_found}} no encontrados',
      col_order: 'Pedido',
      col_status: 'Estado',
      col_action: 'Acción',
      col_description: 'Descripción',
      col_message: 'Mensaje',
      outcome_not_found_short: 'No encontrado',
      outcome_errored_short: 'Error',
      error_generic: 'No fue posible completar la consulta. Inténtalo de nuevo en unos instantes.',
      retry: 'Reintentar',
      row_aria_label: 'Ver detalles de la NF-e del pedido {{order_number}}',
      modal_raw_label: 'Detalles de la respuesta',
      close: 'Cerrar',
    },
    deposit_transfer: {
      title: 'Transferencia de materiales',
      instructions_heading: 'Cómo usar esta página',
      instructions_step1: 'Elige el origen de los materiales: pedido REM, tienda + ubicación, o manual.',
      instructions_step2: 'Selecciona el tipo, motivo y los depósitos de origen y destino del movimiento.',
      instructions_step3: 'Genera el preview, revisa los lotes y confirma para reportar el movimiento al SAP de Natura.',
      warning: 'Cada confirmación reporta el movimiento al SAP de Natura. Revisa el preview antes de confirmar.',

      step1_heading: '1. Origen',
      step2_heading: '2. Parámetros del movimiento',
      step3_heading: '3. Preview',
      step4_heading: 'Resultado',

      mode_label: 'Modo',
      mode_rem_order: 'Pedido REM',
      mode_store_location: 'Tienda + ubicación',
      mode_manual: 'Manual',

      rem_order_number: 'Número del pedido REM',
      store_id: 'ID de la tienda',
      warehouse_location: 'Ubicación en el almacén',
      sku: 'SKU',
      lot_code: 'Lote',
      quantity: 'Cantidad',
      store_location_lost_note: 'Solo se transferirán las unidades perdidas (LOST) de esta ubicación.',
      statuses_label: 'Estados de las unidades',
      statuses_empty: 'Ningún estado disponible para filtrar.',
      statuses: {
        ACTIVE: 'Activo',
        RESERVED: 'Reservado',
        DAMAGED: 'Dañado',
        EXPIRED: 'Vencido',
        HOLDED: 'En espera',
        LOST: 'Perdido',
      },
      options_load_failed: 'No fue posible cargar las opciones (tipos de movimiento y depósitos). Recarga la página.',

      move_type: 'Tipo de movimiento',
      move_reason: 'Motivo del movimiento',
      source_deposit: 'Depósito de origen',
      destination_deposit: 'Depósito de destino',
      select_placeholder: 'Selecciona…',

      generate_preview: 'Generar preview',
      generating_preview: 'Generando preview…',
      confirm: 'Confirmar',
      confirming: 'Confirmando…',
      cancel: 'Cancelar',
      retry: 'Reintentar',

      preview_summary: '{{lot_count}} lotes · {{total_units}} unidades · {{skipped_units}} ignoradas',
      preview_statuses: 'Estados: {{statuses}}',
      skipped_heading: 'Ítems ignorados',
      skipped_no_lot: 'Sin lote ({{quantity}} unidades): {{detail}}',
      skipped_generic: '{{reason}} ({{quantity}} unidades): {{detail}}',

      finalize_checkbox: 'Finalizar proceso en Cubbo después de la transferencia',
      finalize_warning: 'Envía el pedido / unidades y registra el cobro. No se puede deshacer automáticamente.',
      finalize_warning_discard: 'Descarta las unidades perdidas movidas (las elimina del stock). No se puede deshacer automáticamente.',

      cap_message: 'Más de {{limit}} lotes ({{given}}). Reduce la selección o usa el modo Manual.',
      empty_message: 'Ningún lote para transferir.',
      no_transferable_lots: 'Ningún lote transferible en el preview (sin lot_id). No hay nada para confirmar.',
      error_generic: 'No fue posible completar la operación. Inténtalo de nuevo en unos instantes.',
      processing_in_background: 'Enviando los movimientos a la SAP de Natura… {{percentage}}% completado. Puedes dejar esta pantalla abierta.',
      result_unreadable: 'Los movimientos fueron enviados y están siendo procesados, pero esta pantalla no pudo leer el resultado. No repitas la operación.',

      col_sku: 'SKU',
      col_lot: 'Lote',
      col_quantity: 'Cant',
      col_source_location: 'Ubicación',
      col_status: 'Estado',
      col_message: 'Mensaje',
      col_finalize: 'Finalización',

      result_summary: '{{total}} procesados · {{ok}} OK · {{errored}} con error · {{finalized}} finalizados · {{units_discarded}} descartadas',
      outcome_ok: 'OK',
      outcome_errored: 'Error',
      finalize_finalized: 'Finalizado',
      finalize_discarded: 'Descartado ({{count}})',
      finalize_skipped: 'Ignorado ({{reason}})',
      finalize_errored: 'Error en la finalización',
      finalize_none: '—',
    },
    // Usado por los componentes compartidos de Operaciones Natura (CopyButton, JsonBlock).
    shared: {
      copy: 'Copiar',
      copied: 'Copiado',
      copy_failed: 'No se pudo copiar',
      empty_body: 'Sin contenido.',
    },
    picking: {
      title: 'Reenviar confirmación de picking (WP09)',
      instructions_heading: 'Cómo usar esta página',
      instructions_step1: 'Ingresa el número de remesa de Natura (10 dígitos) o el id interno del pedido y genera el payload. Generarlo no envía nada.',
      instructions_step2: 'Compara cada línea con lo que realmente se separó y se embarcó. Línea correcta: déjala como está.',
      instructions_step3:
        'Línea con SKU o lote equivocado, pero cuya pieza sí se embarcó: usa Corregir y edita el campo equivocado. Corregir cambia la línea, no la elimina.',
      instructions_step4:
        'Marca para quitar solo la línea cuya pieza no se embarcó. Quitar una línea que sí se embarcó confirma menos de lo que salió, y la factura sale corta.',
      instructions_step5:
        'Reenvía y adjunta el bloque de evidencia al ticket de Natura. Si vuelve el mismo error después del ajuste de Natura, hay que escalar — no todo error de facturación se resuelve reenviando.',
      warning: 'El reenvío envía realmente el WP09 al SAP de Natura. Generar el payload no envía nada.',

      mode_label: 'Buscar el pedido por',
      mode_order_number: 'Número de remesa (Natura)',
      mode_order_id: 'Id interno del pedido (Cubbo)',
      field_label_order_number: 'Número de remesa',
      field_label_order_id: 'Id del pedido',
      field_placeholder_order_number: '9001234567',
      field_placeholder_order_id: '1234567',
      field_hint_order_number: 'El número que aparece en el ticket de Natura. Los ceros a la izquierda se ignoran.',
      field_hint_order_id: 'El id del pedido en Cubbo.',

      generate_preview: 'Generar payload',
      generating_preview: 'Generando…',
      resend: 'Reenviar a Natura',
      resend_without_lines: 'Reenviar sin {{lines}} línea(s)',
      resending: 'Reenviando…',
      cancel: 'Cancelar',
      retry: 'Intentar de nuevo',

      lines_heading: 'Líneas del payload',
      lines_explanation: 'Una entrada por línea y lote. Quitar una línea quita todos los lotes reportados en ella — es lo que recibe Natura.',
      lines_summary: 'Se enviarán {{remaining}} de {{total}} línea(s).',
      correct_line: 'Corregir',
      column_sku: 'SKU',
      added_heading: 'Líneas corregidas',
      added_explanation: 'Estas líneas se enviarán en lugar de las que quitaste. El número de línea viene del payload y no cambia.',
      added_sku_aria: 'SKU de la línea {{line}} (lote de origen {{source}})',
      added_batch_aria: 'Lote de la línea {{line}} (lote de origen {{source}})',
      added_quantity_aria: 'Cantidad de la línea {{line}} (lote de origen {{source}})',
      added_discard: 'Descartar',
      added_lot_caution:
        'El lote debe haber sido informado a Natura en el WP10 para ese SKU y depósito. Si no, la factura se rechaza después, aunque el WP09 responda 200.',
      resend_with_corrections: 'Reenviar con {{lines}} línea(s) corregida(s)',
      resend_with_corrections_and_removals: 'Reenviar con {{corrections}} línea(s) corregida(s) y {{lines}} quitada(s)',
      unpaired_badge: 'sin quitar',
      unpaired_heading: 'Estas líneas se agregaron sin quitar la original: {{lines}}',
      unpaired_explanation: 'Marca la línea correspondiente para quitarla. Si no, Natura recibiría la misma línea dos veces, y el envío es rechazado.',
      rejection_free_line_not_supported:
        'La línea corregida no se quitó en este mismo reenvío, así que se confirmaría dos veces. Marca la línea correspondiente para quitarla y reenvía.',
      rejection_invalid_added_entry: 'Una de las líneas corregidas está incompleta o inválida.',
      rejection_unknown_sku: 'El SKU indicado no existe en esta tienda, así que no tiene código de material para enviar.',
      prior_sends_warning: 'Este pedido ya tuvo {{count}} confirmación(es) de picking enviada(s) a Natura.',
      prior_sends_last: 'Último envío el {{at}}.',
      prior_sends_explanation: 'Reenviar puede generar una segunda baja en SAP para la misma remesa. Confirma con Natura si la primera no llegó.',
      column_remove: 'Quitar',
      column_deliv_item: 'Línea',
      column_material: 'SKU',
      column_batch: 'Lote',
      column_quantity: 'Cant',
      column_flags: 'Indicadores',
      remove_line_aria: 'Quitar la línea {{line}} del reenvío',
      lot_count: '{{lots}} lotes',

      error_generic: 'No se pudo completar la operación.',
      delivery_unknown: 'No sabemos si llegó al SAP.',
      delivery_unknown_explanation: 'La solicitud salió de Cubbo, pero no recibimos respuesta a tiempo.',
      unknown_delivery_detail: 'Consulta con Natura antes de reenviar — un nuevo envío puede duplicar la confirmación.',
      delivery_delivered: 'Llegó al SAP.',
      delivery_delivered_explanation: 'Natura recibió y respondió la solicitud.',
      delivery_not_delivered: 'No llegó al SAP.',
      delivery_not_delivered_explanation: 'No se envió nada, así que es seguro intentar de nuevo.',

      outcome_accepted: 'Natura aceptó la confirmación de picking.',
      outcome_natura_refused: 'Natura recibió la confirmación y la rechazó.',
      outcome_natura_no_response: 'Natura no respondió.',
      outcome_natura_auth_failed: 'Falla de autenticación con Natura — no se envió nada.',

      rejection_order_not_found: 'No se encontró ningún pedido en las tiendas Natura a las que tienes acceso.',
      rejection_missing_identifier: 'Ingresa el número de remesa o el id del pedido.',
      rejection_not_natura_order: 'Este pedido no es de una integración Natura, así que no tiene payload de WP09.',
      rejection_qa_store_skipped: 'Esta es una tienda de QA de Natura. El payload se puede consultar, pero el reenvío está bloqueado.',
      rejection_lock_unavailable: 'No se pudo garantizar que no haya otro reenvío en curso, así que no se envió nada.',
      rejection_circuit_open: 'La integración de Natura está suspendida temporalmente tras fallas repetidas. No se envió nada; intenta en unos minutos.',
      rejection_ambiguous_order_number: 'Este número de remesa corresponde a más de un pedido. Elige cuál.',
      rejection_resend_in_progress: 'Ya hay un reenvío en curso para este pedido.',
      rejection_payload_build_failed: 'No se pudo armar el payload de este pedido.',
      rejection_integration_unusable: 'La integración de Natura de esta tienda no está utilizable.',
      rejection_payload_changed: 'El payload cambió desde la última consulta. Genera el payload de nuevo antes de reenviar.',
      rejection_unknown_deliv_items: 'Alguna de las líneas marcadas ya no está en el payload. Genera el payload de nuevo.',
      rejection_empty_payload: 'Quitar todas las líneas no deja nada por confirmar.',
      retry_after: 'Intenta de nuevo en hasta {{seconds}} segundos.',
      qa_store_notice: 'Esta es una tienda de QA de Natura. El payload se puede consultar, pero el reenvío está bloqueado.',

      copy_for_ticket: 'Copiar todo para el ticket',
      request_heading: 'Payload enviado',
      response_heading: 'Respuesta de Natura',
      response_empty: 'Natura no devolvió cuerpo en la respuesta.',

      field_order_id: 'Id del pedido',
      field_order_number: 'Número de remesa',
      field_status: 'Estado del pedido',
      field_store: 'Tienda',
      field_path: 'Endpoint',
      field_delivery: 'Llegó al SAP',
      field_removed_lines: 'Líneas quitadas',
      no_lines_removed: 'ninguna',
      lot_unknown_flag: '(lote no informado en el WP10)',
      use_this_one: 'Usar este',

      check_nfe_status: 'Consultar estado NF-e',
      checking_nfe_status: 'Consultando…',
      nfe_status_heading: 'Estado de la NF-e en Natura (WP21)',
      nfe_status_unavailable: 'No se pudo consultar el estado de la NF-e.',
      nfe_status_code: 'Código',
      nfe_status_description: 'Descripción',
      nfe_status_action: 'Acción',
      nfe_status_message: 'Mensaje de Natura',
    },
    notfis_upload: {
      title: 'Carga de NOTFIS',
      instructions_heading: 'Cómo usar esta página',
      instructions_step1: 'Usa esta página cuando Natura confirme que envió el NOTFIS pero el pedido en Cubbo sigue sin los datos de transporte.',
      instructions_step2:
        'Pide a Natura el archivo NOTFIS del pedido. Sirve tanto el .gz que envía la transportadora como el archivo de texto ya descomprimido.',
      instructions_step3: 'Sube el archivo abajo. El sistema lo lee en el momento y dice a qué pedido se aplicó.',
      instructions_step4: 'Lee el resultado antes de salir de la página: dice si el NOTFIS entró y, cuando no entró, qué hacer.',
      file_picker_hint: 'Suelta el archivo aquí o haz clic para buscar — .gz o texto, hasta 4MB',
      submit: 'Subir NOTFIS',
      submit_loading: 'Procesando…',
      result_label_file: 'Archivo guardado como',
      result_label_layout: 'Tipo',
      result_compressed: 'comprimido por el sistema',
      layout_transport: 'Remesa',
      layout_return: 'Devolución',
      outcome_applied: '✓ NOTFIS aplicado al pedido {{order_number}}',
      outcome_order_not_found: 'No se encontró ningún pedido para este NOTFIS',
      outcome_not_applied: 'Archivo guardado, pero no se aplicó nada',
      outcome_processing_error: 'Archivo guardado, pero la lectura falló',
      next_applied: 'Revisa los datos de transporte en el pedido. Nada más que hacer aquí.',
      next_order_not_found:
        'El número de remesa de este archivo no existe en Cubbo. Confirma con Natura cuál es el pedido antes de subirlo otra vez — subir el mismo archivo de nuevo da el mismo resultado.',
      next_not_applied:
        'El tipo de pedido dentro del archivo no lo maneja el sistema. El archivo sigue en la fila y se releerá automáticamente; avisa a ingeniería con el nombre del archivo si nada cambia.',
      next_processing_error:
        'El archivo sigue en la fila y se releerá automáticamente en unos minutos. Si el error se repite, avisa a ingeniería con el nombre del archivo y el mensaje de arriba.',
      error_no_file: 'Elige un archivo antes de subir.',
      error_empty_file: 'El archivo está vacío.',
      error_file_too_large: 'El archivo supera los 4MB.',
      error_invalid_file_name: 'Nombre de archivo inválido.',
      error_invalid_gzip: 'El archivo .gz está corrupto o no es un .gz. Pide el archivo de nuevo a Natura.',
      error_uncompressed_too_large: 'El contenido del archivo supera los 4MB descomprimido. Confirma que es el NOTFIS del pedido y no otro archivo.',
      error_not_a_notfis:
        'Este archivo no es un NOTFIS completo — falta la línea que identifica el pedido o el número de remesa. Confirma con Natura que enviaron el archivo correcto.',
      error_unsupported_order_type: 'El tipo de pedido dentro de este archivo no lo maneja el sistema. Envía el archivo a ingeniería.',
      error_already_pending: 'Ya existe un archivo con este nombre en la fila, aún sin procesar. Espera unos minutos o renombra el archivo antes de subirlo.',
      error_upload_failed: 'No se pudo guardar el archivo. Inténtalo de nuevo; si se repite, avisa a ingeniería.',
    },
    confirmation_resend: {
      title: 'Reenviar confirmación de remesa',
      instructions_heading: 'Cómo usar esta página',
      instructions_step1: 'Ingresa el número de remesa que Natura dice no haber recibido, o el ID de la remesa en Cubbo.',
      instructions_step2: 'Haz clic en "Generar payload" — armamos lo que se enviaría, sin llamar al SAP de Natura.',
      instructions_step3:
        'Revisa el payload. Si necesitas la respuesta de Natura como evidencia, haz clic en "Reenviar a Natura" y copia ambos bloques para el ticket.',
      warning: 'El reenvío no modifica la remesa: no dispara ajustes de inventario, ni confirmación de recepción, ni backorders.',

      mode_label: 'Buscar por',
      mode_external_reference: 'Número de Natura',
      mode_replenishment_id: 'ID de Cubbo',
      field_label_external_reference: 'Número de remesa en Natura',
      field_placeholder_external_reference: '0081234567',
      field_hint_external_reference: 'El número que aparece en el ticket de Natura. Los ceros a la izquierda son opcionales.',
      field_label_replenishment_id: 'ID de la remesa en Cubbo',
      field_placeholder_replenishment_id: '41522',
      field_hint_replenishment_id: 'El ID interno. Úsalo cuando el número de Natura corresponda a más de una remesa.',

      generate_preview: 'Generar payload',
      generating_preview: 'Armando payload…',
      resend: 'Reenviar a Natura',
      resending: 'Reenviando…',
      resend_again: 'Reenviar de nuevo',
      cancel: 'Cancelar',
      retry: 'Intentar de nuevo',
      error_generic: 'No se pudo completar la operación. Intenta de nuevo en unos instantes.',
      unknown_delivery_detail:
        'La solicitud salió de Cubbo, pero no recibimos respuesta a tiempo. Consulta con Natura antes de reenviar — el reenvío de abajo sigue disponible.',
      qa_store_notice: 'Esta es una tienda de QA de Natura. El payload se puede consultar, pero el reenvío está bloqueado.',

      copy_for_ticket: 'Copiar todo para el ticket',

      request_heading: 'Payload enviado',
      response_heading: 'Respuesta de Natura',
      response_empty: 'Natura no devolvió cuerpo en la respuesta.',

      field_replenishment_id: 'ID de la remesa',
      field_external_reference: 'Número de remesa',
      field_store: 'Tienda',
      field_confirmed_at: 'Confirmada el',
      field_path: 'Endpoint',
      field_delivery: 'Entrega al SAP',
      never_confirmed: 'Nunca confirmada',

      delivery_delivered: 'Llegó al SAP.',
      delivery_delivered_explanation: 'Natura recibió y procesó la solicitud — lo que volvió es su respuesta.',
      delivery_not_delivered: 'No llegó al SAP.',
      delivery_not_delivered_explanation: 'La solicitud no salió de Cubbo, así que se puede reenviar sin riesgo.',
      delivery_unknown: 'No sabemos si llegó al SAP.',
      delivery_unknown_explanation: 'No hubo respuesta dentro del tiempo límite. Confirma con Natura antes de cerrar el ticket.',

      outcome_accepted: 'Natura aceptó la confirmación',
      outcome_natura_refused: 'Natura rechazó la confirmación',
      outcome_natura_no_response: 'Natura no respondió',
      outcome_natura_auth_failed: 'Falló la autenticación con Natura',

      rejection_replenishment_not_found: 'No se encontró ninguna remesa con ese identificador en las tiendas Natura a las que tienes acceso.',
      rejection_missing_identifier: 'Ingresa el número o el ID de la remesa.',
      rejection_no_channel_integration: 'Esta tienda no tiene integración Natura configurada.',
      rejection_qa_store_skipped: 'Esta es una tienda de QA de Natura, así que no se envió nada.',
      rejection_not_completed: 'La remesa aún no está completada (COMPLETED), así que no hay confirmación que reenviar.',
      rejection_return_replenishment_unsupported: 'Las remesas de devolución siguen otro flujo y no tienen confirmación WP15 que reenviar.',
      rejection_lock_unavailable: 'No se pudo garantizar que no haya otro reenvío en curso, así que no se envió nada. Intenta de nuevo en unos instantes.',
      rejection_circuit_open: 'La integración de Natura está suspendida temporalmente tras fallas repetidas. No se envió nada; intenta en unos minutos.',
      rejection_ambiguous_external_reference: 'Ese número corresponde a más de una remesa. Elige abajo cuál de ellas.',
      rejection_resend_in_progress: 'Ya hay un reenvío en curso para esta remesa.',
      rejection_payload_build_failed: 'No se pudo armar el payload de esta remesa.',
      rejection_integration_unusable: 'La integración Natura de esta tienda está inactiva o le faltan las credenciales de WP15.',

      retry_after: 'Intenta de nuevo en hasta {{seconds}} segundos.',
      use_this_one: 'Usar esta',
    },
    coming_soon: 'Próximamente',
  },
  table_paginator: {
    page_by_page: 'por página',
    page: 'página',
    of: 'de',
    total_elements: 'elementos totales',
    previous: 'Anterior',
    next: 'Siguiente',
  },
  list_warehouses: {
    warehouses: 'Almacenes',
    empty_table_text: 'No hay almacenes que mostrar.',
    headers: {
      warehouse: 'Almacén',
      address: 'Dirección',
      status: 'Estado',
      country: 'País',
      created_at: 'Creada',
    },
  },
  home: {
    pending_orders: 'Pedidos Pendientes',
    pending: 'Pendientes',
    processing_orders: 'Pedidos en Procesando',
    processing: 'Procesando',
    waiting_pick_up_orders: 'Pedidos en Esperando Recolección',
    waiting_pick_up: 'Esperando Recolección',
    no_stock_orders: 'Pedidos Sin Stock',
    no_stock: 'Sin Stock',
    missing_info_orders: 'Pedidos Falta de Información',
    missing_info: 'Falta de Información',
  },
  pickability: {
    status: {
      FULLY_PICKABLE: 'Sí',
      PARTIALLY_PICKABLE: 'Sí, incompleto',
      NOTHING_PICKABLE: 'No',
    },
    go_to_break: 'Ir a Cajas por romper',
    breakdown: {
      pickable: 'Pickeable',
      blocked: 'Por romper',
      missing: 'Sin stock',
    },
  },
  list_orders: {
    pending_orders: 'Pedidos Pendientes',
    empty_table_text: 'No hay pedidos que mostrar.',
    assign_orders: 'Asignar Pedidos',
    store_search_placeholder: 'Buscar: -A, B',
    area_search_placeholder: 'Buscar: -A, B',
    order_number_search_placeholder: 'Buscar orden',
    city_search_placeholder: 'Buscar comuna',
    state_search_placeholder: 'Buscar región',
    headers: {
      store: 'Tienda',
      area: 'ÁREA',
      products: 'Productos',
      pickability: '¿Es pickeable?',
      max_packing_time: 'Empacar antes de',
      order_number: 'Nº DE ORDEN',
      city: 'Comuna',
      state: 'Región',
      channel_name: 'Canal',
      shipping_type: 'Tipo de envío',
      shipping_method: 'MÉTODO DE ENVÍO',
      same_day: 'Mismo día',
      standard: 'Estándar',
      store_search_help_1: 'Para buscar más de una tienda usa "," Ej: Levis, Dossier',
      store_search_help_2: 'Para omitir algunas tiendas usa "-" EJ: -Levis, -Dossier',
      area_search_help_1: 'Para buscar más de un área usa "," Ej: A, B',
      area_search_help_2: 'Para omitir algunas áreas usa "-" EJ: -A, -B',
      order_number_search_help: 'Para buscar múltiples órdenes usa "," Ej: ORD-001, ORD-002',
      city_search_help: 'Para buscar múltiples comunas usa "," Ej: Providencia, Las Condes',
      state_search_help_1: 'Para buscar múltiples regiones usa "," Ej: Metropolitana, Valparaíso',
      state_search_help_2: 'Para omitir algunas regiones usa "-" EJ: -Metropolitana, -Valparaíso',
    },
    actions: {
      see_order: 'Ver orden',
      generate_shipment: 'Generar Guía',
      pick_pieces: 'Pickear piezas',
    },
    rem_packing_time: {
      to_be_agreed: 'A convenir',
      set: 'Definir',
      dialog_title: 'Definir fecha límite de empaque — {{order_number}}',
      dialog_description: 'Remoción de más de 2000 piezas: define la fecha acordada con la marca. Esta fecha solo puede definirse una vez.',
      confirm: 'Guardar',
      cancel: 'Cancelar',
      saving: 'Guardando...',
      error: 'No se pudo guardar la fecha. Verifica que no haya sido definida ya y que administras este almacén.',
      error_invalid_date: 'Fecha inválida o en el pasado.',
    },
  },
  list_processing_orders: {
    orders: 'Pedidos',
    title: 'Pedidos Procesando',
    generate_shipments: 'Generar Guías',
    generate_shared_shipment: 'Generar Guía Agrupada',
    reassign_picker: 'Reasignar Picker',
    reassign_picker_in_review_tooltip: 'Este pedido está en revisión. Deshaz la revisión antes de reasignar el picker.',
    reassign_picker_tooltip: 'Selecciona solamente órdenes en estado Picking ó Procesando',
    empty_table_text: 'No hay pedidos que mostrar.',
    pick_all_success: 'Orden pickeada correctamente',
    store_search_placeholder: 'Buscar: -A, B',
    area_search_placeholder: 'Buscar: -A, B',
    partial_fulfillment: {
      confirm_title_single: 'Enviar Parcialmente 1 Pedido',
      confirm_description_single: '¿Estás seguro de que quieres enviar este pedido parcialmente?',
      confirm_label: 'Confirmar',
      cancel_label: 'Cancelar',
      close_label: 'Cerrar',
      loading_title: 'Procesando Envío Parcial',
      loading_description: 'Espera mientras procesamos el envío parcial del pedido...',
      error_missing_stock_title: 'Al pedido le faltan piezas asignadas',
      error_missing_stock_description:
        'A este pedido le faltan piezas asignadas y no se puede continuar desde aquí. Usa Revertir Picking en la handheld, en la pantalla del tote, para regresarlo al inicio.',
      error_fiscal_block_title: 'Factura fiscal aprobada',
      error_fiscal_block_description:
        'Este pedido ya tiene una factura (NF-e) aprobada. Es necesario regenerar la factura antes de poder enviarlo parcialmente.',
      error_would_cut_container_title: 'El envío parcial partiría un contenedor',
      error_would_cut_container_description:
        'Para enviar parcialmente este pedido habría que sacar piezas de un contenedor y dejar el resto dentro, y eso no se puede hacer en el almacén. Usa Revertir Picking en la handheld, en la pantalla del tote, para regresar el pedido completo al inicio junto con sus cajas y tarimas.',
      error_containers_not_supported_title: 'Este pedido tiene piezas en cajas o tarimas',
      error_containers_not_supported_description:
        'Este pedido tiene piezas dentro de cajas o tarimas, y el envío parcial desde esta pantalla no puede manejar cajas ni tarimas. Usa Revertir Picking en la handheld, en la pantalla del tote, para regresar el pedido completo al inicio junto con sus cajas y tarimas.',
      completion_title: 'Envío Parcial Completado',
      completion_description: 'Ahora debes mover los ítems al área de Disgrace.',
      items_to_move: 'Ítems para mover:',
      move_to_disgrace_title: 'Mover al área de Disgrace',
      move_to_disgrace_description: 'Excedente pickeado: sácalo del tote y colócalo en el área de Disgrace.',
      not_found_lost_title: 'No encontradas — registradas como perdidas',
      not_found_lost_description: 'El sistema ya las registró como perdidas. No hay nada que mover.',
      original_location: 'Ubicación original:',
      new_location: 'Nueva ubicación:',
      bulk_button: 'Enviar Parcialmente',
      banner_message: 'Esta orden será enviada parcialmente. Asegúrate de mover los ítems que no se enviarán.',
      dialog_error_title: 'Algo salió mal',
      dialog_error_description: 'Ocurrió un error al procesar el envío parcial.',
      dialog_cancel_label: 'Cancelar',
      dialog_retry_label: 'Reintentar',
      dialog_completion_title: 'Envío Parcial Procesado',
      dialog_completion_description_cancel: 'La orden será cancelada. Mueva todos los artículos al área de Disgrace.',
      dialog_completion_description_ready: 'La orden está lista para packing',
      dialog_ok_label: 'OK',
      order_details: {
        title: 'Ver Orden',
        order_number: 'Número de orden',
        tracking_number: 'Número de Rastreo',
        status: 'Estado',
        shipping_status: 'Estatus de Envío',
        creation_date: 'Fecha de creación',
        proof_of_delivery: 'Evidencia de entrega',
        store: 'Tienda',
        shipping_method: 'Método de envío',
        shipping_information: 'Información de envío',
        name: 'Nombre',
        phone: 'Teléfono',
        email: 'Email',
        address: 'Dirección',
        country: 'País',
        state: 'Estado',
        city: 'Ciudad',
      },
    },
    headers: {
      store: 'Tienda',
      order_number: 'Nº DE ORDEN',
      max_packing_time: 'Empacar antes de',
      channel_name: 'Canal',
      tote: 'TOTE',
      picker: 'Picker',
      status: 'Estado',
      shipping_method: 'MÉTODO DE ENVÍO',
      requires_partial_fulfillment: 'Envío parcial obligatorio',
      pickability: '¿Es pickeable?',
      has_unassigned_pickable: 'Stock por pickear',
      store_search_help_1: 'Para buscar más de una tienda usa "," Ej: Levis, Dossier',
      store_search_help_2: 'Para omitir algunas tiendas usa "-" EJ: -Levis, -Dossier',
      area_search_help_1: 'Para buscar más de un área usa "," Ej: A, B',
      area_search_help_2: 'Para omitir algunas áreas usa "-" EJ: -A, -B',
    },
    requires_partial_fulfillment: {
      yes: 'Sí',
      no: 'No',
      tooltip: 'Este pedido requiere enviarse parcialmente',
    },
    has_unassigned_pickable: {
      filter: 'Con stock por pickear',
      tag: 'Sí',
    },
    actions: {
      generate_shipment: 'Generar Guía',
      pick_pieces: 'Pickear piezas',
      fulfill_partially: 'Enviar Parcialmente',
      undo_in_review: 'Regresar a Picking',
      undo_in_review_loading: 'Regresando a Picking...',
    },
    undo_in_review: {
      error_title: 'Error al Regresar a Picking',
      error_no_picking_order: 'Datos de la orden incompletos. Por favor, intente nuevamente.',
      error_generic: 'Ocurrió un error al regresar el pedido a picking. Por favor, intente nuevamente.',
      error_not_in_review: 'El pedido no está en revisión',
      error_forbidden: 'No tienes permiso para sacar este pedido de revisión.',
      error_missing_stock:
        'A este pedido le faltan piezas asignadas y no se puede continuar desde aquí. Usa Revertir Picking en la handheld, en la pantalla del tote, para regresarlo al inicio. Si el pedido trae cajas o tarimas, repórtalo a Tech: no tiene salida automática.',
      error_requires_partial_fulfillment: 'Este pedido debe enviarse parcialmente y no puede sacarse de revisión.',
      error_picker_required: 'Selecciona un picker para sacar el pedido de revisión.',
      error_picker_not_found: 'El picker seleccionado ya no existe. Actualiza la lista y vuelve a intentarlo.',
      error_picker_not_in_warehouse: 'El picker seleccionado no pertenece a la bodega de este pedido. Elige otro.',
      error_picker_cannot_pick: 'El picker seleccionado no tiene permiso para pickear. Elige otro.',
      dialog_title: 'Regresar a Picking',
      choose_picker_hint: 'Selecciona el picker que retoma este pedido.',
      choose_pickers_hint: 'Selecciona uno o más pickers que retoman este pedido.',
      selected_summary: 'Seleccionados: {{names}}',
      operators_count_one: '{{count}} operador en esta bodega',
      operators_count_other: '{{count}} operadores en esta bodega',
      no_pickers: 'No hay pickers disponibles en esta bodega.',
      pickers_error: 'No se pudo cargar la lista de pickers. Intenta de nuevo.',
      tasks_error: 'No se pudieron cargar las tareas pendientes. Intenta de nuevo.',
      continue: 'Continuar',
      confirm: 'Regresar a Picking',
      back: 'Atrás',
      distribute_hint: 'Reparte las tareas pendientes. Lo que no repartas queda con {{name}}.',
      default_picker_option: 'Por defecto ({{name}})',
      pending_count_one: '{{count}} pendiente',
      pending_count_other: '{{count}} pendientes',
      no_pending: 'No hay tareas pendientes por repartir.',
      picker_for_location: 'Picker para {{location}}',
      error_has_holded_stock:
        'El pedido no se puede sacar de revisión porque tiene stock bloqueado. Para procesarlo, la marca debe desbloquear el stock, o puedes enviarlo parcialmente. Para ver el detalle del stock, consulta la sección de pedidos en revisión en la handheld.',
      error_has_holded_stock_no_partial:
        'El pedido no se puede sacar de revisión porque tiene stock bloqueado. Para procesarlo, la marca debe desbloquear el stock. Para ver el detalle del stock, consulta la sección de pedidos en revisión en la handheld.',
      error_has_expired_stock: 'El pedido no se puede sacar de revisión porque tiene stock expirado. Para procesarlo, envíalo parcialmente.',
      error_has_expired_stock_no_partial:
        'El pedido no se puede sacar de revisión porque tiene stock expirado, y tu tienda no tiene habilitado el envío parcial. Repórtalo a Tech.',
      error_order_interrupted: 'Este pedido fue cancelado, no se puede sacar de revisión. El tote debe vaciarse en la estación de revisión.',
      error_in_packing_status: 'El pedido se encuentra en packing, porfavor contacta al equipo tech para que revise este pedido',
      error_ok_label: 'OK',
    },
  },
  list_orders_shipped: {
    title: 'Pedidos Enviados',
    reassignment_of_orders: 'Reasignación de Pedidos',
    empty_table_text: 'No hay pedidos que mostrar.',
    actions: {
      print_shipping_label: 'Imprimir etiqueta de envío',
      regenerate_shipping_label: 'Regenerar etiqueta de envío',
      print_packing_list: 'Imprimir packing list',
    },
    headers: {
      order_number: 'Nº DE ORDEN',
      shipping_method: 'MÉTODO DE ENVÍO',
      shipping_type: 'Tipo de envío',
      status: 'Estado',
      shipping_status: 'Estatus de envío',
      incident: 'Incidente',
    },
  },
  list_returns: {
    returns: 'Retornos',
    empty_table_text: 'No hay retornos que mostrar.',
    require_monitoring: 'Requieren monitoreo',
    return_details: 'Detalle del retorno',
    scan_package_title: 'Escanea el paquete para identificarlo',
    scan_package_placeholder: 'Escanea la guia de retorno, la orden de packing list o RMA o la chave',
    headers: {
      store: 'Tienda',
      returned_order_number: 'Nº DE ORDEN RETORNADA',
      created_order_number: 'Nº DE NUEVA ORDEN',
      type: 'Tipo',
      status: 'Status',
      shipping_number: 'Guía retornada',
      created_at: 'Fecha de creación',
    },
  },
  list_locations: {
    locations: 'Ubicaciones',
    locations_by_product: 'Ubicaciones por producto',
    location_to_export_description: 'Con ubicación igual o parecida a ',
    sku_to_export_description: 'Con SKU igual o parecido a ',
    upc_to_export_description: 'Con UPC igual o parecido a ',
    store_to_export_description: 'Con nombre de tienda igual o parecido a ',
    location_type_to_export_description: 'Con ubicación tipo ',
    product_name_to_export_description: 'Con nombre de producto igual o parecido a ',
    export_all_products_description: 'Se exportaran todos los productos del almacén. Si deseas, usa los filtros para obtener un reporte específico.',
    headers: {
      product_image_path: 'Imagen',
      location_code: 'Ubicación',
      store: 'Tienda',
      location_type: 'Tipo',
      product_name: 'Nombre Producto',
      sku: 'SKU',
      upc: 'UPC',
      stock_total_count: 'Cantidad',
      stock_by_lot: 'Lotes',
    },
    containers_cell: {
      box_one: 'caja',
      box_other: 'cajas',
      pallet_one: 'tarima',
      pallet_other: 'tarimas',
      in: 'en',
      view_detail: 'Ver detalle',
    },
    containers_panel: {
      title: 'Contenedores en la ubicación',
      empty: 'No hay contenedores en esta ubicación.',
      pallet: 'Tarima',
      box: 'Caja',
      loose: '(suelta)',
      code: 'código',
      no_barcode: 'Sin código',
      content: 'Contenido',
      lot: 'Lote',
      piece_one: 'pieza',
      piece_other: 'piezas',
      box_one: 'caja',
      box_other: 'cajas',
      pallet_one: 'tarima',
      pallet_other: 'tarimas',
    },
    lot_columns: {
      lot: 'Lote',
      qty: 'Cant.',
      expires: 'Vence',
    },
    no_lot: 'Sin lote',
    empty_table_text: 'No hay productos que mostrar.',
    empty_table_text_lot_code: 'No hay stock del lote indicado.',
    export_inventory_title: 'Exportar inventario',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    inventory: 'Inventario',
    inventory_history: 'Historial de inventario',
    download: 'Descargar',
    export: 'Exportar',
    view_locations: 'Ver Ubicaciones',
    delete_lost_stock: 'Eliminar Stock Perdido',
    found_stock_button: 'Sobrantes',
    found_stock_pending_one: '{{count}} declaración de sobrantes pendiente',
    found_stock_pending_other: '{{count}} declaraciones de sobrantes pendientes',
  },
  simulate_putaway: {
    button_label: 'Putaway a Ubicaciones',
    title: 'Putaway a Ubicaciones',
    description:
      'Carga un archivo CSV con SKU, código de ubicación y cantidad para ejecutar el putaway de un replenishment a ubicaciones específicas. Opcionalmente puedes incluir código de lote y fecha de vencimiento.',
    instructions_title: 'Instrucciones',
    instruction_1: 'Columnas requeridas: sku, warehouse_location_code, quantity',
    instruction_2: 'Columnas opcionales: lot_code, expiration_date (formato YYYY-MM-DD o DD/MM/YY)',
    instruction_3: 'La cantidad debe ser un número entero mayor a 0',
    instruction_4: 'El código de ubicación debe corresponder a una ubicación existente en el almacén',
    instruction_5: 'También se aceptan columnas en español: CUBBO, SKU, Lote, Vencimiento, Suma de Cant.',
    download_template: 'Descargar plantilla CSV',
    replenishment_id_label: 'ID del Replenishment',
    replenishment_id_placeholder: 'Ej: 1234',
    file_label: 'Archivo CSV',
    file_placeholder: 'Arrastra o haz clic para subir un archivo CSV',
    file_help: 'Solo archivos .csv (máximo 10MB)',
    warnings_title: 'Advertencias en el archivo',
    preview_title: '{{count}} filas válidas encontradas',
    column_location: 'Ubicación',
    column_quantity: 'Cantidad',
    column_lot_code: 'Lote',
    column_expiration_date: 'Vencimiento',
    progress_label: 'Procesando putaway...',
    task_errors_title: 'Errores en el putaway',
    buttons: {
      cancel: 'Cancelar',
      close: 'Cerrar',
      confirm: 'Ejecutar Putaway ({{count}} filas)',
      processing: 'Procesando...',
    },
    validation: {
      missing_columns: 'Columnas faltantes en el CSV: {{columns}}',
      missing_sku: 'Fila {{row}}: SKU es requerido',
      missing_location: 'Fila {{row}}: Código de ubicación es requerido',
      invalid_quantity: 'Fila {{row}}: Cantidad debe ser un número mayor a 0',
      invalid_expiration_date: 'Fila {{row}}: Fecha de vencimiento tiene un formato inválido (usar YYYY-MM-DD o DD/MM/YY)',
      lot_without_expiration: 'Fila {{row}}: Lote "{{lot_code}}" no tiene fecha de vencimiento — será requerida si el lote es nuevo',
      skipped_empty_lots: '{{count}} filas sin código de lote — se procesarán sin lote',
      parse_error: 'Error al leer el archivo: {{message}}',
    },
    success_title: 'Putaway Completado',
    success_description: 'Se procesaron {{count}} registros correctamente.',
    error_title: 'Error en Putaway',
    error_generic: 'Ocurrió un error al procesar la solicitud.',
    error_conflict: 'Ya existe una tarea de putaway en progreso para este replenishment.',
    error_not_found: 'No se encontró el replenishment con el ID proporcionado.',
    error_types: {
      quantity_mismatch: 'Cantidad no coincide',
      missing_product: 'Producto faltante en el archivo',
      product_not_in_replenishment: 'Producto no pertenece al replenishment',
      sku_not_found: 'SKU no encontrado',
      location_not_found: 'Ubicación no encontrada',
      invalid_location_type: 'Tipo de ubicación no permitido',
      missing_field: 'Campo requerido faltante',
      invalid_field: 'Campo inválido',
      invalid_status: 'Estado del replenishment no válido',
      invalid_state: 'El replenishment ya tiene stock units creados',
      replenishment_not_found: 'Replenishment no encontrado',
      execution_error: 'Error durante la ejecución',
      unexpected_error: 'Error inesperado',
      job_failed: 'El proceso falló inesperadamente',
    },
  },
  location_modals: {
    create_location_modal: {
      title: 'Crear Ubicaciones de Almacén',
      description: 'Configura los parámetros para crear nuevas ubicaciones en el almacén',
      success_title: 'Ubicaciones Creadas Exitosamente',
      success_description: 'Las ubicaciones han sido creadas correctamente en el almacén.',
      fields: {
        location_type: 'Tipo de Ubicación',
        location_type_explanation: 'Esto dicta la funcionalidad de la ubicación dentro del almacén',
        volume_category: 'Categoría de Volumen',
        volume_category_explanation: 'Esto dicta la manera en la que se les cobrará a los clientes',
        area: 'Área',
        row: 'Fila',
        bay_min: 'Bahía Mínima',
        bay_max: 'Bahía Máxima',
        height_min: 'Altura Mínima',
        height_max: 'Altura Máxima',
        max_sku_capacity: 'Capacidad Máxima SKU',
        picking_priority: 'Prioridad de Picking',
      },
      placeholders: {
        area: 'Ej: A, AA',
        row: 'Ej: 01, 02',
        bay_min: '1',
        bay_max: '10',
        height_min: 'A',
        height_max: 'G',
        max_sku_capacity: 'Ej: 100',
        picking_priority: 'Ej: 1',
      },
      buttons: {
        cancel: 'Cancelar',
        create: 'Crear Ubicaciones',
        creating: 'Creando...',
      },
      validation: {
        required_fields: 'Por favor completa todos los campos obligatorios',
        warehouse_specific: 'Para este almacén, la capacidad máxima SKU y prioridad de picking son obligatorias',
        creation_error: 'Error al crear las ubicaciones',
      },
      preview: {
        title: 'Vista previa de códigos de ubicación:',
        from: 'Desde',
        to: 'hasta',
        format: 'Formato: Área-Fila-Bahía-Altura',
        warning: 'Nota: Si intentas crear ubicaciones que ya existen, serán omitidas automáticamente.',
      },
    },
    bulk_edit_location_modal: {
      title: 'Editar Ubicaciones de Almacén',
      description: 'Edita las ubicaciones existentes en el almacén en lote',
      success_title: 'Ubicaciones Editadas Exitosamente',
      success_description: 'Las ubicaciones han sido actualizadas correctamente en el almacén.',
      fields: {
        location_type: 'Tipo de Ubicación',
        volume_category: 'Categoría de Volumen',
        area: 'Área',
        row: 'Fila',
        bay_min: 'Bahía Mínima',
        bay_max: 'Bahía Máxima',
        height_min: 'Altura Mínima',
        height_max: 'Altura Máxima',
        max_sku_capacity: 'Capacidad Máxima SKU',
        picking_priority: 'Prioridad de Picking',
      },
      placeholders: {
        area: 'Ej: A, AA',
        row: 'Ej: 01, 02',
        bay_min: '1',
        bay_max: '10',
        height_min: 'A',
        height_max: 'G',
        max_sku_capacity: 'Ej: 100',
        picking_priority: 'Ej: 1',
      },
      buttons: {
        cancel: 'Cancelar',
        edit: 'Editar Ubicaciones',
        editing: 'Editando...',
      },
      validation: {
        required_fields: 'Por favor completa todos los campos obligatorios',
        warehouse_specific: 'Para este almacén, la capacidad máxima SKU y prioridad de picking son obligatorias',
        edit_error: 'Error al editar las ubicaciones',
      },
      loading: 'Cargando opciones...',
      preview: {
        title: 'Vista previa de códigos de ubicación:',
        from: 'Desde',
        to: 'hasta',
        format: 'Formato: Área-Fila-Bahía-Altura',
      },
    },
    view_warehouse_locations: {
      title: 'Ubicaciones del Almacén',
      warehouse_prefix: 'Almacén',
      buttons: {
        create_locations: 'Crear Ubicaciones',
        edit_locations: 'Editar Ubicaciones',
      },
      table: {
        label: 'Ubicaciones',
        empty_text: 'No hay ubicaciones que mostrar.',
        headers: {
          location_type: 'Tipo de Ubicación',
          volume_category: 'Categoría de Volumen',
          unique_code: 'Código de Ubicación',
          max_sku_capacity: 'Capacidad Máxima SKU',
          picking_priority: 'Prioridad de Picking',
        },
      },
    },
  },
  list_claims: {
    title: 'Disputas',
    headers: {
      order_number: 'Nº DE ORDEN',
      store_name: 'TIENDA',
      status: 'ESTADO',
      accepted_value: 'VALOR ACEPTADO',
      area: 'ÁREA',
      category: 'CATEGORÍA',
      created_at: 'FECHA DE CREACIÓN',
    },
    empty_table_text: 'No hay disputas que mostrar.',
  },
  list_operators: {
    title: 'Gestión de Operadores',
    new_operator: 'Nuevo operador',
    name: 'Nombre',
    surname: 'Apellido',
    email: 'E-mail',
    password: 'Contraseña',
    copy_email: 'Copiar e-mail',
    generate_password: 'Generar Password',
    sso_no_password: 'Este correo inicia sesión con Google, sin contraseña. Los roles y almacenes que asignes aquí se aplican a su cuenta de Google.',
    user_exists: 'Ya existe un usuario con este correo. Pide a un administrador que edite sus roles y almacenes.',
    sso_required: 'Este correo aún no puede darse de alta desde aquí: la persona debe iniciar sesión con Google primero.',
    account_outside_domain: 'Esta cuenta pertenece al personal de Cubbo. Solo un administrador de Cubbo puede crearla o modificarla.',
    copy_password: 'Copiar Password',
    create_operator: 'Crear Operador',
    operators: 'Operadores',
    warehouses: 'Almacenes',
    warehouses_column: 'Almacenes',
    all_warehouses: 'Todos',
    select_warehouses: 'Seleccionar almacenes',
    warehouses_required: 'Debes seleccionar al menos un almacén.',
    search_by_name: 'Buscar por nombre, apellido o email',
    search_by_role: 'Buscar por rol',
    roles: 'Roles',
    wh_admin_elevated_notice:
      'El Administrador de almacén tiene acceso total a todas las áreas. Solo un administrador de almacén (o superior) puede asignar este rol.',
    customer_app_access: 'Habilitar acceso al OMS',
    disable_customer_app_access: 'Deshabilitar acceso al OMS',
    wh_admin_oms_access: 'Habilitar acceso al OMS',
    disable_wh_admin_oms_access: 'Deshabilitar acceso al OMS',
    show_active_only: 'Mostrar sólo usuarios activos',
    empty_table_text: 'No hay operadores que mostrar.',
    has_oms_access: 'Acceso al OMS',
    notifications: {
      copied: 'Copiado!',
      operator_created: 'Operador creado!',
      operator_creation_failed: 'Error al crear el operador.',
      operator_roles_updated_success: 'Roles actualizados con éxito!',
      operator_roles_updated_failed: 'Hubo un error al modificar los roles, por favor intenta de nuevo.',
      operator_warehouses_updated_success: 'Almacenes actualizados con éxito!',
      operator_warehouses_updated_failed: 'Hubo un error al modificar los almacenes, por favor intenta de nuevo.',
      customer_app_enabled_success: 'Acceso al OMS modificado con éxito!',
      customer_app_enabled_failed: 'Hubo un error al modificar el acceso al OMS, por favor intente nuevamente.',
      operator_status_update_failed: 'Hubo un error al modificar el estado del usuario, por favor intenta de nuevo.',
      operator_edit_refused: 'No tienes permiso para modificar este usuario.',
      password_reset_success: 'La contraseña se actualizó correctamente!',
      password_reset_error: 'Error al resetear la contraseña.',
    },
    password_rules: {
      length: 'La contraseña debe tener al menos {{count}} caracteres',
      lengthAtLeast: 'Al menos {{count}} caracteres de longitud',
      containsAtLeast: 'Contener al menos {{min}} de los siguientes {{total}} tipos de caracteres:',
      items: {
        lowerCase: 'letras minúsculas (a-z)',
        upperCase: 'letras mayúsculas (A-Z)',
        numbers: 'números (0-9)',
        specialCharacters: 'caracteres especiales (ej. !@#$%^&*)',
      },
    },
    disable_user: 'Deshabilitar usuario',
    enable_user: 'Habilitar usuario',
    reset_password: 'Resetear Password',
    detail: {
      roles: 'Roles asignados',
      warehouses: 'Almacenes asociados',
      status_active: 'Activo',
      status_disabled: 'Deshabilitado',
      no_warehouses: 'Sin almacenes asignados',
    },
  },
  replenishments: {
    inbound_appointments: {
      statuses: {
        unknown: 'Sin estado',
        booked: 'Agendada',
        checked_in: 'Recibida',
        canceled: 'Cancelada',
        no_show: 'No llegó',
        superseded: 'Reagendada',
      },
      classes: {
        standard: 'Programada',
        express: 'Express',
        extemporaneous: 'Extemporánea',
      },
      unload: {
        title: 'Descarga',
        started_label: 'Inicio de descarga',
        ended_label: 'Fin de descarga',
        include_end: 'Registrar también el fin de la descarga',
        now: 'Ahora',
        save: 'Guardar descarga',
        saved: 'Descarga registrada ✓',
      },
      extemporaneous: {
        button: 'Registrar llegada extemporánea',
        confirm_title: 'Registrar llegada extemporánea',
        confirm_description:
          'Se registrará la llegada de este recibo con fecha de hoy, sin franja y sin reserva de capacidad. Esta acción no se puede deshacer desde aquí.',
        confirm: 'Registrar',
        cancel: 'Cancelar',
        success: 'Llegada extemporánea registrada',
      },
      overrides: {
        title: 'Capacidad de recibo',
        from: 'Desde',
        to: 'Hasta',
        create: 'Crear ajuste',
        all_day: 'Todo el día',
        superseded: 'Reemplazada',
        blocked_pill: 'Bloqueado',
        no_overrides: 'No hay ajustes en este rango',
        headers: {
          date: 'Fecha',
          franja: 'Franja',
          dock: 'Muelles',
          man_hours: 'Horas-hombre',
          units_delta: 'Δ piezas',
          blocked: 'Bloqueado',
          reason: 'Motivo',
          created_at: 'Creado',
        },
        load_error: 'No se pudieron cargar los ajustes',
        franjas_load_error: 'No se pudieron cargar las franjas de recibo',
        retry: 'Reintentar',
        form: {
          title: 'Crear ajuste de capacidad',
          date: 'Fecha',
          franja: 'Franja',
          dock: 'Ajuste de muelles',
          man_hours: 'Ajuste de horas-hombre',
          man_hours_day_only: 'Las horas-hombre solo aplican a todo el día',
          units_delta: 'Piezas extra (±)',
          units_delta_franja_only: 'Las piezas extra requieren una franja',
          capacity_preview: 'Capacidad actual: {{current}} → con ajuste: {{result}}',
          blocked: 'Bloquear el día (feriado, mantenimiento…)',
          blocked_confirm_title: 'Bloquear día de recibo',
          blocked_confirm_description:
            'Se bloqueará la capacidad de recibo para la fecha seleccionada. En v1 los ajustes no se pueden editar ni borrar desde la interfaz: el bloqueo quedará activo hasta una corrección manual. ¿Continuar?',
          blocked_confirm: 'Bloquear',
          reason: 'Motivo',
          cancel: 'Cancelar',
          create: 'Crear',
        },
        notifications: {
          created: 'Ajuste creado',
        },
      },
      board: {
        title: 'Citas de recibo',
        date_label: 'Fecha',
        status_label: 'Estado',
        class_label: 'Tipo',
        all: 'Todas',
        extemporaneous_group: 'Extemporáneos',
        no_appointments: 'Sin llegadas en esta franja',
        no_appointments_day: 'No hay citas para esta fecha',
        store: 'Tienda',
        replenishment: 'Recibo',
        units: '{{units}} piezas',
        units_boxes: '{{units}} piezas · {{boxes}} cajas',
        checked_in_at: 'Check-in: {{time}}',
        load_error: 'No se pudieron cargar las citas',
        franjas_load_error: 'No se pudieron cargar las franjas de recibo',
        retry: 'Reintentar',
        no_appointments_filtered: 'Sin resultados para estos filtros',
        arrivals_filter: 'Llegadas',
        arrivals_count_one: '{{count}} llegada',
        arrivals_count_other: '{{count}} llegadas',
        capacity_full: 'lleno',
        capacity_reserved: 'reservado',
        capacity_blocked: 'Bloqueada',
        capacity_error: 'No se pudo cargar la capacidad por franja',
        early: {
          title: 'Recibidos por adelantado',
          summary_one: '{{count}} cita · {{units}} piezas',
          summary_other: '{{count}} citas · {{units}} piezas',
          received_on: 'Recibido el {{date}} · {{time}}',
        },
        week: {
          toggle_week: 'Semana',
          toggle_day: 'Día',
          franja_header: 'Franja',
          today: 'hoy',
          extemporaneous_row: 'Extemporáneas',
          total_row: 'Total camiones',
          early_row: 'Recibidos por adelantado',
          load_error: 'No se pudo cargar la vista semanal',
          stale_error: 'No se pudo actualizar la vista semanal',
          header_label: 'Ver {{day}}',
          cell_label: 'Ver {{day}} · {{franja}}',
          empty: 'No hay franjas ni llegadas en esta semana',
        },
      },
      errors: {
        generic: 'Ocurrió un error. Intenta de nuevo.',
        forbidden: 'No tienes permiso para esta acción',
        inbound_scheduling_disabled: 'El agendamiento nativo no está habilitado en este almacén',
        replenishment_not_bookable: 'El estado del recibo no permite esta acción',
        already_booked: 'Este recibo ya tiene una cita activa',
        appointment_not_active: 'La cita ya no está activa',
        invalid_unload_window: 'Ventana de descarga inválida: el fin debe ser posterior al inicio y ambos dentro de ±2 días de la fecha de la cita',
        invalid_override: 'Ajuste inválido: las horas-hombre solo aplican a todo el día y las piezas extra requieren franja',
      },
    },
    show_replenishment: {
      title: 'Cita de Recibo',
      products: 'Productos',
      sell_ahead: 'Preventa',
      not_sell_ahead: 'No-Preventa',
      open_receipt: 'Volver a abrir recibo',
      complete_receipt: 'Completar Recibo',
      modify_lots: 'Modificar lotes del último producto escaneado',
      edit_lots: 'Editar lotes',
      finish_check_in: 'Terminar check-in',
      receipt_correction: 'Corrección de recibo',
      name: 'Nombre',
      skus: 'SKUs',
      upc: 'UPC',
      new_quantity: 'Nuevo número de piezas en recepción',
      cancel: 'Cancelar',
      correct: 'Corregir',
      continue: 'Continuar',
      no_pieces_in_receipt: 'No hay ninguna pieza en recibo',
      attention: 'Atención',
      accept: 'Aceptar',
      scan_product: 'Escanea el producto para identificarlo',
      products_with_lots: 'productos con lotes registrados',
      filter_no_lots: 'Productos sin lote registrado',
      receipt_stage_complete: 'Etapa de Recibo Completada pero todavía quedan piezas por localizar en Put Away.',
      quality_check: 'Control de calidad',
      segregated_check: 'El producto viene correctamente segregado.',
      labeled_check: 'El producto viene correctamente etiquetado.',
      inventory_receipt: 'Recibo de inventario',
      no_lot: 'No tiene lote',
      no_lot_required: 'No requiere lote',
      replenishment_completed: 'Recibo completado',
      receipt_completed: 'Recibo completado',
      received_pieces: 'Piezas recibidas',
      damaged_dialog_1: 'Mueve ',
      damaged_dialog_2: ' piezas a la localización: D-1-1-1 y clicka continuar',
      complete_dialog_1: 'Tienes ',
      complete_dialog_2: ' productos con piezas en recibo, ¿aceptas completar el recibo y que esas piezas se eliminen?',
      how_many_boxes: '¿Cuantos bultos/cajas vienen en este recibo?',
      attended_appointment: 'Cumplió con cita.',
      mark_as_received: 'Marcar cómo Recibido',
      receive: 'Recibir',
      damaged: 'Dañado',
      product_exists_but_not_in_receipt: 'Este producto existe en la tienda, pero no en el recibo',
      add_to_receipt: 'Añadir al recibo',
      start_check_in: 'Empezar check-in',
      count_pieces_by_sku_or_upc: 'Cuenta piezas por SKU o UPC',
      start: 'Empezar',
      searching: 'Buscando...',
      product_not_found: 'El SKU buscado no existe',
      select_lot: 'Éste producto tiene más de un lote, selecciona uno para continuar',
      store_not_configured: 'Esta tienda no ha sido configurada para poder iniciar el recibo. Por favor, contacta al representante de ventas de la tienda.',
      notifications: {
        quality_check_saved: 'Quality check guardado',
        duplicate_product_added: 'Este producto ya ha sido añadido al recibo anteriormente',
      },
      columns: {
        lot: 'Lote',
        name: 'Nombre',
        sku: 'SKU',
        upc: 'UPC',
        counted: 'Contadas',
        actions: 'Acciones',
        expected_quantity: 'Esperadas',
        processed_quantity: 'Procesadas',
        in_reception: 'En recepción',
      },
      how_many_boxes_in_receipt: '¿Cuantas cajas llegaron?',
      inventory_receipt: 'Recibo de inventario',
    },
    show_replenishment_boxes: {
      in_putaway: 'Etapa de Recibo Completada pero todavía quedan piezas por localizar en Put Away.',
      completed: 'Etapa de Recibo Completada',
      start_check_in_title: 'Empezar check-in',
      start_chcek_in_button: 'Empezar',
      complete_receive_button: 'Ya no hay mas piezas que contar',
      complete_putaway_button: 'Hemos finalizado el putaway',
      reopen_button: 'Regresar a contar piezas',
      last_movements: 'Últimos productos que escaneé',
      complete_replenishment_dialog: {
        received_less_than_expected_title: 'Diferencias detectadas',
        received_less_than_expected_description: 'Para algunos productos se contaron menos piezas de las esperadas',
        received_less_than_expected_confirm_question: '¿Seguro que ya no hay más piezas que contar?',
        confirm_button: 'Confirmar',
        cancel_button: 'Regresar y revisar',
      },
      receive_options: {
        title: '¿Qué vas a contar ahora?',
        options: {
          complete_boxes: 'Cajas completas',
          uncomplete_boxes: 'Cajas parciales',
        },
        receiving_title: 'Estas contando',
        scan_input_title: 'Escanea el código de la caja',
        scan_input_placeholder: 'Escanea',
        scan_input_receing: 'Recibiendo caja...',
      },
      scan_quantity_barcode_dialog: {
        title: 'Piezas contenidas en la caja',
        description: 'Escanea el código de la caja con la cantidad del producto o escribe la cantidad',
        scan_input_placeholder: 'Escanea el código o escribe la cantidad',
        confirm_button: 'Ingresar',
      },
      supplier_invoice: {
        chip_label: 'Factura: {{number}}',
        chip_empty: 'Agregar Factura',
        change: 'Cambiar',
        add: 'Agregar',
        dialog_title: 'Factura del proveedor',
        dialog_description: 'Las cajas recibidas se asociarán a esta factura hasta que la cambies.',
        input_placeholder: 'p. ej. F-505',
        save: 'Guardar',
        remove: 'Quitar factura',
        cancel: 'Cancelar',
        column_header: 'Facturas',
        active_label: 'Factura en proceso',
        tooltip_active: 'Las piezas recibidas se asociarán a esta factura. Toca para cambiarla.',
        tooltip_empty: 'Ninguna factura asignada: las piezas recibidas no quedarán asociadas a una factura. Toca para agregar.',
        correction_per_invoice: 'Piezas en recepción por factura',
        correction_total: 'Total en recepción',
        required_before_scan: 'Ingresa la factura antes de escanear. Toca "Agregar Factura" para agregarla.',
        has_invoice_question: '¿Este recibo trae factura del proveedor?',
        has_invoice_help: 'Si la marcas, será obligatorio ingresar la factura para recibir.',
        receive_requires_invoice: 'Agrega una factura para recibir',
        pieces_received: '{{count}} piezas recibidas',
      },
      supplier_invoice_files: {
        documents_button: 'Documentos',
        title: 'Documentos de recibo',
        description: 'Adjunta documentos del recibo, como la factura del proveedor. Son visibles para todos los que reciben este abasto.',
        upload: 'Subir documentos',
        uploading: 'Subiendo…',
        drop_placeholder: 'Presiona aquí o arrastra tus documentos.',
        delete: 'Eliminar',
        upload_error: 'No se pudo subir el documento. Intenta de nuevo.',
        delete_error: 'No se pudo eliminar el documento. Intenta de nuevo.',
      },
      received_boxes_table: {
        columns: {
          product_name: 'Nombre',
          scanned_box: 'Caja escaneada',
          lot: 'Lote | Expiración',
          sku: 'SKU | UPC',
          expected: 'Piezas esperadas',
          received: 'Piezas recibidas',
          received_boxes: 'Total cajas recibidas',
          received_pieces: 'Total piezas recibidas',
          pieces_status: 'Estado de Piezas',
          in_putaway: 'En Putaway',
          actions: '',
        },
        complete_boxes_plural: '{{quantity}} cajas completas',
        uncomplete_boxes_plural: '{{quantity}} cajas parciales',
        not_damaged_pieces_plural: '{{quantity}} buen estado',
        damaged_pieces_plural: '{{quantity}} dañadas',
        fix_DAMAGED_button: 'Corregir dañadas',
        fix_PUTAWAY_button: 'Corregir cantidad',
        send_to_damage_button: 'Dañada',
        empty_table: 'Sin contenido',
        empty_movements: 'No se han registrado movimiento aún',
        cannot_edit_damaged: 'No es posible corregir dañadas debido a que no existen piezas recibidas',
        cannot_edit_quantity: 'No es posible corregir cantidad debido a que no existen piezas recibidas',
        cannot_send_to_damage: 'No es posible enviar a dañado debido a que no existen piezas recibidas',
        damaged_pieces_dialog: {
          title: '¿Cuántas piezas de este producto deseas marcar como dañadas?',
          description: 'Aparta las piezas para ubicarlas en una posición de dañado en el almacén',
          confirm_button: 'Confirmar',
          cancel_button: 'Cancelar',
        },
        fix_quantity: {
          PUTAWAY_title: 'Corrección de piezas esperando putaway',
          DAMAGED_title: 'Corrección de piezas dañadas',
          product_name: 'Nombre del producto',
          sku: 'SKU | UPC',
          lot: 'Lote | Expiración',
          PUTAWAY_description: 'Cantidad actualizada de piezas esperando putaway',
          DAMAGED_description: 'Cantidad actualizada de piezas dañadas',
          confirm_button: 'Actualizar',
          cancel_button: 'Cancelar',
        },
        filters: {
          sku: {
            title: 'SKU',
          },
          upc: {
            title: 'UPC',
          },
          lot_unique_code: {
            title: 'Código de lote',
          },
          box_barcode: {
            title: 'Código de barras de caja',
          },
          pending_to_receive: {
            title: 'Con piezas pendientes de recibir',
          },
          pending_to_putaway: {
            title: 'Con piezas pendientes de putaway',
          },
        },
      },
      errors: {
        send_pieces_to_damage: "Ocurrió un error al enviar a dañado, se reportó el siguiente error: '{{error_data}}'",
        adjust_putaway_pieces: "Ocurrió un error al ajustar piezas en putaway, se reportó el siguiente error: '{{error_data}}'",
        invalid_barcode:
          "El código que escaneaste '{{barcode}}' no corresponde a un código de barras de una caja de la tienda. Inténtalo de nuevo y si el error persiste, pide ayuda a tech para validar el formato del código",
        receive_error: "No se logró recibir la caja, se reportó el siguiente error: '{{error_data}}'",
        quality_check_error: "Ocurrió un error en quality check, se reportó el siguiente error: '{{error_data}}'",
        start_error: "Ocurrió un error al comenzar el recibo, se reportó el siguiente error: '{{error_data}}'",
        complete_receive_error: "Ocurrió un error al completar el recibo de piezas, se reportó el siguiente error: '{{error_data}}'",
        complete_putaway_error: "Ocurrió un error al completar el putaway, se reportó el siguiente error: '{{error_data}}'",
        reopen_error: 'No se pudo reabrir el recibo: {{error}}',
        generic: 'ocurrió un error inesperado',
        receive_damaged_error: "Ocurrión un error al enviar las piezas a dañado, se reportó el siguiente error: '{{error_data}}'",
      },
      error_codes: {
        lot_not_found:
          "Esta caja no se puede recibir ya que el lote del producto no está registrado en la tienda. Manda una foto de este error y de la etiqueta de la caja al equipo de tech para validar el caso, contexto para tech: '{{context}}'",
        sku_not_found:
          "Esta caja no se puede recibir ya que el SKU del producto no está registrado en la tienda. Manda una foto de este error y de la etiqueta de la caja al equipo de tech para validar el caso, contexto para tech: '{{context}}'",
        no_expected_product_quantity:
          "Este producto no se esperaba en este recibo, por lo que no se puede ingresar. Manda una foto de este error y de la etiqueta de la caja al equipo de tech para validar el caso, contexto para tech: '{{context}}'",
        unexpected_product_count:
          "Ya se recibieron el total de piezas esperadas de este producto. Manda una foto de este error y de la etiqueta de la caja al equipo de tech para validar el caso, contexto para tech: '{{context}}'",
      },
      receive_progress_bar: {
        title: 'Progreso general del recibo',
        remaining_pieces: 'Faltan {{quantity}} piezas por recibir',
        received_boxes: '{{complete_boxes}} cajas completas y {{uncomplete_boxes}} cajas parciales',
        update_quantity: 'Corregir cantidades recibidas',
        show_breakdown: 'Ver desglose de piezas',
        general_quantity: '{{received_pieces}} de {{expected_pieces}} piezas contadas',
      },
      putaway_progress_bar: {
        title: 'Progreso general del putaway',
        remaining_pieces: 'Faltan {{quantity}} piezas recibidas por completar putaway',
        update_quantity: 'Corregir cantidades recibidas',
        show_breakdown: 'Ver desglose de piezas',
        general_quantity: '{{putaway_pieces}} de {{check_in_pieces}} piezas recibidas con putaway completado',
      },
      breakdown: {
        title: 'Detalles de piezas del recibo',
      },
    },
  },
  list_active_replenishments: {
    replenishment: 'Recibo',
    replenishments: 'Recibos',
    empty_table_text: 'No hay recibos de inventario que mostrar.',
    receive: 'Recibir',
    reverse_logistics_replenishments: 'Recibos de Logística Inversa',
    bulk_reverse_logistics_replenishments: 'Recibos de Logística Inversa en Bulk',
    bulk_empty_table_text: 'No hay recibos de logística inversa en bulk que mostrar.',
    headers: {
      id: 'Id',
      store: 'Tienda',
      notes: 'Notas',
      status: 'Estado',
      created_at: 'Fecha de creación',
      has_containers: 'Contenedores',
      sell_ahead: 'Preventa',
      has_expirations: 'Tiene expiraciones',
      actions: 'Acciones',
      products: 'Productos',
      received_quantity: 'Cantidad recibida',
      pending_transfer: 'Pendiente transferir',
      scanned_label: 'Etiqueta escaneada',
      scanned_label_placeholder: 'Buscar por guía o pedido',
    },
    bulk_status: {
      pending: 'Pendiente',
      completed: 'Completado',
    },
    bulk_id: 'Bulk ID',
    replenishment_id: 'Recibo ID',
    bulk_return_label: 'Retorno en Bulk',
    bulk_replenishment_products: 'Productos del recibo en bulk',
    bulk_replenishment_products_description: 'Total de productos de todos los retornos en este recibo en bulk',
    view_session: 'Ver detalle',
    reprint_label: 'Reimprimir etiqueta',
  },
  csv_grid: {
    upload: 'Subir CSV',
    paste: 'Pegar CSV',
    paste_placeholder: 'Pega aquí tu CSV (incluye la fila de encabezados)',
    paste_apply: 'Cargar',
    download_template: 'Descargar plantilla',
    add_row: 'Agregar fila',
    remove_row: 'Eliminar fila',
    errors: {
      required: 'Requerido',
      not_a_number: 'Debe ser un número',
      too_small: 'Valor demasiado bajo',
      csv_only: 'Solo se aceptan archivos .csv',
      parse_failed: 'No se pudo leer el archivo',
      parse_issues: 'El CSV tiene {{count}} filas con formato inválido. Revísalo y vuelve a subirlo.',
      not_positive: 'Debe ser mayor que 0',
      min_cost: 'Mínimo 0.01',
      need_cost_or_enabled: 'Indica un precio o habilita/deshabilita la cobertura',
      need_cost: 'Indica un precio',
      duplicate_tier: 'Ya hay una fila con este peso para esta zona',
      duplicate_id: 'Este id está repetido en otra fila',
      empty: 'No se encontraron filas con datos',
    },
  },
  common: {
    yes: 'Si',
    no: 'No',
    accept: 'Aceptar',
    cancel: 'Cancelar',
    warning: '¡Cuidado!',
    beta_badge: 'Beta',
    beta_badge_tooltip: 'Funcionalidad en beta — puede cambiar o tener limitaciones temporales.',
    order: 'Orden',
    orders: 'Pedidos',
    shipments: 'Envios',
    returns: 'Retornos',
    inventory: 'Inventario',
    claims: 'Disputas',
    maquilas: 'Maquilas',
    operators: 'Operadores',
    warehouse: 'Almacén',
    locations: 'Ubiquaciones',
    previous: 'Anterior',
    next: 'Seguiente',
    loading: 'Cargando...',
    error: 'Error',
    internal_carrier_tooltip: 'Transportadora interna: {{carrier}}',
    client_carrier_tooltip: 'Se muestra a clientes como: {{carrier}}',
    show_more: 'más',
    show_less: 'Ver menos',
  },
  picking_productivities: {
    title: 'Productividades de Picking',
    subtitle: 'Torre de Control de Productividad',
    active_pickers_today: 'Pickers Activos Hoy',
    active_pickers_last_hour: 'Pickers Activos Última Hora',
    total_items_24h: 'Total Items 24h',
    avg_items_per_interval: 'Promedio Items/Intervalo',
    productivity_score: 'Puntaje Productividad',
    view_by_day: 'Ver por Día',
    view_by_hour: 'Ver por Hora',
    view_by_10min: 'Ver por 10 Minutos',
    insights: 'Insights Generales',
    picker_performance: 'Rendimiento por Picker',
    hourly_breakdown: 'Desglose por Hora',
    interval_breakdown: 'Desglose por Intervalos',
    no_data: 'No hay datos disponibles',
    loading: 'Cargando...',
    error: 'Error al cargar datos',
    retry: 'Reintentar',
    top_performers: 'Top Performers',
    top_performers_subtitle: 'Los mejores pickers del día basado en productividad',
  },
  configurations: {
    manage_operators: 'Operadores',
    manage_boxes: 'Gestionar Cajas',
    manage_store_boxes: 'Cajas por marca',
    manage_container_templates: 'Gestionar Contenedores',
    manage_barcode_pool: 'Gestionar pool',
    manage_sales_channels: 'Canales de venta',
    campaigns: 'Campañas',
    manage_receiving_capacity_overrides: 'Capacidad de recibo',
    receiving: 'Recepción',
    packing: 'Empaque',
    dispatch_recipients: 'Destinatarios del manifiesto',
  },
  dispatch_recipients: {
    title: 'Destinatarios del manifiesto',
    explainer:
      'Al finalizar una salida, el manifiesto firmado se envía por correo a quienes estén aquí: los de esa paquetería y los de "Todas las paqueterías". Sin destinatarios, el manifiesto no se envía.',
    all_carriers: 'Todas las paqueterías',
    all_carriers_hint: 'Reciben el manifiesto de cada salida del almacén.',
    carrier_hint: 'Reciben el manifiesto de las salidas de esta paquetería.',
    empty_group: 'Nadie recibe estos manifiestos todavía.',
    count_one: '{{count}} destinatario',
    count_other: '{{count}} destinatarios',
    confirm_remove: '{{name}} ({{email}}) dejará de recibir estos manifiestos.',
    actions: {
      add: 'Agregar destinatario',
      edit: 'Editar',
      remove: 'Quitar',
      history: 'Historial',
      retry: 'Reintentar',
    },
    form: {
      create_title: 'Agregar destinatario',
      edit_title: 'Editar destinatario',
      carrier: 'Paquetería',
      name: 'Nombre',
      name_placeholder: 'Nombre y apellido, o área',
      email: 'Correo',
      cancel: 'Cancelar',
      create: 'Agregar',
      save: 'Guardar',
    },
    notifications: {
      created: 'Destinatario agregado',
      updated: 'Destinatario actualizado',
      removed: 'Destinatario quitado',
    },
    history: {
      title: 'Historial de destinatarios',
      empty: 'Todavía no hay cambios.',
      action_create: 'Agregado',
      action_update: 'Editado',
      action_delete: 'Quitado',
      load_error: 'No se pudo cargar el historial.',
    },
    errors: {
      required: 'Este campo es obligatorio.',
      fields: {
        name: 'Revisa el nombre.',
        email: 'Revisa el correo: no es una dirección válida.',
        carrier_name: 'Elige una paquetería de este almacén.',
      },
      no_access: 'No tienes acceso a esta sección.',
      load: 'No se pudieron cargar los destinatarios.',
      RECIPIENT_DUPLICATED: 'Ese correo ya recibe los manifiestos de esta paquetería.',
      RECIPIENT_INVALID: 'Revisa el nombre, el correo y la paquetería.',
      NOT_FOUND: 'Alguien ya quitó ese destinatario: la lista se actualizó.',
      FORBIDDEN: 'No tienes permiso para cambiar los destinatarios.',
      generic: 'No se pudo guardar. Intenta de nuevo.',
    },
  },
  packing_config: {
    title: 'Empaque',
    load_error: 'No se pudo cargar la configuración de empaque',
    retry: 'Reintentar',
    not_available: 'La configuración de empaque todavía no está disponible para este almacén.',
    empty: 'No tienes configuraciones de empaque que puedas modificar en este almacén.',
    audit: {
      title: 'Auditoría de empaque',
      explainer:
        'Porcentaje de pedidos que se auditan al asignar tote en este almacén. Aplica a las asignaciones nuevas; las auditorías ya pendientes se deben responder igual. Los pedidos de clientes críticos y las entregas ZVPJ de Natura se auditan siempre, salvo al 0%.',
      warehouse_label: 'Porcentaje del almacén',
      save: 'Guardar',
      discard: 'Descartar',
      saving: 'Guardando...',
      stamp: 'Última modificación: {{name}} · {{date}}',
      unset: 'Sin configurar: la auditoría está desactivada (0%).',
      counters: { following: 'Siguen el almacén', exceptions: 'Con excepción', excluded: 'Excluidas (0%)' },
      exceptions_title: 'Excepciones por tienda',
      exceptions_hint: 'Estas tiendas usan su propio porcentaje en lugar del del almacén.',
      add_exception: '+ Agregar excepción',
      exceptions_empty: 'Ninguna tienda tiene excepción: todas usan el porcentaje del almacén.',
      exceptions_load_error: 'No se pudieron cargar las excepciones.',
      columns: { store: 'Tienda', audit: 'Auditoría', updated: 'Última modificación' },
      excluded_pill: 'Excluida (0%)',
      edit: 'Editar',
      remove: 'Quitar',
      saved: 'Porcentaje del almacén actualizado',
      exception_added: 'Excepción agregada',
      exception_updated: 'Excepción actualizada',
      exception_removed: 'Excepción quitada: la tienda vuelve a usar el porcentaje del almacén',
      confirm: {
        title: '¿Cambiar la auditoría de {{warehouse}} a {{value}}%?',
        description: 'Las nuevas asignaciones de tote se auditarán al {{value}}% (antes {{previous}}%) en las tiendas que siguen el almacén ({{following}}).',
        description_off:
          'La auditoría quedará desactivada por completo, incluidas las obligatorias (clientes críticos, entregas ZVPJ de Natura), en las tiendas que siguen el almacén ({{following}}; antes {{previous}}%).',
        own_value: 'Mantienen su propio porcentaje: {{parts}}.',
        own_exceptions: 'con excepción ({{n}})',
        own_excluded: 'excluidas ({{n}})',
        pending_note: 'Las auditorías ya pendientes se deben responder igual.',
        confirm: 'Cambiar porcentaje',
        cancel: 'Cancelar',
        loading: 'Guardando',
        this_warehouse: 'este almacén',
      },
      remove_confirm: {
        title: '¿Quitar la excepción de {{store}}?',
        description: 'La tienda pasará a usar el porcentaje del almacén ({{value}}%).',
        warehouse_off:
          'El almacén está al 0%: la tienda no recibirá ninguna auditoría, ni siquiera las obligatorias (clientes críticos, entregas ZVPJ de Natura).',
        confirm: 'Quitar excepción',
        cancel: 'Cancelar',
        loading: 'Quitando',
      },
      modal: {
        add_title: 'Agregar excepción',
        edit_title: 'Editar excepción',
        subtitle: 'Una excepción reemplaza el porcentaje del almacén ({{value}}%) para una tienda.',
        store_label: 'Tienda',
        store_placeholder: 'Busca por nombre (mín. 2 letras)',
        no_results: 'Sin resultados (las tiendas que ya tienen excepción no aparecen).',
        search_error: 'No se pudo buscar tiendas. Intenta de nuevo.',
        searching: 'Buscando tiendas…',
        change_store: 'Cambiar',
        value_label: 'Porcentaje para esta tienda',
        preset_exclude: 'Excluir (0%)',
        excluded_hint: 'La tienda no recibirá ninguna auditoría, ni siquiera las obligatorias (clientes críticos, entregas ZVPJ de Natura).',
        cancel: 'Cancelar',
        close: 'Cerrar',
        save: 'Guardar',
      },
      errors: {
        required: 'Ingresa un porcentaje',
        integer: 'Solo números enteros de 0 a 100',
        max: 'El máximo es 100%',
        forbidden: 'No tienes permiso para cambiar esta configuración en este almacén.',
        invalid_value: 'El porcentaje debe estar entre 0 y 100.',
        store_not_in_warehouse: 'Esta tienda no pertenece a este almacén.',
        store_spans_multiple_warehouses:
          'Esta tienda opera en más de un almacén. Su porcentaje aplicaría en todos ellos, así que solo tecnología puede cambiarlo.',
        concurrent_update: 'Otra persona guardó al mismo tiempo. Recarga e intenta de nuevo.',
        not_found: 'La tienda o el almacén ya no existe.',
        generic: 'No se pudo guardar. Intenta de nuevo.',
        remove_generic: 'No se pudo quitar la excepción. Intenta de nuevo.',
      },
    },
  },
  receiving_config: {
    title: 'Recepción',
    tabs: { settings: 'Configuración', overrides: 'Capacidad de recibo', history: 'Historial' },
    load_error: 'No se pudo cargar la configuración de recepción',
    retry: 'Reintentar',
    launch_flags: {
      enabled: 'Citas activas',
      show_promises: 'Promesas visibles',
      express_enabled: 'Express activo',
      off_suffix: '(apagado)',
      managed_by_engineering: 'Gestionado por ingeniería',
    },
    unprovisioned_banner: 'Esta bodega aún no tiene configuración de recepción. Completa los campos obligatorios y guarda.',
    settings: {
      title: 'Parámetros',
      fields: {
        dock_count: 'Muelles',
        units_per_door_franja: 'Piezas por muelle y franja',
        daily_processing_man_hours: 'Horas-hombre diarias de procesamiento',
        express_buffer_door_franjas: 'Muelles-franja reservados para express',
        no_show_grace_minutes: 'Minutos de gracia por no-show',
        reschedule_cutoff_hours: 'Horas límite para reprogramar',
        checkin_units_per_hour_default: 'Piezas por hora en check-in (default)',
      },
      required: 'Obligatorio',
      suggestion: 'Sugerido: {{value}}',
      apply_suggestion: 'aplicar',
      no_suggestion: 'sin datos aún',
      errors: {
        dock_count_range: 'Debe estar entre 1 y 50',
        non_negative: 'Debe ser 0 o mayor',
        positive: 'Debe ser mayor a 0',
        man_hours_max: 'Máximo 9999.99',
        buffer_exceeds_docks: 'No puede superar el número de muelles',
      },
    },
    franjas: {
      title: 'Franjas',
      add: 'Agregar franja',
      headers: { label: 'Nombre', weekdays: 'Días', window: 'Horario', status: 'Estado' },
      active: 'Activa',
      retired: 'Retirada',
      edit: 'Editar',
      retire: 'Retirar',
      reactivate: 'Reactivar',
      empty: 'No hay franjas configuradas',
      weekdays_short: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
      weekdays_full: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
      modal: {
        title_new: 'Nueva franja',
        title_edit: 'Editar franja',
        label: 'Nombre',
        weekdays: 'Días de la semana',
        starts_at: 'Inicio',
        ends_at: 'Fin',
        cancel: 'Cancelar',
        save: 'Aceptar',
        errors: {
          label_required: 'El nombre es obligatorio',
          label_too_long: 'Máximo 100 caracteres',
          weekdays_required: 'Selecciona al menos un día',
          end_after_start: 'El fin debe ser posterior al inicio',
          overlap_warning: 'Se traslapa con la franja "{{label}}" en un día compartido; la API rechazará el guardado.',
        },
      },
    },
    save: {
      button: 'Guardar',
      discard: 'Descartar cambios',
      unsaved_prompt: 'Tienes cambios sin guardar. ¿Salir de todas formas?',
      modal: {
        title: 'Confirmar cambios',
        reason: 'Motivo del cambio',
        reason_help: 'Queda registrado en el historial. No incluyas datos de clientes.',
        reason_required: 'El motivo es obligatorio (mínimo 3 caracteres)',
        cancel: 'Cancelar',
        confirm: 'Guardar cambios',
      },
      saved: 'Configuración guardada',
      reverted: 'Cambio revertido',
    },
    warnings: {
      title: 'Guardado con advertencias',
      overbooked_intro: 'Estas fechas ya tienen más piezas reservadas que la nueva capacidad:',
      overbooked_headers: { date: 'Fecha', franja: 'Franja', reserved: 'Reservadas', capacity: 'Capacidad' },
      affected_count: '{{count}} citas ya reservadas cambiaron de condiciones (gracia, límite de reprogramación o inicio de franja).',
      view_board: 'Ver citas',
      revert: 'Revertir',
      revert_confirm_title: 'Revertir el último cambio',
      revert_confirm_description: 'Se restaurará la configuración anterior al cambio #{{id}}.',
      dismiss: 'Cerrar',
    },
    errors: {
      generic: 'No se pudo guardar la configuración',
      invalid_param: 'Solicitud inválida: {{message}}',
      invalid_config: 'Configuración inválida: {{message}}',
      settings_required_for_first_save: 'Para el primer guardado son obligatorios: {{fields}}',
      concurrent_update_title: 'Alguien más guardó cambios',
      concurrent_update_description: 'La configuración cambió mientras editabas. Recarga para continuar.',
      reload: 'Recargar',
      conflicts_title: 'La franja tiene citas reservadas',
      conflicts_intro: 'Reprograma o cancela estas citas antes de modificar la franja:',
      conflicts_headers: { appointment: 'Cita', date: 'Fecha', franja: 'Franja' },
      conflicts_close: 'Entendido',
    },
    history: {
      empty: 'Aún no hay cambios registrados',
      load_more: 'Cargar más',
      system: 'Sistema (rake)',
      forced: 'Forzado',
      no_changes: 'Sin cambios efectivos',
      settings: 'Parámetros',
      franjas_changed: 'Franjas modificadas',
      franjas_added: 'Franjas agregadas',
      franjas_retired: 'Franjas retiradas',
      franjas_reactivated: 'Franjas reactivadas',
      load_error: 'No se pudo cargar el historial',
    },
  },
  campaigns: {
    title: 'Campañas',
    subtitle: 'Campañas generales por país. Todas las marcas del país las ven en Métricas.',
    country_label: 'País',
    countries: { MX: 'México', BR: 'Brasil', CL: 'Chile' },
    yearly_group: 'Cada año',
    headers: { name: 'Nombre', starts_on: 'Inicio', ends_on: 'Fin', recurrence: 'Se repite', updated_at: 'Actualizada', actions: 'Acciones' },
    recurrence: { none: 'No se repite', monthly: 'Cada mes', yearly: 'Cada año' },
    actions: { create: 'Nueva campaña', edit: 'Editar', duplicate: 'Duplicar al año siguiente', delete: 'Eliminar' },
    empty: 'Cubbo no tiene campañas para {{country}}',
    errors: {
      no_access: 'No tienes acceso a esta sección',
      load: 'No se pudieron cargar las campañas',
      retry: 'Reintentar',
      end_before_start: 'El fin debe ser igual o posterior al inicio',
      generic: 'No se pudo guardar la campaña',
      delete_generic: 'No se pudo eliminar la campaña',
      forbidden: 'No tienes permiso para modificar las campañas de Cubbo',
      gone: 'Esta campaña ya no existe; actualizamos la lista',
    },
    form: {
      create_title: 'Nueva campaña',
      edit_title: 'Editar campaña',
      duplicate_title: 'Duplicar al año siguiente',
      duplicate_hint: 'Fechas corridas un año a partir de "{{name}}". Ajusta los días exactos.',
      country: 'País',
      name: 'Nombre',
      name_placeholder: 'Ej. Buen Fin',
      starts_on: 'Inicio',
      ends_on: 'Fin',
      recurrence: 'Se repite',
      save: 'Guardar',
      saving: 'Guardando...',
      cancel: 'Cancelar',
    },
    confirm_delete: {
      title: 'Eliminar campaña',
      description: 'Se eliminará "{{name}}" ({{starts_on}} – {{ends_on}}) para {{country}}. Las marcas dejarán de ver esta banda en Métricas.',
      confirm: 'Eliminar',
      cancel: 'Cancelar',
    },
    notifications: { created: 'Campaña creada', updated: 'Campaña actualizada', deleted: 'Campaña eliminada' },
  },
  sales_channels: {
    title: 'Canales de venta destino',
    no_channels: 'No hay canales de venta configurados',
    status_active: 'Activo',
    status_inactive: 'Deshabilitado',
    scope_types: {
      stores: 'Tiendas',
      warehouses: 'Almacenes',
    },
    filters: {
      search: 'Buscar por nombre',
      status_label: 'Estado',
      status_active: 'Activos',
      status_disabled: 'Deshabilitados',
      status_all: 'Todos',
    },
    headers: {
      name: 'Nombre',
      scope: 'Alcance',
      links: 'Vínculos',
      status: 'Estado',
      actions: 'Acciones',
    },
    actions: {
      create: 'Crear canal',
      edit: 'Editar',
      history: 'Historial',
      disable: 'Deshabilitar',
      restore: 'Re-habilitar',
      confirm_disable: '¿Deshabilitar este canal de venta? Dejará de ofrecerse en pedidos nuevos; los pedidos que ya lo tienen no se ven afectados.',
      confirm_restore: '¿Re-habilitar este canal de venta?',
    },
    form: {
      create_title: 'Crear canal de venta',
      edit_title: 'Editar canal de venta',
      name: 'Nombre',
      scope_type: 'Alcance',
      stores: 'Tiendas',
      warehouses: 'Almacenes',
      links_placeholder: 'Buscar y agregar',
      cancel: 'Cancelar',
      create: 'Crear',
      save: 'Guardar',
    },
    history: {
      title: 'Historial',
      refresh: 'Actualizar',
      no_history: 'Sin historial',
      action: 'Acción',
      changes: 'Cambios',
      user: 'Usuario',
      date: 'Fecha',
      added: 'Agregados',
      removed: 'Quitados',
      action_create: 'Creación',
      action_name_update: 'Cambio de nombre',
      action_links_update: 'Cambio de vínculos',
      action_discard: 'Deshabilitado',
      action_undiscard: 'Re-habilitado',
    },
    notifications: {
      created: 'Canal creado',
      updated: 'Canal actualizado',
      disabled: 'Canal deshabilitado',
      restored: 'Canal re-habilitado',
      error: 'Ocurrió un error',
    },
    errors: {
      no_access: 'No tienes acceso a esta sección',
      name_taken: 'Ya existe un canal activo con ese nombre',
    },
  },
  container_templates: {
    title: 'Contenedores',
    select_store: 'Selecciona una tienda',
    no_templates: 'No hay templates configurados para esta tienda',
    create_template: 'Crear Template',
    edit_template: 'Editar Contenedor',
    save_template: 'Guardar',
    cancel: 'Cancelar',
    print_label: 'Imprimir Etiqueta',
    delete_template: 'Eliminar Template',
    confirm_delete: '¿Estás seguro de que deseas eliminar este template?',
    headers: {
      grouping_code: 'Código',
      name: 'Nombre',
      container_type: 'Tipo',
      items_count: 'Items',
      active: 'Activo',
      actions: 'Acciones',
    },
    container_types: {
      GROUP_CONTAINER: 'Tarima',
      PRODUCT_CONTAINER: 'Caja',
    },
    editor: {
      grouping_code: 'Código de agrupación',
      grouping_code_placeholder: 'Ej: TARIMA-MIX-001',
      name: 'Nombre',
      name_placeholder: 'Nombre descriptivo del template',
      container_type: 'Tipo de contenedor',
      active: 'Activo',
      add_item: 'Agregar',
      add_product: 'Producto',
      add_sub_container: 'Sub-contenedor',
      product: 'Producto',
      product_search_placeholder: 'Buscar por nombre, SKU o código de barras',
      no_products_found: 'No se encontraron productos',
      quantity: 'Cantidad',
      units_per_container: 'Piezas por contenedor',
      lot: 'Lote',
      no_lot: 'Sin lote',
      template: 'Template',
      select_template: 'Seleccionar template',
      done: 'Listo',
      remove: 'Eliminar',
      total_pieces: 'Total: {{count}} piezas',
      total_bar: 'Total de piezas en contenedor: {{count}} piezas',
      pieces_each: '{{count}} pzas c/u',
      pieces_short: 'pzas',
      boxes_count_one: '× {{count}} caja',
      boxes_count_other: '× {{count}} cajas',
      validation: {
        grouping_code_required: 'El código de agrupación es requerido',
        container_type_required: 'El tipo de contenedor es requerido',
        at_least_one_item: 'Debe tener al menos un item',
        incomplete_item: 'El elemento #{{position}} está incompleto',
      },
    },
    notifications: {
      created: 'Template creado exitosamente',
      updated: 'Template actualizado exitosamente',
      deleted: 'Template eliminado exitosamente',
      error_create: 'Error al crear el template',
      error_update: 'Error al actualizar el template',
      error_delete: 'Error al eliminar el template',
      missing_store: 'Selecciona una tienda primero',
    },
  },
  barcode_pool: {
    title: 'Pool de etiquetas',
    subtitle: 'Etiquetas pre-impresas reusables (Cubbo) para tarimas y cajas. Se generan vacías y se reclaman al escanearlas en una recepción.',
    empty: 'No hay etiquetas con estos filtros.',
    total: '{{count}} etiquetas',
    selected: '{{count}} seleccionadas',
    container_types: {
      GROUP_CONTAINER: 'Tarima',
      PRODUCT_CONTAINER: 'Caja',
    },
    statuses: {
      available: 'Disponible',
      in_use: 'En uso',
    },
    filters: {
      container_type: 'Tipo',
      status: 'Estado',
      all: 'Todas',
      show_store_scoped: 'Ver de un cliente específico',
      select_store: 'Selecciona cliente',
      select_store_hint: 'Selecciona un cliente para ver sus etiquetas pre-impresas.',
    },
    columns: {
      barcode: 'Barcode',
      type: 'Tipo',
      status: 'Estado',
      created_at: 'Creada',
      container: 'Contenedor',
    },
    actions: {
      generate_batch: 'Generar lote',
      print_selection: 'Imprimir selección ({{count}})',
      print_one: 'Imprimir',
    },
    generate_dialog: {
      title: 'Generar lote de etiquetas',
      subtitle: 'Selecciona el tipo y la cantidad. Las etiquetas se generan vacías y quedan disponibles en el pool.',
      quantity: 'Cantidad',
      cancel: 'Cancelar',
      confirm: 'Generar',
      generating: 'Generando…',
      store_scoped_warning: 'Estas etiquetas quedarán asignadas al cliente {{store}} (no reusables por otros).',
    },
    notifications: {
      generated: '{{count}} etiquetas generadas',
      generate_error: 'No se pudo generar el lote',
      print_error: 'No se pudo descargar el PDF',
      too_many: 'No puedes imprimir más de {{max}} etiquetas a la vez',
    },
  },
  missing_stock: {
    section_title: '¿Por qué este pedido no tiene stock?',
    missing_one: 'Falta {{count}} pieza',
    missing_other: 'Faltan {{count}} piezas',
    blocked_one: '{{count}} pieza reservada no se puede enviar',
    blocked_other: '{{count}} piezas reservadas no se pueden enviar',
    in_transit_one: '{{count}} pieza en camino',
    in_transit_other: '{{count}} piezas en camino',
    assignable_hint: 'El motor ya tiene stock asignable para este pedido: reprocésalo desde el OMS.',
    lot: 'Lote',
    rule: 'Regla',
    expiration_date: 'Caducidad',
    sellable_until: 'Vendible hasta',
    units: 'Piezas',
    locations: 'Ubicaciones',
    no_lot: 'Sin lote',
    no_location: 'Sin ubicación',
    other_warehouse_locations: 'Otro almacén',
    unknown_reason: 'Motivo no reconocido por esta versión del WMS.',
    load_error: 'No se pudo cargar el diagnóstico. Recarga la página para intentarlo de nuevo.',
    reasons: {
      freshness: 'Hay stock, pero dentro de la ventana de frescura del producto o en lotes caducados.',
      held_lot: 'Hay stock, pero en un lote retenido.',
      damaged: 'Hay stock, pero dañado.',
      incoming: 'Hay stock en preventa en camino.',
      in_transit: 'El stock reservado aún no se ha recibido.',
      no_stock: 'No hay stock disponible en este almacén.',
      assignable: 'Hay stock asignable.',
      requested_unit: 'El pedido espera una unidad específica que aún no está disponible.',
      needs_unit_code: 'Producto personalizado sin unidad indicada en el pedido.',
      unknown_product: 'El SKU no existe en el catálogo de la tienda.',
    },
    buckets: {
      reserved_by_other_orders: 'Reservado por otros pedidos',
      other_warehouse: 'En otro almacén',
      incoming: 'Preventa en camino',
      in_reception: 'En recepción',
      damaged: 'Dañado',
      unsellable_location: 'En ubicación no vendible',
      held_lot: 'Lote retenido',
      expired_lot: 'Lote caducado',
      freshness_window: 'Dentro de la ventana de frescura',
      not_for_channel: 'No habilitado para el canal',
      unconfirmed_replenishment: 'Recibo no confirmado',
      containers_not_allowed: 'En caja/tarima (el pedido no puede tomarla)',
      assignable: 'Asignable ahora',
      other_engine_rule: 'Otra regla del motor',
    },
  },
  stock_allocation: {
    section_title: 'Asignación de stock',
    pallets: 'tarimas',
    boxes: 'cajas',
    loose_pieces: 'piezas sueltas',
    totes: 'totes',
    standalone_boxes: 'Cajas sueltas',
    pieces: 'piezas',
    box: 'Caja',
    piece: 'Pieza',
    lot: 'Lote',
    picking_progress: 'Progreso de picking',
    empty: 'Sin asignación de stock',
    error: 'No se pudo cargar la asignación de stock',
    statuses: {
      SEALED: 'Sellada',
      ACTIVE: 'Activa',
      RESERVED: 'Reservada',
      PICKED: 'Pickeada',
      in_use: 'En uso',
    },
  },
  picking_tasks: {
    badge_b2b: 'B2B',
    summary_title: 'Tareas de Picking',
    columns: {
      store: 'Tienda',
      order_number: 'Núm. Pedido',
      location: 'Ubicación',
      pick_type: 'Tipo',
      progress: 'Progreso',
      quantity: 'Cantidad',
      sku: 'SKU',
      status: 'Estado',
      picker: 'Picker',
    },
    pick_types: {
      PALLET: 'Tarima',
      BOX: 'Caja',
      PIECE: 'Pieza',
    },
    statuses: {
      PENDING: 'Pendiente',
      ASSIGNED: 'Asignado',
      IN_PROGRESS: 'En progreso',
      COMPLETED: 'Completado',
      SKIPPED: 'Omitido',
      CANCELED: 'Cancelado',
    },
    actions: {
      view_tasks: 'Ver progreso',
      reassign_picker: 'Reasignar',
      reassign_picker_title: 'Reasignar Picker',
      reassign_confirm: 'Reasignar',
      reassign_success: 'Picker reasignado correctamente',
      reassign_error: 'Error al reasignar picker',
      search_operator_placeholder: 'Buscar Operador',
      current: 'actual',
    },
    assign_pickers_error: 'Error al crear tareas de picking. La orden fue asignada pero las tareas no se pudieron dividir.',
    empty: 'No hay tareas de picking para esta orden',
    sku_summary: {
      location_one: 'ubicación',
      location_other: 'ubicaciones',
    },
    assign_summary: {
      orders: 'pedidos seleccionados',
      pieces: 'piezas',
      picker_short: 'operador',
      pickers_short: 'pickers',
      too_many_pickers_warning:
        'Vas a repartir {{pieces}} piezas entre {{selected}} pickers. Te recomendamos como máximo {{recommended}} para este volumen — asegúrate que quieres asignar tantos pickers a este picking.',
      all_blocked_from_picking:
        'Todos los pedidos seleccionados tienen piezas dentro de cajas o tarimas por romper. Inventarios tiene que romperlas antes de poder asignarlos a picking.',
      blocked_title: 'No hay nada que asignar',
      go_to_break: 'Ir a Cajas por romper',
      excluded_title: 'Pedidos excluidos',
      excluded_blocked_from_picking: 'Se excluyen de la asignación porque tienen piezas dentro de cajas o tarimas por romper:',
    },
    multi_picker: {
      title: 'Asignar Tasks a Pickers',
      suggested_distribution: 'Distribución sugerida (balanceada por carga)',
      restore_distribution: 'Restaurar distribución',
      confirm: 'Confirmar Asignación',
      unassigned: 'Pendiente de asignar',
      load_summary: 'Carga',
      unassign: 'Devolver al pool',
      unassign_success: 'Task devuelta al pool correctamente',
      unassign_error: 'Error al devolver task al pool',
      confirm_success: 'Tasks asignadas correctamente',
      confirm_error: 'Error al asignar tasks',
      picker_queue: 'Cola del picker',
      queue_reorder: 'Reordenar cola',
      queue_save: 'Guardar orden',
      queue_save_success: 'Cola actualizada',
      queue_save_error: 'Error al actualizar la cola',
      queue_empty: 'Este picker no tiene tareas en cola.',
      queue_unauthorized: 'No tienes permiso para ver la cola de este picker.',
      queue_error: 'No se pudo cargar la cola del picker.',
      select_pickers: 'Seleccionar pickers',
      multi_picker_help: 'Selecciona 2 o más pickers para repartir las tareas entre ellos',
      picking_status_title: 'Progreso por picker',
      completed_short: 'Completada con faltante',
      no_pickers_selected: 'Selecciona al menos un picker',
      cancel: 'Cancelar',
      close: 'Cerrar',
      pieces_short: 'pzs',
      tasks_short: 'tareas',
      total: 'Total',
      retry: 'Reintentar',
      upc: 'UPC',
      product_name: 'Producto',
      toggle_sku_detail: 'Ver detalle de SKU y UPC',
      no_product_detail: 'Sin detalle de productos para esta ubicación',
      preview_error: 'No se pudo calcular la distribución',
      stale_distribution: 'La distribución cambió porque el stock se movió. Revisa la nueva sugerencia.',
      already_exists: 'Este pedido ya tiene una asignación. Refrescando…',
      split_across_pickers:
        'La distribución dividía una misma ubicación, o un mismo SKU del mismo tipo de picking, entre varios pickers. Recalculamos una asignación válida — revisa la nueva sugerencia.',
      copy_hint: 'Clic para copiar',
      copied: 'copiado',
      distribution_title: 'Distribución de tareas',
      distribution_summary:
        'Revisa la distribución sugerida de tareas de picking entre los <b>{{users}}</b> seleccionados para procesar las <b>{{pieces}}</b> {{ordersArticle}} <b>{{orders}}</b>. La carga se repartió equilibrando las piezas entre los pickers; cada ubicación queda con un solo picker.',
      summary_users_one: '{{count}} usuario',
      summary_users_other: '{{count}} usuarios',
      summary_users_many: '{{count}} usuarios',
      summary_pieces_one: '{{formatted}} pieza',
      summary_pieces_other: '{{formatted}} piezas',
      summary_pieces_many: '{{formatted}} piezas',
      summary_orders_article_one: 'del',
      summary_orders_article_other: 'de los',
      summary_orders_article_many: 'de los',
      summary_orders_one: '{{count}} pedido',
      summary_orders_other: '{{count}} pedidos',
      summary_orders_many: '{{count}} pedidos',
      excluded_title_one: '{{count}} pedido excluido de la distribución. Se reparte el resto:',
      excluded_title_other: '{{count}} pedidos excluidos de la distribución. Se reparte el resto:',
      excluded_title_many: '{{count}} pedidos excluidos de la distribución. Se reparte el resto:',
      search_placeholder: 'Buscar por SKU, pedido o ubicación',
      all_pick_types: 'Todos los tipos de picking',
      view_by_picker: 'Por picker',
      view_by_location: 'Por ubicaciones',
      view_by_order: 'Por pedido',
      collapse_all: 'Contraer todos',
      expand_all: 'Expandir todos',
      distribution_error_title: 'No pudimos calcular la distribución',
      distribution_error_see_details: 'Revisa el detalle de cada pedido a continuación.',
      distribution_error_mixed_types:
        'Suele pasar cuando la selección mezcla tipos de pedido que no se pueden repartir juntos entre varios pickers. Regresa y deja un solo tipo de pedido, o asígnalos con un solo picker.',
      distribution_error_not_pending:
        "Uno o más pedidos ya no están en estado 'Pendiente' (es posible que ya hayan sido asignados). Regresa, actualiza la lista de pedidos y vuelve a intentar.",
      picker_summary: '{{locations}} ubicaciones · {{pieces}} piezas · {{skus}} SKUs · {{orders}} pedidos',
      remove_picker: 'Quitar picker (sus ubicaciones pasan a pendiente de asignar)',
      no_locations: 'Sin ubicaciones asignadas',
      pick_type_header: 'Tipo de picking',
      drag_to_reassign: 'Arrastra para reasignar a otro picker',
      unassign_location: 'Desasignar (mover a pendiente de asignar)',
      locations_pieces: '{{locations}} ubicaciones · {{pieces}} piezas',
      auto_assign: 'Asignar automáticamente',
      drag_to_assign: 'Arrastra a un picker para asignar',
      locations_pieces_short: '{{locations}} ubicaciones · {{pieces}} pzs',
      order_split_notice: 'Este pedido se repartió entre {{n}} pickers.',
    },
    order_errors: {
      missing_stock: 'Hay productos de este pedido que no han sido asignados. Contacta a soporte técnico. ',
      excessive_stock: 'Hay un exceso de productos asignados al pedido. Contacta a soporte técnico. ',
      expired_stock: 'Hay productos expirados asignados al pedido. Contacta a soporte técnico. ',
      holded_stock: 'Hay productos en hold asignados al pedido. Contacta a soporte técnico. ',
      invalid_order_status: "Este pedido no se encuentra en estado 'Pendiente'. Es posible que ya haya sido asignado. ",
      sxkm_order: 'Este pedido es del cliente SXKM. No debe realizar picking. ',
      not_apt_for_single_item_picking: 'Este pedido no cumple los requisitos para poder ser agrupado. ',
      single_item_picking_conflict:
        'Este pedido tiene conflictos de SKU o UPC con el pedido #{{orders}}. No es posible agrupar el pedido en esta sesión de picking. ',
      single_item_picking_conflict_no_order:
        'Este pedido tiene conflictos de SKU o UPC con otro pedido. No es posible agrupar el pedido en esta sesión de picking. ',
      single_item_picking_store_conflict:
        'Este pedido no puede ir en el mismo tote que el pedido #{{orders}}: uno de ellos lleva injerto y son de tiendas distintas, o son de la misma tienda con injertos distintos. Los pedidos con injerto solo se agrupan con pedidos de su misma tienda y con los mismos injertos. Si no ves ese pedido en esta lista, puede que ya esté asignado al picker. ',
      single_item_picking_store_conflict_no_order:
        'Este pedido no puede ir en el mismo tote que otro pedido: uno de ellos lleva injerto y son de tiendas distintas, o son de la misma tienda con injertos distintos. Los pedidos con injerto solo se agrupan con pedidos de su misma tienda y con los mismos injertos. Si no ves ese pedido en esta lista, puede que ya esté asignado al picker. ',
      already_has_picking_order: 'Este pedido ya ha sido asignado a un picker. ',
      pending_container_break: 'Este pedido tiene piezas dentro de una caja o tarima que inventarios debe romper antes de poder pickearlo. ',
      panel_title_one: 'No se pudieron procesar {{count}} pedido:',
      panel_title_other: 'No se pudieron procesar {{count}} pedidos:',
      panel_title_many: 'No se pudieron procesar {{count}} pedidos:',
      invalid_order_status_with_status:
        "Este pedido no se encuentra en estado 'Pendiente'; se encuentra en '{{status}}' y no puede ser asignado.",
      order_status_label: 'Estado del pedido:',
      code_label: 'Código:',
      code_title: 'Código de error para reportar a soporte',
    },
    assign_columns: {
      store: 'Tienda',
      order_number: 'Número de pedido',
      channel_name: 'Canal de venta',
      pieces: 'Piezas',
      groupable: 'Agrupable',
      groupable_help:
        'Un pedido es elegible para agrupar cuando puede pickearse junto con otros en un mismo tote. Los pedidos no elegibles se asignan a su propio tote individual.',
      groupable_count: '{{n}} pedidos',
      yes: 'Si',
      no: 'No',
      insert_tooltip: 'Lleva injerto: {{names}}. Solo se agrupa con pedidos de su misma tienda y con los mismos injertos.',
      insert_fallback: 'material de la tienda',
      insert_badge: 'Injerto',
      picker_name: 'Nombre del picker',
      email: 'Correo',
      queued_orders: 'Pedidos asignados en cola',
      in_progress_orders: 'Pedidos en curso',
      grouping_split: 'No agrupado | Agrupados',
      picking_orders_split: '{{nonGrouped}} No agrupado | {{grouped}} Agrupado',
    },
    assign_dialog: {
      title: 'Asignación de pickers',
      intro_one: 'Selecciona qué picker(s) trabajarán los <bold>{{count}} pedido</bold> que se van a asignar.',
      intro_other: 'Selecciona qué picker(s) trabajarán los <bold>{{count}} pedidos</bold> que se van a asignar.',
      intro_many: 'Selecciona qué picker(s) trabajarán los <bold>{{count}} pedidos</bold> que se van a asignar.',
      search_placeholder: 'Buscar operador (nombre o correo)',
      selected_pickers_one: '{{count}} picker seleccionado',
      selected_pickers_other: '{{count}} pickers seleccionados',
      selected_pickers_many: '{{count}} pickers seleccionados',
      deselect_all: 'Deseleccionar todos',
      operators_count: '{{n}} Operadores',
      summary_title: 'Resumen de asignación',
      orders_to_assign: 'Pedidos a asignar',
      individual: 'Individuales',
      groupable: 'Agrupables',
      total_pieces: 'Total de piezas',
      route_areas: 'Áreas del recorrido',
      order_type: 'Tipo de pedido',
      pickers_detail: 'Detalle de pickers',
      queued_orders_one: 'con {{count}} pedido encolado',
      queued_orders_other: 'con {{count}} pedidos encolados',
      queued_orders_many: 'con {{count}} pedidos encolados',
      choose_operator: 'Elige un operador',
      continue: 'Continuar',
      back: 'Regresar',
      group_title: 'Agrupar pedidos',
      group_help: 'Edita la selección de pedidos que se agruparán en caso de ser necesario.',
      group_orders_heading: 'Pedidos que vas a asignar',
      group_eligible:
        'De los <bold>{{total}} pedidos</bold> seleccionados, <bold>{{eligible}}</bold> son elegibles para agrupar. Selecciona cuáles de estos deseas que se asignen al mismo tote.',
      shared_tote: '<bold>{{n}} pedidos</bold> agrupables, se asignarán al mismo tote compartido.',
      show_all: 'Ver todos los pedidos',
      show_only_groupable: 'Ver sólo pedidos agrupables',
      not_groupable_tooltip: 'Este pedido no es agrupable, por eso no se puede seleccionar. Se pickeará en su propio tote individual.',
      insert_blocker_tooltip:
        'Un pedido con injerto solo se agrupa con pedidos de su misma tienda y con los mismos injertos, y este no puede ir en el mismo tote que #{{orderNumber}} ({{store}}). Quita ese pedido del grupo o se pickeará en su propio tote.',
      other_store: 'otra tienda',
      resolve_conflicts_one: 'Resuelve {{count}} Conflicto',
      resolve_conflicts_other: 'Resuelve {{count}} Conflictos',
      resolve_conflicts_many: 'Resuelve {{count}} Conflictos',
      confirm_orders: 'Confirmar {{count}} Pedidos',
      loading: 'Cargando...',
    },
  },
  picking_tasks_to_break: {
    title: 'Cajas por romper',
    refresh: 'Actualizar',
    forbidden: 'No tienes permiso para ver esta pantalla.',
    empty_table_text: 'No hay nada por romper en este almacén.',
    footer_products: 'productos',
    footer_orders: 'pedidos',
    summary: '{{products}} productos, {{orders}} pedidos bloqueados',
    pivot: {
      by_product: 'Por producto',
      by_order: 'Por pedido',
    },
    status: {
      breakable: 'Se puede romper',
      not_breakable: 'Sin stock para romper — requiere reabasto',
    },
    filters: {
      sku_upc: 'SKU / UPC',
    },
    headers: {
      product: 'Producto',
      pieces_to_release: 'Piezas a liberar',
      affected_orders: 'Pedidos afectados',
      oldest_order: 'En espera desde',
      locations: 'Ubicaciones',
      locations_reserved: 'Ubicaciones con inventario reservado no pickeable',
      status: 'Estado',
      order_number: 'Número de Pedido',
      store: 'Tienda',
      total_pieces: 'Piezas',
      products_count: 'Productos',
    },
    detail: {
      orders_title: 'Pedidos afectados',
      products_title: 'Productos requeridos',
      pieces: 'Piezas',
      pieces_short: '{{count}} pza',
      pieces_short_plural: '{{count}} pzas',
      boxes_title: 'Ver cajas',
      no_barcode: 'Sin código',
      product_summary: '{{pieces}} piezas a liberar · {{orders}} pedidos afectados',
      order_summary: '{{pieces}} piezas · {{products}} productos',
    },
  },
  delete_lost_stock: {
    title: 'Eliminar Stock Perdido',
    warning_message:
      'Esta acción es irreversible. Una vez eliminados los stock units, no pueden recuperarse. Asegúrate de verificar los datos antes de continuar.',

    // Steps
    step1_title: 'Seleccionar Ubicación LOST',
    step2_title: 'Seleccionar Productos y Cantidades',
    step2_description: 'Productos disponibles en la ubicación {{location}}:',
    step2_placeholder: 'Selecciona una ubicación en el paso 1 para ver los productos disponibles.',
    refetch: 'Actualizar',

    // Labels
    labels: {
      select_location: 'Ubicación LOST',
      product: 'Producto',
      lot: 'Lote',
      location: 'Ubicación',
      store: 'Tienda',
      quantity_to_delete: 'Cantidad a eliminar',
      available: 'Disponible',
      to_delete: 'A eliminar',
      expires: 'Expira',
    },

    // Units
    units: 'unidades',
    no_lot: 'Sin lote',
    no_image: 'Sin imagen',
    unknown_store: 'Tienda desconocida',
    total_in_location: 'Total en ubicación',
    total_stores: 'Total de tiendas',
    filtered_total: 'Total filtrado',

    // Search
    search_by_sku: 'Buscar por SKU o UPC',
    search_placeholder: 'Escanear o ingresar SKU/UPC...',
    search_button: 'Buscar',
    search_results: "{{count}} resultado(s) para '{{term}}'",
    no_search_results: 'No se encontraron productos con el SKU/UPC buscado.',
    clear_search: 'Limpiar búsqueda',

    // Empty states
    no_lost_locations: 'No hay ubicaciones LOST con stock disponible.',
    no_stock_items: 'No hay productos en esta ubicación.',

    // Confirmation
    confirm_title: 'Confirmar Eliminación',
    confirm_description: 'Estás a punto de eliminar stock con los siguientes datos:',
    confirm_warning: 'Esta acción es irreversible. ¿Deseas continuar?',
    confirm_button: 'Sí, Eliminar',
    cancel_button: 'Cancelar',
    loading: 'Eliminando...',

    // Success/Error
    success_title: 'Stock Eliminado',
    success_message: "Se eliminaron {{count}} stock unit(s) de la ubicación '{{location}}'",
    success_message_store: "Se eliminaron {{count}} stock unit(s) de la tienda '{{store}}' en la ubicación '{{location}}'",
    error_title: 'Error',

    // Store delete
    delete_all_store: 'Eliminar todo',
    confirm_store_title: 'Eliminar Todo el Stock de la Tienda',
    confirm_store_description:
      "Estás a punto de eliminar todo el stock de la tienda '{{store}}' en la ubicación '{{location}}'. Se eliminarán {{count}} unidad(es).",

    // Permissions
    no_permission_title: 'Acceso Denegado',
    no_permission_message: 'No tienes permisos para eliminar stock perdido. Contacta al administrador si necesitas acceso.',
    go_back: 'Volver al Inventario',
    view_history: 'Ver Historial',

    // Errors
    errors: {
      product_not_found: 'El producto no fue encontrado.',
      warehouse_not_found: 'El almacén no fue encontrado.',
      lot_not_found: 'El lote no fue encontrado.',
      lot_does_not_belong_to_product: 'El lote no pertenece al producto seleccionado.',
      location_not_found: 'La ubicación especificada no existe o no es de tipo LOST en área LF.',
      no_stock_units_found: 'No hay stock para eliminar con los criterios especificados.',
      quantity_exceeds_available: 'La cantidad solicitada excede el stock disponible.',
      store_not_found: 'La tienda no fue encontrada.',
      invalid_parameter: 'Parámetros inválidos. Verifica los datos ingresados.',
      internal_error: 'Error interno. Por favor intenta de nuevo más tarde.',
      loading_locations: 'Error al cargar las ubicaciones.',
      loading_stock: 'Error al cargar el stock de la ubicación.',
      no_quantity_selected: 'Debes ingresar una cantidad a eliminar.',
    },
  },

  lastmile_management: {
    days: {
      0: 'Domingo',
      1: 'Lunes',
      2: 'Martes',
      3: 'Miércoles',
      4: 'Jueves',
      5: 'Viernes',
      6: 'Sábado',
    },
    days_short: {
      0: 'Dom',
      1: 'Lun',
      2: 'Mar',
      3: 'Mié',
      4: 'Jue',
      5: 'Vie',
      6: 'Sáb',
    },
    boolean_yes: 'Sí',
    boolean_no: 'No',
    shipping_methods: {
      title: 'Métodos de envío',
      subtitle: 'Gestiona coberturas, costos y días no laborables por paquetería.',
      empty_table: 'No hay métodos de envío para mostrar.',
      footer_text: 'métodos de envío',
      edit_method: 'Editar método de envío',
      search_placeholder: 'Buscar por método o paquetería',
      all_carriers: 'Todas las paqueterías',
      non_working_days_empty: 'Ninguno',
      methods_active: 'Métodos activos',
      column_title: 'Título',
      column_type: 'Tipo',
      no_results: 'No hay métodos que coincidan con tu búsqueda.',
      count_method: 'método',
      count_methods: 'métodos',
      status_active: 'Activo',
      status_inactive: 'Inactivo',
      non_working_pill_prefix: 'No opera',
      non_working_pill_none: 'Opera todos los días',
      status_filter: {
        all: 'Todos',
        active: 'Activos',
        inactive: 'Inactivos',
      },
      headers: {
        shipping_name: 'Nombre',
        carrier_name: 'Paquetería',
        shipping_type: 'Tipo de envío',
        delivery_type: 'Tipo de entrega',
        country: 'País',
        is_active: 'Activo',
        is_cod: 'Contra entrega',
        extended_zone: 'Zona extendida',
        po_box_dropoff: 'PO Box',
        provides_pod: 'POD',
        enable_multipackage: 'Multipaquete',
        contract_provider: 'Proveedor',
        non_working_days: 'Días no laborables',
        actions: 'Acciones',
      },
      filters: {
        shipping_name: 'Nombre de envío',
        carrier_name: 'Paquetería',
        shipping_type: 'Tipo de envío',
        delivery_type: 'Tipo de entrega',
        is_active: 'Solo activos',
        inactive_only: 'Solo no activos',
      },
      form: {
        is_active: 'Activo',
        non_working_days: 'Días no laborables',
        non_working_days_help: 'Selecciona los días en que este método no opera',
        cancel: 'Cancelar',
        save: 'Guardar',
      },
      notifications: {
        update_success: 'Método de envío actualizado correctamente',
        update_error: 'Error al actualizar el método de envío',
      },
      errors: {
        fetch_error: 'Error al cargar los métodos de envío',
        no_access: 'No tienes acceso a esta sección',
      },
      actions: {
        activate: 'Activar',
        deactivate: 'Desactivar',
        confirm_activate: '¿Estás seguro de que deseas activar este método de envío?',
        confirm_deactivate: '¿Estás seguro de que deseas desactivar este método de envío?',
        manage_coverages: 'Gestionar coberturas',
        coverages_external_disabled: 'La cobertura de este método la gestiona el transportista o marketplace y no se puede editar desde Cubbo.',
      },
      history: {
        title: 'Historial de cambios',
        no_history: 'No hay historial de cambios para mostrar.',
        action: 'Acción',
        changes: 'Cambios',
        user: 'Usuario',
        date: 'Fecha',
        refresh: 'Actualizar',
        action_create: 'Creado',
        action_update: 'Actualizado',
        action_costs_update: 'Costos actualizados',
        action_costs_create: 'Costos creados',
        action_zone_sync: 'Zona editada',
        action_coverages_update: 'Coberturas actualizadas',
        action_coverages_create: 'Coberturas creadas',
        field_is_active: 'Activo',
        field_non_working_days: 'Días no laborables',
        field_extended_zone: 'Zona extendida',
        field_po_box_dropoff: 'PO Box',
        field_provides_pod: 'POD',
        field_enable_multipackage: 'Multipaquete',
        field_carrier_name: 'Paquetería',
        field_shipping_name: 'Nombre',
        field_cost: 'Costo',
        field_max_compound_weight: 'Peso máx. (kg)',
        field_coverage_enabled: 'Cobertura',
        field_xdock: 'Cross-dock',
        field_enabled: 'Activa',
        field_delivery_sla_in_hours: 'SLA (horas)',
        field_delivery_sla_offset: 'Ajuste de SLA',
        field_zone: 'Zona',
        show_all: 'Ver todos ({{count}})',
        show_less: 'Ver menos',
        showing_of_total: 'Se muestran {{shown}} de {{total}} cambios',
      },
    },
    shipping_costs: {
      loading: 'Cargando…',
      load_error: 'No se pudo cargar el estado de las zonas. Reintenta.',
      tabs: {
        tarifas: 'Zonas',
        xdock: 'Xdock',
        status: 'Tarifas por zona',
        missing_cost: 'Zonas sin costo',
        missing_xdock: 'Zonas sin xdock',
        update: 'Actualizar costos',
        create: 'Crear zonas',
      },
      banners: {
        action_title_one: '{{count}} zona requiere una acción',
        action_title_other: '{{count}} zonas requieren una acción',
        breakdown: '{{cost}} sin costo · {{xdock}} sin xdock',
        view: 'Ver zonas',
        clear: 'Ver todas',
      },
      actions: {
        create_costs: 'Crear costos',
        update_costs: 'Actualizar costos',
        create_single: 'Crear costo',
        update_single: 'Actualizar costo',
        bulk: 'Cargar csv',
        template: 'Descargar plantilla',
      },
      modal: {
        create: 'Crear costos en bloque',
        update: 'Actualizar costos en bloque',
        create_single: 'Crear costo',
        update_single: 'Actualizar costo',
      },
      single_form: {
        zone: 'Zona',
        zone_placeholder: 'Nombre de la zona (ej. ZONA_1)',
        zone_select_placeholder: 'Selecciona una zona',
        weight: 'Peso máximo (kg)',
        cost: 'Costo',
        currency: 'Moneda',
        xdock: 'Cross-dock (xdock)',
        xdock_placeholder: 'Selecciona un cross-dock',
        tier: 'Selecciona la zona a actualizar',
        tier_placeholder: 'Selecciona zona y tier',
        current_cost: 'Costo actual',
        new_cost: 'Costo nuevo',
        save: 'Guardar',
        saving: 'Guardando…',
        required: 'Completa los campos requeridos.',
        hint_xdock: 'Selecciona un cross-dock para poder guardar.',
      },
      bulk_wizard: {
        create_title: 'Crear costos por .csv',
        update_title: 'Actualizar costos por .csv',
        steps: {
          upload: 'Subir archivo',
          preview: 'Vista previa y validación',
          confirm: 'Confirmación',
        },
        drop_title: 'Arrastra tu archivo aquí o haz clic para buscar',
        drop_hint: 'Acepta archivos .csv',
        template_question: '¿Necesitas la plantilla?',
        template_desc: 'CSV con todas las columnas y validaciones precargadas.',
        download_template: 'Descargar plantilla',
        required_columns: 'Columnas del archivo',
        optional_tag: 'opcional',
        step_indicator: 'Paso {{current}} de {{total}}',
        manual: 'O ingresar manualmente',
        csv_only: 'Solo se aceptan archivos .csv',
        parse_error: 'No se pudo leer el archivo. Revisa el formato.',
        empty_file: 'El archivo no tiene filas válidas.',
        wrong_columns: 'El archivo no tiene las columnas esperadas. Usa la plantilla.',
        back: 'Volver',
        continue: 'Continuar',
        cancel: 'Cancelar',
        validate: 'Validar',
        validating: 'Validando…',
        apply: 'Aplicar',
        applying: 'Aplicando…',
        xdock_bindings: 'Asigna un cross-dock a cada zona nueva',
        xdock_binding_placeholder: 'Cross-dock para {{zone}}',
        xdock_binding_required: 'Asigna un cross-dock a cada zona para poder validar.',
        method_status_loading: 'Cargando la configuración del método…',
        method_status_error: 'No se pudo cargar la configuración del método. Ciérralo y vuelve a intentar.',
      },
      xdock_tab: {
        help: 'Cada zona Cubbo debe estar ligada a un cross-dock, si no la orden falla al rutear.',
        col_zone: 'Zona',
        col_xdock: 'Cross-dock',
        col_status: 'Estado',
        col_actions: 'Acciones',
        assigned: 'Asignado',
        missing: 'Falta xdock',
        empty: 'No hay zonas Cubbo para este método.',
        assign: 'Asignar xdock',
        edit: 'Editar',
        modal_title: 'Asignar / editar xdock',
        crossdocks_title: 'Cross-docks',
        crossdocks_help: 'Cross-docks disponibles en el país del método.',
        create_crossdock: 'Crear cross-dock',
        zones_title: 'Zonas y su cross-dock',
        col_country: 'País',
        col_zipcode: 'CP',
        col_processing: 'Tiempo de proceso (h)',
        col_phone: 'Teléfono',
        crossdocks_empty: 'No hay cross-docks en este país.',
      },
      xdock_form: {
        create_title: 'Crear cross-dock',
        edit_title: 'Editar cross-dock',
        name: 'Nombre',
        address: 'Dirección de envío',
        zipcode: 'Código postal',
        country: 'País',
        country_placeholder: 'Selecciona país',
        processing_time: 'Tiempo de proceso (horas)',
        phone: 'Teléfono',
        shipping_number: 'Número de envío',
        save: 'Guardar',
        saving: 'Guardando…',
        success: 'Cross-dock guardado correctamente.',
        error: 'No se pudo guardar el cross-dock.',
        required: 'Completa los campos requeridos.',
      },
      edit_zone: {
        title: 'Editar costos',
        zone: 'Zona',
        xdock: 'Cross-dock (xdock)',
        xdock_placeholder: 'Selecciona un cross-dock',
        ranges_title: 'Rangos de peso y costo',
        col_from: 'Desde peso',
        col_to: 'Hasta peso',
        col_cost: 'Costo',
        from_zero: 'Más de 0 kg',
        from_more: 'Más de {{weight}} kg',
        to_placeholder: 'Sin límite',
        add_range: 'Agregar rango',
        add_range_disabled_hint: 'Define el peso máximo del último rango antes de agregar otro.',
        disable: 'Inhabilitar',
        enable: 'Habilitar',
        remove: 'Quitar',
        save: 'Guardar',
        saving: 'Guardando…',
        error: 'No se pudo guardar. Revisa los datos.',
        incomplete_hint: 'Completa peso y costo (mayores a 0) en cada rango activo para guardar.',
        hint_xdock: 'Selecciona un cross-dock para poder guardar.',
        hint_duplicate_weight: 'Hay dos rangos con el mismo peso máximo. Usa pesos distintos.',
      },
      status: {
        filter_placeholder: 'Filtrar por una o varias zonas',
        export: 'Descargar CSV para actualizar',
        empty: 'No hay zonas para mostrar.',
        col_zone: 'Zona',
        col_tiers: 'Tarifa por peso',
        tier_weight: '≤ {{weight}} kg',
        col_cost: 'Costos',
        col_edit: 'Editar',
        edit: 'Editar',
        edit_menu: {
          costs: 'Editar costos',
          xdock: 'Editar xdock',
        },
        not_configured: 'Sin configurar',
        costs_count_one: '{{count}} costo configurado',
        costs_count_other: '{{count}} costos configurados',
        no_coverage: 'Sin cobertura',
        no_coverage_hint:
          'Esta zona no tiene códigos postales asignados en coberturas, así que su precio nunca se aplica y no puede editarse. Asigna cobertura a la zona o elimina su precio.',
        tier_range_first: '≤ {{max}} kg',
        tier_range: '{{min}} – {{max}} kg',
        tier_range_open: 'Más de {{min}} kg',
        col_tier_weight: 'Rango de peso',
        col_tier_cost: 'Costo',
        col_tier_id: 'ID',
        tier_cost: '{{currency}} {{cost}}',
        tier_line: '≤ {{weight}} kg · {{cost}}',
        col_xdock: 'Zona xdock',
        col_missing: 'Qué falta',
        yes: 'Sí',
        no: 'No',
        not_applicable: 'N/A',
        ok: 'Completa',
        notices: {
          UNUSED_COST: 'Sin uso',
          COST_UNREACHABLE: 'Precio no usable',
        },
        showing: 'Mostrando {{from}}–{{to}} de {{total}}',
        prev: 'Anterior',
        next: 'Siguiente',
        missing: {
          MISSING_COST: 'Falta precio',
          MISSING_XDOCK_ZONE: 'Falta zona xdock',
        },
      },
      missing_cost: {
        help: 'Estas zonas tienen cobertura pero no tienen precio, por lo que sus órdenes fallan al cotizar. Deberían ser 0 — créalas cuanto antes.',
        empty: 'Todo en orden: no hay zonas sin costo.',
        create_button: 'Crear tarifas ({{count}})',
        col_zone: 'Zona',
        col_type: 'Tipo',
        cubbo_needs_xdock: 'Cubbo (también necesitará xdock)',
        standard: 'Estándar',
      },
      missing_xdock: {
        help: 'Estas zonas Cubbo tienen precio pero les falta la zona xdock, por lo que sus órdenes fallan al rutear. Deberían ser 0 — selecciónalas y asígnales un cross-dock.',
        empty: 'Todo en orden: no hay zonas sin xdock.',
        select_placeholder: 'Selecciona un cross-dock',
        assign_button: 'Asignar xdock ({{count}})',
        assigning: 'Asignando…',
        assign_error: 'No se pudo asignar el xdock. Intenta de nuevo.',
        col_zone: 'Zona',
        col_cost: 'Precio',
      },
      update: {
        help: 'Pega o sube un CSV (id del shipping_cost y nuevo precio). Puedes descargar el archivo pre-llenado desde la pestaña "Tarifas por zona". El precio es opcional si solo quieres habilitar/deshabilitar la cobertura de esa fila; cada fila debe traer al menos un precio o un cambio de cobertura.',
        col_id: 'ID del shipping_cost',
        col_cost: 'Nuevo precio',
        col_weight: 'Peso máx. (kg)',
        col_enabled: 'Cobertura',
        enabled_unset: '— Sin cambio',
        enabled_yes: 'Habilitar',
        enabled_no: 'Deshabilitar',
        validate: 'Validar',
        validating: 'Validando…',
        apply: 'Aplicar',
        applying: 'Aplicando…',
      },
      create: {
        help: 'Da de alta precios para zonas nuevas. El precio y el peso máx. compuesto deben ser mayores a 0 (usa un techo alto, ej. 999, para un precio plano). Puedes repetir la misma zona con distintos techos de peso para cobrar por rango (tiers). Para métodos Cubbo debes indicar además a qué cross-dock (xdock) pertenece cada zona.',
        col_zone: 'Zona (tarif_zone)',
        col_cost: 'Precio',
        col_weight: 'Peso máx. compuesto',
        col_currency: 'Moneda (opcional)',
        validate: 'Validar',
        validating: 'Validando…',
        apply: 'Crear',
        applying: 'Creando…',
        xdock: {
          title: 'Cross-dock por zona (Cubbo)',
          help: 'Cada zona nueva de Cubbo necesita una zona xdock; si falta, la orden no puede rutear el last-mile.',
          select_placeholder: 'Selecciona un cross-dock',
        },
      },
      validation: {
        valid: 'Todo se ve bien. Listo para aplicar.',
        invalid: 'Se encontraron {{count}} errores. Corrígelos y vuelve a validar.',
        request_failed: 'La solicitud falló. Intenta de nuevo.',
        row: 'Fila',
        message: 'Error',
      },
    },
    coverage_manager: {
      title: 'Coberturas del método',
      back_to_methods: 'Volver a métodos de envío',
      view_history: 'Ver historial',
      not_found: 'No se encontró el método de envío solicitado.',
      external_notice: 'La cobertura de este método la gestiona el transportista o marketplace. Las acciones de edición están deshabilitadas.',
      inactive_notice: 'Este método está desactivado. Las coberturas siguen siendo editables, pero el método no acepta envíos hasta que se reactive.',
      inactive_banner: 'Este método de envío está desactivado. No será elegible para asignarse a nuevos pedidos hasta que se reactive.',
      inactive_banner_with_date:
        'Este método de envío está desactivado desde el {{date}}. No será elegible para asignarse a nuevos pedidos hasta que se reactive.',
      external_disabled_tooltip: 'Cobertura gestionada externamente: no editable desde Cubbo.',
      no_permission_tooltip: 'No tienes permisos para editar coberturas.',
      actions_title: '¿Qué deseas hacer?',
      other_actions_title: 'Otras opciones',
      field: {
        shipping_name: 'Nombre',
        carrier_name: 'Paquetería',
        delivery_type: 'Tipo de entrega',
        country: 'País',
      },
      bulk_manage: {
        title: 'Gestionar coberturas en masa',
        description: 'Filtra, selecciona y actualiza coberturas específicas. Soporta búsqueda por zona, prefijo o rango, y carga/descarga por CSV.',
        hint: 'Recomendado para la mayoría de los cambios — permite revisar antes de aplicar.',
      },
      edit_by_range: {
        title: 'Editar por rango de código postal',
        description: 'Actualiza coberturas para uno o varios rangos de CP. Carga un CSV o ingrésalos manualmente.',
        hint: 'Útil para cambios localizados sin revisar coberturas individuales.',
      },
      edit_all: {
        title: 'Editar todas las coberturas',
        description: 'Aplica un cambio único a todas las coberturas activas del método (SLA, offset o estado).',
        hint: 'Útil para activar o desactivar el método completo en una sola operación.',
      },
      non_working_days: {
        title: 'Días no laborables',
        help: 'Selecciona los días en que este método no opera.',
        save: 'Actualizar días no laborales',
        update_success: 'Días no laborables actualizados correctamente',
        update_error: 'Error al actualizar los días no laborables',
      },
      status_active: 'Activo',
      status_inactive: 'Inactivo',
      tabs: {
        coverages: 'Coberturas',
        non_working_days: 'Días no laborables',
        dispatch_schedules: 'Horarios de recolección',
        draft: 'Borrador (actual)',
      },
      coverages_table: {
        filters: 'Filtrar',
        clear_filters: 'Limpiar filtros',
        export: 'Exportar',
        exporting: 'Exportando…',
        export_in_progress: 'Exportando coberturas, espera un momento…',
        export_success: 'Exportado exitosamente',
        export_empty: 'No hay coberturas para exportar con esos filtros.',
        export_error: 'No se pudo exportar la información.',
        export_truncated:
          'Se exportaron las primeras {{rows}} coberturas. El método tiene demasiadas para exportar de una vez — usa los filtros para acotar el resultado.',
        page_of_many: 'Página {{page}} · más de {{cap}} coberturas',
        selection: {
          count: '{{count}} seleccionados',
          update: 'Actualizar seleccionados',
          deactivate: 'Desactivar seleccionados',
          deactivate_error: 'No se pudieron desactivar las coberturas seleccionadas.',
          clear: 'Limpiar selección',
        },
        filter_panel: {
          status: 'Estado',
          status_all: 'Todas',
          status_active: 'Activa',
          status_inactive: 'Inactiva',
          extended_zone: 'Zona extendida',
          extended_zone_yes: 'Sí',
          extended_zone_no: 'No',
          zone: 'Zona',
          zone_all: 'Todas las zonas',
          cp: 'Código postal',
          cp_placeholder: 'Ej: 01000',
          range: 'Rango de CP',
          range_start: 'CP inicial',
          range_end: 'CP final',
          apply: 'Aplicar',
        },
        update_coverage: 'Actualizar cobertura',
        create_coverage: 'Crear cobertura',
        empty: 'No hay coberturas para mostrar.',
        load_error: 'Error al cargar las coberturas.',
        headers: {
          postal_code: 'Código postal',
          zone: 'Zona',
          extended_zone: 'Zona extendida',
          sla_hours: 'SLA (horas)',
          sla_offset: 'SLA offset',
          status: 'Estado',
        },
        boolean_yes: 'Sí',
        boolean_no: 'No',
      },
      create_modal: {
        title: 'Crear cobertura',
        chooser_hint: '¿Cómo quieres crear las coberturas?',
        back: 'Volver',
        close: 'Cerrar',
        use_existing_flow: 'Por ahora, usa el flujo actual de creación',
        single: {
          title: 'Crear cobertura',
          description: 'Crea una cobertura para un código postal individual.',
          placeholder: 'Pendiente de implementación: formulario para crear un nuevo código postal.',
          submit: 'Crear cobertura',
          tab_single: 'Un solo CP',
          tab_range: 'Rango de CP',
          section_location: 'Código postal y zona',
          section_delivery: 'Tiempos y costos',
          optional_hint: 'Opcionales — vacíos usan el valor por defecto del método',
          fix_errors: 'Corrige lo siguiente y vuelve a intentar:',
          already_exists_count: '{{count}} CP ya existen',
          error: 'No se pudo crear la cobertura. Revisa tu conexión e inténtalo de nuevo.',
        },
        bulk: {
          title: 'Cargar csv',
          description: 'Sube una hoja de cálculo (CSV o XLSX) con múltiples coberturas.',
          placeholder: 'Pendiente de implementación: subida de hoja de cálculo.',
          drop_hint: 'Arrastra un archivo aquí o haz click para seleccionarlo (.csv, .xlsx)',
        },
      },
      update_modal: {
        menu: {
          single: 'Actualizar cobertura',
          bulk: 'Cargar csv',
          all: 'Toda la cobertura',
        },
        tab_single: 'Un solo CP',
        tab_range: 'Rango de CP',
        tab_all: 'Toda la cobertura',
        range_preview: '{{count}} CP se actualizarán',
        range_apply_title: 'Valores a aplicar a todo el rango',
        single: {
          title: 'Actualizar cobertura',
          search_label: 'Código postal',
          search_placeholder: 'Ej: 01000',
          search_help: 'Busca el CP para ver y editar su configuración actual.',
          search_button: 'Buscar',
          searching: 'Buscando…',
          not_found: 'No existe una cobertura con ese CP en este método de envío.',
          change_cp: 'Cambiar CP',
        },
        all: {
          title: 'Actualizar toda la cobertura',
          warning: 'Estos cambios se aplicarán a todos los códigos postales de este método de envío.',
        },
        selected: {
          warning: 'Estos cambios se aplicarán a los {{count}} códigos postales seleccionados.',
        },
        sla_warning: 'El SLA supera las 72 horas. Verifica que el valor sea correcto antes de actualizar.',
        bulk: {
          title: 'Actualizar desde Excel',
          placeholder: 'Pendiente de implementación: actualización masiva desde hoja de cálculo.',
          drop_hint: 'Arrastra un archivo aquí o haz click para seleccionarlo (.csv, .xlsx)',
        },
        fields: {
          cp: 'Código postal',
          sla: 'SLA',
          sla_help: 'Compromiso de la paquetería para entregar.',
          sla_placeholder: 'Ej: 24',
          sla_offset: 'SLA offset',
          sla_offset_help: 'Suma a la fecha de entrega prometida.',
          sla_offset_placeholder: 'Ej: 0',
          status: 'Estado',
          status_help: 'Al desactivarse, no se asignarán nuevos pedidos.',
          status_no_change: 'Sin cambio',
          status_keep: 'Mantener actual',
          status_active: 'Activa',
          status_paused: 'Desactivada',
          hours_suffix: 'horas',
          zone: 'Zona',
          zone_keep: 'Mantener zona actual',
          zone_help: 'Reclasifica: la zona define la tarifa (y, en Cubbo, la ruta).',
          zone_loading: 'Cargando zonas del método…',
          zone_empty: 'Este método aún no tiene zonas con tarifa ni en uso. Configúralas en la pestaña de costos.',
          zone_load_failed: 'No pudimos cargar las zonas del método. Recarga la página antes de reclasificar.',
          extended_zone: 'Zona extendida',
          extended_zone_keep: 'Mantener actual',
          extended_zone_yes: 'Sí',
          extended_zone_no: 'No',
          extended_zone_help: 'Recargo ODA/OPA que se suma a la tarifa de la zona.',
        },
        zone_section_title: 'Zona y recargo',
        zone_method_wide_note:
          'La zona no se puede cambiar para todo el método: el barrido dejaría todas las coberturas en una sola zona y no hay historial para revertirlo. Cámbiala por CP, por rango o seleccionando coberturas en el listado.',
        extended_zone_method_wide_warning:
          'La zona extendida se aplicará a TODOS los códigos postales del método: los que hoy la tienen quedarán igual que los demás y no hay historial por CP para revertirlo.',
        zone_rewrite_range_warning:
          'Se reescribirá la zona o el recargo de los {{count}} CP del rango, incluidos los que hoy están desactivados, y no queda historial por CP para revertirlo.',
        zone_none_applies_warning:
          'NONE_APPLIES deja las coberturas sin llave de tarifa (y, en Cubbo, sin llave de ruteo). Úsala solo si vas a cargar la tarifa después.',
        server_codes: {
          INVALID_ZONE: 'El nombre de zona es inválido.',
          ZONE_HAS_NO_SHIPPING_COST: 'La zona no tiene una tarifa que el sistema pueda usar en este método.',
          ZONE_COST_SHADOWED_BY_DISABLED_TIER: 'Un tramo de peso deshabilitado más barato bloquea la tarifa de la zona.',
          ZONE_HAS_NO_XDOCK: 'La zona no está vinculada a ningún xdock: un pedido de Cubbo Last Mile no podría rutearse.',
          ZONE_HAS_NO_XDOCK_ROUTE: 'El xdock de la zona no tiene ruta de entrega habilitada.',
          MISSING_EXTENDED_ZONE_COST: 'Este método no tiene tarifa EXTENDED_ZONE: el recargo quedaría sin precio.',
          ZONE_UPDATE_NOT_ALLOWED_METHOD_WIDE: 'La zona no se puede cambiar para todo el método. Hazlo por CP, por rango o sobre una selección.',
          NO_UPDATE_PARAMETERS: 'No enviaste ningún campo para actualizar.',
          TOO_MANY_IDS: 'Seleccionaste demasiadas coberturas. Usa la actualización por rango.',
          COVERAGE_IDS_NOT_IN_METHOD: 'Alguna de las coberturas no pertenece a este método de envío.',
          INVALID_RANGE: 'El rango de CP es inválido.',
        },
        require_field: 'Elige al menos un campo para actualizar.',
        submit: 'Actualizar cobertura',
        error: 'No se pudo actualizar la cobertura. Revisa tu conexión e inténtalo de nuevo.',
      },
      bulk_upload: {
        title: 'Cargar coberturas por .csv',
        title_update: 'Actualizar coberturas por .csv',
        steps: {
          upload: 'Subir archivo',
          preview: 'Vista previa y validación',
          confirm: 'Confirmación',
        },
        drop_title: 'Arrastra tu archivo aquí o haz clic para buscar',
        drop_hint: 'Acepta archivos .csv',
        template_question: '¿Necesitas la plantilla?',
        template_desc: 'Excel con todas las columnas y validaciones precargadas.',
        download_template: 'Descargar plantilla',
        required_columns: 'Columnas del archivo',
        optional_tag: 'opcional',
        // Column hints. `vocab_*` is the single list of words a closed-vocabulary column
        // accepts: it is interpolated into the hint AND into issue_invalid_value, so the
        // screen can never ask for a spelling the validator rejects.
        hint_range_start: '(CP o inicio de rango)',
        hint_range_ends: '(fin de rango)',
        hint_percent: '(%)',
        hint_values: '({{values}})',
        // Shared by `estado` and by the update CSV's `zona_extendida`: both are closed
        // columns whose blank cell means "leave this CP alone".
        hint_values_keep: '({{values}} — vacío: no cambiar)',
        hint_keep: '(vacío: no cambiar)',
        vocab_si_no: 'sí/no',
        vocab_estado: 'activa/desactivada',
        step_indicator: 'Paso {{current}} de {{total}}',
        change: 'Cambiar',
        rows_detected: '{{count}} filas detectadas',
        preview_title: 'Vista previa · Primeras {{count}} filas',
        valid_title: '{{count}} filas válidas, listas para importar',
        warnings_title: '{{count}} filas con avisos',
        warnings_desc: 'Offsets mayores a 72h.',
        errors_title: '{{count}} filas con errores',
        errors_desc: 'Faltan campos obligatorios o tienen formato inválido.',
        issue_missing: 'falta el dato ({{count}})',
        issue_format: 'formato inválido ({{count}})',
        issue_invalid_value: 'valor no aceptado, usa {{values}} ({{count}})',
        issue_too_wide: 'rango demasiado amplio, máximo {{max}} códigos ({{count}})',
        issue_no_update_fields: 'la fila no cambia nada: llena zona, zona_extendida, sla_horas, sla_offset o estado ({{count}})',
        unsupported_country: 'La carga por planilla todavía no soporta coberturas de {{country}}. Usa las pestañas de CP individual o rango.',
        padded_notice:
          '{{count}} filas traían el código postal sin el cero inicial (Excel lo lee como número); se restauró. Verifica que no sea un dígito faltante.',
        too_many_coverages: 'El archivo crearía {{count}} coberturas y el máximo por carga es {{max}}. Divide el archivo en varias cargas.',
        wide_range_notice:
          '{{count}} filas cubren rangos amplios ({{codes}} códigos postales en total). Se aplicará a todos: revisa que el fin de rango sea el correcto.',
        see_detail: 'Ver detalle',
        rows_affected: 'CP: {{list}}',
        back: 'Atrás',
        import: 'Importar {{count}} filas',
        step2_indicator: 'Paso 2 de 3 · ignora {{count}} filas con errores',
        csv_only: 'La vista previa está disponible para archivos CSV. Descarga y usa la plantilla CSV.',
        parse_error: 'No se pudo leer el archivo. Revisa que tenga encabezados y al menos una fila de datos.',
        zone_rewrite_notice:
          '{{count}} filas con rango traen zona: se reclasificarán TODOS los CP del rango, incluidos los que hoy están desactivados. La zona define la tarifa que cobramos y pagamos.',
        extended_zone_rewrite_notice:
          '{{count}} filas con rango traen zona_extendida: se aplicará a TODOS los CP del rango, así que los que hoy tienen el recargo quedarán igual que los demás.',
        status_rewrite_notice:
          '{{count}} filas con rango traen estado: se aplicará a TODOS los CP del rango, incluidos los que hoy están desactivados. Deja la columna estado vacía para cambiar solo el SLA.',
        create_status_ignored: '{{count}} filas traen estado desactivada, pero las coberturas siempre se crean activas. Desactívalas después desde el listado.',
        error: 'No se pudo completar la importación. Revisa tu conexión e inténtalo de nuevo.',
        job_failed: 'La importación falló en el servidor. Revisa el archivo e inténtalo de nuevo.',
        job_partial: 'La importación se aplicó solo en parte ({{applied}} filas). Revisa el detalle del archivo antes de reintentar.',
        job_unavailable: 'No pudimos confirmar el resultado de la importación. Revisa las coberturas en el listado antes de volver a cargar el archivo.',
        no_rows_matched:
          'El archivo se procesó, pero ningún CP coincidió con la cobertura de este método: no se actualizó nada. Verifica que los CP existan en este método de envío.',
        no_job: 'El servidor no confirmó la importación. Revisa las coberturas en el listado antes de reintentar.',
        confirm_placeholder: 'Confirmación — próximamente.',
        importing: 'Importando coberturas…',
        done_title: 'Coberturas importadas',
        done_summary: '{{imported}} importadas · {{skipped}} omitidas',
        imported_by: 'Importadas por',
        file_label: 'Archivo',
        date_label: 'Fecha',
        changes_applied: 'Cambios aplicados al método',
        close: 'Cerrar',
        view_coverages: 'Ver coberturas',
        cost_column_ignored:
          'La columna cost se ignora: el costo es por zona y tramo de peso, y se configura en la pestaña de costos. Este archivo solo crea coberturas.',
        server_errors_title: 'El servidor rechazó el archivo · {{count}} filas con problemas',
        server_codes: {
          INVALID_VALUE: 'CP con formato inválido para el país del método',
          DUPLICATE_VALUE_IN_PAYLOAD: 'CP repetido dentro del archivo',
          COVERAGE_ALREADY_EXISTS: 'El CP ya tiene cobertura en este método',
          ZONE_HAS_NO_XDOCK: 'La zona no está vinculada a ningún xdock del país',
          ZONE_HAS_NO_SHIPPING_COST: 'La zona no tiene costo de envío en este método',
          INVALID_ZONE: 'El nombre de zona es inválido',
          ZONE_COST_SHADOWED_BY_DISABLED_TIER: 'Un tramo de peso deshabilitado más barato bloquea la tarifa de la zona',
          ZONE_HAS_NO_XDOCK_ROUTE: 'El xdock de la zona no tiene ruta de entrega habilitada',
          MISSING_EXTENDED_ZONE_COST: 'Este método no tiene tarifa EXTENDED_ZONE: el recargo quedaría sin precio',
          ZONE_UPDATE_NOT_ALLOWED_METHOD_WIDE: 'La zona no se puede cambiar para todo el método. Hazlo por CP, por rango o sobre una selección',
          NO_UPDATE_PARAMETERS: 'Alguna fila no trae ningún campo para actualizar',
          INVALID_RANGE: 'Alguna fila tiene un rango de CP inválido',
        },
        server_code_unknown: 'Error {{code}}',
        server_zones_affected: 'Zonas: {{list}}',
        server_rows_sample: 'CP: {{list}}',
        server_more: '+{{count}} más',
        server_available_zones: 'Zonas con costo configurado en este método: {{list}}',
      },
      dispatch_placeholder: 'Los horarios de recolección se gestionan a nivel almacén. Próximamente accesibles desde aquí filtrados por este método.',
      dispatch_link_text: 'Los horarios de recolección se gestionan a nivel almacén.',
      dispatch_link_label: 'Ir a Horarios de recolección',
      draft_notice: 'Vista de la pantalla actual. Se mantiene aquí como referencia mientras migramos su contenido a las pestañas nuevas.',
    },
    dispatch_schedules: {
      title: 'Horarios de despacho',
      empty_table: 'No hay horarios de despacho para mostrar.',
      footer_text: 'horarios',
      add_schedule: 'Crear horario',
      edit_schedule: 'Editar horario',
      actions: {
        enable: 'Activar',
        disable: 'Desactivar',
        delete: 'Eliminar',
        confirm_enable: '¿Estás seguro de que deseas activar este horario?',
        confirm_disable: '¿Estás seguro de que deseas desactivar este horario?',
        confirm_delete: '¿Estás seguro de que deseas eliminar este horario? Esta acción no se puede deshacer.',
        duplicate: 'Duplicar',
      },
      headers: {
        carrier_name: 'Paquetería',
        dispatch_day: 'Día de despacho',
        dispatch_time: 'Hora de despacho',
        time_before_dispatch: 'Tiempo antes de despacho',
        enable: 'Habilitado',
        channel_type: 'Canal de venta',
        shipping_state: 'Estado de destino',
        actions: 'Acciones',
        created_at: 'Creado',
        updated_at: 'Actualizado',
      },
      filters: {
        carrier_name: 'Paquetería',
        enable: 'Solo habilitados',
        disable: 'Solo desactivados',
        dispatch_day: 'Día de despacho',
        channel_type_id: 'Canal de venta',
        shipping_state: 'Estado de destino',
        shipping_method_id: 'Método de envío',
      },
      form: {
        carrier_name: 'Paquetería',
        dispatch_day: 'Día de despacho',
        dispatch_time: 'Hora de despacho',
        time_before_dispatch: 'Tiempo antes de despacho',
        enable: 'Habilitado',
        channel_type: 'Canal de venta',
        shipping_state: 'Estado de destino',
        select_channel_type: 'Seleccionar canal',
        select_shipping_state: 'Seleccionar estado',
        no_filter: 'Sin filtro (genérico)',
        all_states: 'Todos los estados',
        all_channels: 'Todos los canales',
        cancel: 'Cancelar',
        save: 'Guardar',
        create: 'Crear',
        update: 'Actualizar',
        select_carrier: 'Seleccionar paquetería',
        select_day: 'Seleccionar al menos un día',
        dispatch_days: 'Días de despacho',
        select_all_days: 'Todos los días',
        select_weekdays: 'Lunes a viernes',
        time_before_value: 'Cantidad',
        time_before_unit: 'Unidad',
        time_before_help: 'Tiempo mínimo antes de la hora de despacho en que los pedidos deben estar listos para ser enviados.',
        cutoff_preview: 'Los pedidos deberán estar listos antes de las {{time}}',
        warning_over_2h: '⚠ El tiempo antes de despacho es mayor a 2 horas. ¿Estás seguro de que es correcto?',
        warning_days_before: '⚠ El corte caería en un día anterior al despacho. Verifica que este valor sea correcto.',
        schedule_type: 'Tipo de horario',
        type_carrier: 'Por paquetería',
        type_cross_carrier: 'Por canal de venta',
        type_shipping_method: 'Por método de envío',
        type_carrier_help: 'Aplica solo a una paquetería específica.',
        type_cross_carrier_help: 'Aplica a pedidos que coincidan con el canal de venta y/o estado, si su paquetería es guía externa.',
        type_shipping_method_help: 'Aplica solo a un método de envío específico.',
        cross_carrier_requirement: 'El canal de venta es obligatorio.',
        shipping_method: 'Método de envío',
        select_shipping_method: 'Seleccionar método de envío',
      },
      sort: {
        by_dispatch_time: 'Ordenar por hora de despacho',
        by_cutoff_time: 'Ordenar por hora de corte',
      },
      cutoff_label: 'Corte',
      disabled_label: 'Deshabilitado',
      moving: 'Moviendo...',
      confirm_move: {
        title: 'Mover horario de despacho',
        description: '¿Estás seguro de mover {{count}} horario(s) al día {{day}}?',
        confirm: 'Mover',
        cancel: 'Cancelar',
      },
      bulk: {
        select: 'Seleccionar varios horarios',
        exit_selection: 'Cancelar selección',
        select_action: 'Selecciona una acción',
        select_all: 'Seleccionar todos',
        deselect_all: 'Deseleccionar todos',
        schedules_selected: 'horario(s) seleccionado(s)',
        confirm_enable_title: 'Activar horarios',
        confirm_enable_description: '¿Estás seguro de que deseas activar {{count}} horario(s)?',
        confirm_disable_title: 'Desactivar horarios',
        confirm_disable_description: '¿Estás seguro de que deseas desactivar {{count}} horario(s)?',
        confirm_delete_title: 'Eliminar horarios',
        confirm_delete_description: '¿Estás seguro de que deseas eliminar {{count}} horario(s)? Esta acción no se puede deshacer.',
      },
      today: 'Hoy',
      warehouse_time: 'Hora del almacén',
      cutoff_days_before_one: '{{count}} día antes',
      cutoff_days_before_other: '{{count}} días antes',
      duration_units: {
        hours_one: '{{count}} hora',
        hours_other: '{{count}} horas',
        minutes: '{{count}} min',
        unit_hours: 'Horas',
        unit_minutes: 'Minutos',
      },
      notifications: {
        create_success: 'Horario de despacho creado correctamente',
        create_error: 'Error al crear el horario de despacho',
        update_success: 'Horario de despacho actualizado correctamente',
        hidden_by_filter: 'El horario se ocultó de la vista por el filtro activo',
        update_error: 'Error al actualizar el horario de despacho',
        delete_success: 'Horario de despacho eliminado correctamente',
        delete_error: 'Error al eliminar el horario de despacho',
        move_success: 'Horario de despacho movido correctamente',
        move_error: 'Error al mover el horario de despacho',
        bulk_enable_success: '{{count}} horario(s) activado(s) correctamente',
        bulk_enable_error: 'Error al activar los horarios',
        bulk_already_enabled: '{{names}} ya se encuentra(n) activado(s)',
        bulk_disable_success: '{{count}} horario(s) desactivado(s) correctamente',
        bulk_disable_error: 'Error al desactivar los horarios',
        bulk_already_disabled: '{{names}} ya se encuentra(n) desactivado(s)',
        bulk_delete_success: '{{count}} horario(s) eliminado(s) correctamente',
        bulk_delete_error: 'Error al eliminar los horarios',
        bulk_partial_error: '{{succeeded}} exitoso(s), {{failed}} fallido(s)',
      },
      errors: {
        fetch_error: 'Error al cargar los horarios de despacho',
        no_access: 'No tienes acceso a esta sección',
        required_fields: 'Por favor completa todos los campos requeridos',
      },
      history: {
        title: 'Historial de cambios',
        no_history: 'No hay historial de cambios para mostrar.',
        action: 'Acción',
        changes: 'Cambios',
        user: 'Usuario',
        date: 'Fecha',
        refresh: 'Actualizar',
        action_create: 'Creado',
        action_update: 'Actualizado',
        action_delete: 'Eliminado',
        deleted_label: 'Horario eliminado',
        field_carrier_name: 'Paquetería',
        field_dispatch_day: 'Día de despacho',
        field_dispatch_time: 'Hora de despacho',
        field_time_before_dispatch: 'Tiempo antes de despacho',
        field_enable: 'Habilitado',
        field_channel_type_id: 'Canal de venta',
        field_shipping_state: 'Estado de destino',
        field_shipping_method_id: 'Método de envío',
      },
      generic_label: 'Genérico',
      cross_carrier_label: 'Por Integración',
      shipping_method_label: 'Método de envío',
      grouped_view: {
        all_carriers: 'Todas las paqueterías',
        all_channels: 'Todos los canales',
        all_states: 'Todos los estados',
        all_shipping_methods: 'Todos los métodos',
        all_status: 'Todos',
        enabled_only: 'Solo habilitados',
        disabled_only: 'Solo desactivados',
        reset_filters: 'Limpiar filtros',
      },
    },
    automated_coverage_deactivations: {
      title: 'Coberturas auto-desactivadas',
      footerText: 'desactivaciones',
      filters: {
        onlyPending: 'Solo pendientes',
        carrier: 'Paquetería',
        allCarriers: 'Todas las paqueterías',
        dateRange: 'Rango de fechas',
        dateFrom: 'Desde',
        dateTo: 'Hasta',
      },
      columns: {
        deactivatedAt: 'Fecha',
        carrier: 'Paquetería',
        shippingMethod: 'Método',
        zipCode: 'CP',
        message: 'Mensaje de error',
        order: 'Pedido',
        status: 'Estado',
        actions: 'Acciones',
      },
      status: {
        pending: 'Por revisar',
        acknowledged: 'Revisado',
      },
      actions: {
        acknowledge: 'Marcar como revisado',
      },
      empty: {
        default: 'No hay coberturas auto-desactivadas pendientes de revisión.',
        defaultPerWarehouse: 'No hay coberturas auto-desactivadas pendientes de revisión en este almacén.',
        withFilters: 'No se encontraron resultados con los filtros aplicados.',
      },
      scopeTooltip: 'Solo se muestran desactivaciones disparadas por órdenes de este almacén.',
      errors: {
        noAccess: 'No tienes permiso para ver esta sección.',
        fetchError: 'No se pudieron cargar las desactivaciones.',
        retry: 'Reintentar',
      },
      toast: {
        acknowledgeSuccess: 'Marcado como revisado',
        acknowledgeError: 'No se pudo marcar como revisado. Intenta de nuevo.',
        notFoundError: 'La desactivación ya no existe',
      },
      drawer: {
        title: 'Detalle de desactivación',
        shipping: 'Información del envío',
        shippingType: 'Tipo',
        shippingMethodUnavailable: 'Información del método no disponible.',
        coverage: 'Cobertura desactivada',
        coverageUnavailable: 'Cobertura no disponible.',
        coverageReenabled: 'Re-habilitada manualmente',
        zone: 'Zona',
        enabled: 'Habilitada',
        extendedZone: 'Zona extendida',
        poBoxDropoff: 'PO Box',
        error: 'Error que disparó',
        errorCode: 'Código',
        responseBody: 'Response del carrier',
        copyResponse: 'Copiar',
        copied: 'Copiado',
        metadataMissing: 'Metadata no disponible. Mostrando mensaje crudo.',
        noOrder: 'Sin orden asociada',
        noError: 'Sin error asociado',
        dates: 'Fechas',
        deactivatedAt: 'Desactivado',
        acknowledgedAt: 'Revisado',
        warning: 'Si verificas que el error ocurrido no debería apagar la cobertura, avisa a tech para que ajuste la regla.',
        close: 'Cerrar',
      },
    },
  },

  deleted_lost_history: {
    title: 'Historial de Eliminaciones de Stock Perdido',
    go_back: 'Volver a Eliminar Stock',
    records: 'Registros',
    empty_table: 'No hay eliminaciones registradas para el rango de fechas seleccionado.',
    initial_message: 'Selecciona un rango de fechas y presiona Buscar para ver el historial de eliminaciones.',
    total_deleted: 'Total de unidades eliminadas en el periodo: {{count}}',
    error_loading: 'Error al cargar el historial de eliminaciones.',
    filters: {
      date_range: 'Rango de fechas',
      start_date: 'Fecha inicio',
      end_date: 'Fecha fin',
      store_name: 'Tienda',
      sku: 'SKU',
      bar_code: 'UPC',
      lot: 'Lote',
      search: 'Buscar',
      clear: 'Limpiar',
    },
    columns: {
      discarded_at: 'Fecha de Eliminación',
      store_name: 'Tienda',
      sku: 'SKU',
      bar_code: 'UPC',
      lot: 'Lote',
      quantity: 'Cantidad Eliminada',
      location: 'Ubicación',
      discarded_by: 'Eliminado por',
    },
  },

  cycle_counts: {
    title: 'Conteos Ciclicos',
    warehouse: 'Almacen',
    assign_button: 'Asignar',
    tabs: {
      locations: 'Ubicaciones',
      conteos: 'Conteos',
      reviews: 'Revisiones',
    },
    locations: {
      title: 'ubicaciones',
      location_code: 'Codigo de Ubicacion',
      zone: 'Area',
      location_type: 'Tipo de Ubicacion',
      store: 'Tienda',
      sku: 'SKU',
      upc: 'UPC',
      assignment_status: 'Estado de Asignacion',
      status_available: 'Disponible',
      status_assigned: 'Asignado a {{operator}}',
      last_counted_at: 'Ultimo conteo',
      never_counted: 'Nunca contado',
      empty_table: 'No hay ubicaciones disponibles.',
      filters: {
        location_code: 'Buscar por codigo',
        zone: 'Buscar por area',
        location_type: 'Buscar por tipo',
        store: 'Buscar por tienda',
        sku: 'Buscar por SKU',
        upc: 'Buscar por UPC',
      },
    },
    conteos: {
      operator: 'Operador',
      locations_count: 'Ubicaciones',
      progress: 'Progreso',
      status: 'Estado',
      assigned_date: 'Fecha de Asignacion',
      status_pending: 'Pendiente',
      status_in_progress: 'En Progreso',
      status_completed: 'Completado',
      status_review_pending: 'Revision Asignada',
      status_review_submitted: 'Revision Completada',
      status_resolved: 'Resuelto',
      status_unassigned: 'Sin Asignar',
      status_in_review: 'En Revisión',
      pending_reviews: '{{count}} revisiones pendientes',
      origin: 'Origen',
      origin_manual: 'Manual',
      origin_missing_stock: 'Producto Faltante',
      origin_coverage_event: 'Evento',
      origin_mixed: 'Mixto',
      empty_table: 'No hay conteos ciclicos.',
      load_error: 'No se pudieron cargar los conteos. Reintenta más tarde.',
      filters: {
        operator: 'Buscar por operador',
        status: 'Estado',
        origin: 'Origen',
      },
    },
    reviews: {
      location: 'Ubicación',
      counter: 'Contador',
      divergent_products: 'SKUs con diferencia',
      status: 'Estado',
      attempts: 'Intentos',
      submitted_at: 'Enviado',
      reviewer: 'Revisor',
      unassigned_group: 'Sin asignar',
      status_unassigned: 'Sin asignar',
      status_pending: 'Pendiente',
      status_disagreement: 'Desacuerdo',
      empty_table: 'No hay revisiones pendientes.',
      load_error: 'No se pudieron cargar las revisiones. Reintenta más tarde.',
      assign_button: 'Asignar revisión',
      reassign_button: 'Reasignar revisión',
      resolve_button: 'Resolver',
      discard_button: 'Descartar',
      filters: {
        reviewer: 'Buscar por revisor',
        status: 'Estado',
      },
      mixed_status_error: 'Selecciona revisiones en el mismo estado.',
      truncated_notice: 'Mostrando {{shown}} de {{total}} revisiones de {{reviewer}}; asigna o descarta estas para ver el resto.',
    },
    resolve_modal: {
      title: 'Resolver revisión',
      summary:
        'Ubicación {{location}} — el revisor no coincidió con el sistema ({{attempts}} intentos). Al resolver, el conteo queda cerrado con el resultado del revisor; los ajustes de stock se gestionan por separado.',
      product: 'Producto',
      system_at_count: 'Sistema al contar',
      counter: 'Contador',
      system_now: 'Sistema ahora',
      reviewer: 'Revisor',
      confirm: 'Resolver',
      cancel: 'Cancelar',
      success: 'Revisión resuelta',
      error: 'Error al resolver la revisión',
    },
    task_panel: {
      title: 'Detalle del Conteo',
      operator: 'Operador',
      assigned_date: 'Fecha de Asignacion',
      progress: 'Progreso',
      locations_counted: 'ubicaciones contadas',
      matches: 'coincidencias',
      divergences: 'divergencias',
      pending: 'Pendiente',
      product: 'Producto',
      counted: 'Contado',
      system: 'Sistema',
      result: 'Resultado',
      no_locations: 'Sin ubicaciones',
      status_pending: 'Pendiente',
      status_submitted: 'En Espera de Revision',
      status_review_pending: 'Revision Asignada',
      status_review_submitted: 'Revision Completada',
      status_resolved: 'Resuelto',
      reviewer: 'Revisor',
      reviewer_counted: 'Revisor Conteo',
      review_outcome: 'Resultado de Revision',
      outcome_confirmed: 'Confirmado',
      outcome_counter_confirmed: 'Contador Confirmado',
      outcome_disagreement: 'Desacuerdo',
      download_csv: 'Descargar CSV',
      selected_count: '{{count}} ubicaciones seleccionadas',
      unassign_action: 'Desasignar',
      reassign_action: 'Reasignar',
    },
    assign_modal: {
      title: 'Asignar Conteo Ciclico',
      operator_name: 'Operador',
      search_operator: 'Buscar Operador',
      choose_operator: 'Elige un operador',
      pending_counts: 'Conteos Pendientes',
      operators: 'Operadores',
      locations: 'Ubicaciones',
      selected_count: '{{count}} ubicaciones seleccionadas',
      assign: 'Asignar',
      cancel: 'Cancelar',
      success: 'Conteo ciclico asignado exitosamente',
      success_with_take_over: '{{count}} ubicaciones asignadas, {{taken_over}} conteos pendientes tomados',
      error: 'Error al asignar conteo ciclico',
    },
    bulk_assign_button: 'Asignacion Masiva',
    bulk_assign: {
      title: 'Asignacion Masiva de Conteos',
      filters_step: {
        area_label: 'Area',
        area_placeholder: 'Seleccionar area',
        row_label: 'Fila',
        row_placeholder: 'Seleccionar fila (opcional)',
        store_label: 'Tienda',
        store_placeholder: 'Seleccionar tienda (opcional)',
        preview_button: 'Vista Previa',
        at_least_one_filter: 'Seleccione al menos un filtro',
      },
      preview_step: {
        title: 'Resumen de Asignacion',
        filters_applied: 'Filtros aplicados',
        area_row_column: 'Area - Fila',
        assignable_column: 'A asignar',
        already_pending_column: 'Ya asignados',
        total_assignable: '{{count}} ubicaciones a asignar',
        total_skipped: '{{count}} ubicaciones omitidas (ya tienen conteo pendiente)',
        to_take_over: '{{count}} ubicaciones tomarán un conteo pendiente de otro operador',
        show_skipped: 'Ver ubicaciones omitidas',
        hide_skipped: 'Ocultar ubicaciones omitidas',
        and_more: '... y mas',
        no_locations: 'No se encontraron ubicaciones con los filtros seleccionados',
        all_already_assigned: 'Todas las ubicaciones ya tienen un conteo pendiente',
        select_operator: 'Seleccionar Operador',
        back: 'Volver',
      },
      operator_step: {
        title: 'Se asignaran {{count}} ubicaciones',
        assign_button: 'Asignar',
        back: 'Volver',
      },
      confirm_step: {
        title: 'Confirmar distribución',
        operator_column: 'Operador',
        count_column: 'Ubicaciones',
        from_column: 'Desde',
        to_column: 'Hasta',
        confirm_button: 'Confirmar',
        back: 'Volver',
        loading: 'Cargando distribución...',
        error: 'Error al cargar la distribución',
        retry: 'Reintentar',
      },
      success: 'Se crearon {{count}} conteos ciclicos exitosamente',
      success_with_skipped: 'Se crearon {{created}} conteos ciclicos ({{skipped}} ubicaciones omitidas)',
      success_with_take_over_and_skipped: 'Se crearon {{created}} conteos ciclicos, se tomaron {{taken_over}} pendientes ({{skipped}} ubicaciones omitidas)',
      success_multi: '{{count}} conteos creados: {{details}}',
      success_multi_with_skipped: '{{count}} conteos creados: {{details}} ({{skipped}} ubicaciones omitidas, {{taken_over}} conteos pendientes tomados)',
      error: 'Error al crear conteos ciclicos',
    },
    unassign_button: 'Desasignar',
    reassign_button: 'Reasignar',
    unassign_modal: {
      title: 'Desasignar ubicaciones',
      summary: '{{batches}} conteos seleccionados ({{locations}} ubicaciones)',
      review_pending_warning: 'Algunas ubicaciones ya fueron contadas por el operador. Al desasignar se borrara el conteo registrado.',
      unassigned_warning: 'Los conteos sin asignar seleccionados se eliminaran de la cola y dejaran de aparecer en esta lista.',
      operator: 'Operador',
      locations: 'Ubicaciones',
      status: 'Estado',
      status_pending: 'Pendiente',
      status_unassigned: 'Sin Asignar',
      status_review_pending: 'Revision Asignada',
      status_submitted: 'Enviado',
      status_review_submitted: 'Revisado',
      confirm: 'Desasignar',
      cancel: 'Cancelar',
      success: '{{count}} ubicaciones desasignadas',
      error: 'Error al desasignar ubicaciones',
    },
    reassign_modal: {
      title: 'Reasignar ubicaciones',
      summary: '{{batches}} conteos seleccionados ({{locations}} ubicaciones)',
      mode_single: 'Un solo operador',
      mode_distribute: 'Distribuir entre varios',
      mixed_status_error: 'Solo se puede reasignar ubicaciones en el mismo estado.',
      confirm: 'Reasignar',
      cancel: 'Cancelar',
      success: '{{count}} ubicaciones reasignadas',
      error: 'Error al reasignar ubicaciones',
      counter_notice: 'El contador de estas ubicaciones ({{names}}) no puede ser el revisor.',
      review_title: 'Asignar revisión',
      review_summary: '{{locations}} revisiones seleccionadas',
    },
    errors: {
      REVIEWER_IS_COUNTER: 'El revisor no puede ser quien contó estas ubicaciones: {{locations}}.',
      THIRD_COUNT_REQUIRES_DISAGREEMENT: 'Solo se puede enviar a un tercer conteo cuando hay desacuerdo entre el contador y el revisor.',
      REVIEW_REASSIGNED: 'Esta revisión fue reasignada o cerrada mientras la evaluabas. Actualiza la lista e intenta de nuevo.',
      NOT_REVIEW_SUBMITTED: 'Este conteo ya no está en espera de resolución. Actualiza la lista e intenta de nuevo.',
      OPERATORS_DISABLED: 'Uno o más operadores seleccionados están deshabilitados. Elige otro operador.',
    },
    found_stock: {
      declared_banner_one: 'Se declaró {{count}} sobrante en {{location}}.',
      declared_banner_other: 'Se declararon {{count}} sobrantes en {{location}}.',
      skipped_banner_one: '{{count}} fila no se declaró: {{reasons}}.',
      skipped_banner_other: '{{count}} filas no se declararon: {{reasons}}.',
      view_link: 'Ver en Sobrantes',
      surplus_link: 'Sobrante detectado · ver en Sobrantes',
      reasons: {
        stale: 'el stock cambió desde el conteo',
        transient_units_present: 'hay piezas en tránsito',
        lot_ambiguous: 'lote ambiguo',
        lot_unknown: 'lote desconocido',
        unit_code_product: 'producto con código de unidad',
        product_missing: 'producto inexistente',
        product_not_in_count: 'producto fuera del conteo',
        duplicate_row: 'fila duplicada',
        surplus_exceeds_cap: 'excede el máximo por declaración',
        resolve_cap_exceeded: 'excede el máximo por resolución',
        found_stock_disabled: 'sobrantes desactivado en el almacén',
        error: 'error interno',
        FOUND_STOCK_NOT_AUTHORIZED: 'sin autorización para declarar sobrantes',
      },
    },
    events: {
      tab: 'Eventos',
      wall_to_wall: 'Wall to Wall',
      create_button: 'Nuevo evento',
      empty: 'No hay eventos en este almacén.',
      unavailable: 'Los eventos no están disponibles en esta versión del sistema.',
      load_error: 'No se pudieron cargar los eventos.',
      gate: {
        banner_title: 'Eventos desactivados en este almacén',
        banner_body: 'Se pueden consultar los eventos existentes, pero no crear ni ampliar hasta que se active la función.',
      },
      filters: { store_id: 'Tienda', area: 'Área', row: 'Fila', location_type: 'Tipo' },
      columns: {
        label: 'Evento',
        store: 'Tienda',
        trigger: 'Origen',
        created_by: 'Creado por',
        created_at: 'Creado',
        coverage: 'Cobertura',
        status: 'Estado',
      },
      trigger: { manual: 'Manual', accuracy_gate: 'Automático' },
      status: {
        open: 'Abierto',
        reconciling: 'Conciliando',
        pending_approval: 'Pendiente de firma',
        signed: 'Firmado',
        closed: 'Cerrado',
        canceled: 'Cancelado',
      },
      status_filter: {
        all: 'Todos',
        open: 'Abiertos',
        closed: 'Cerrados',
        canceled: 'Cancelados',
        reconciling: 'Conciliando',
        pending_approval: 'Pendientes de firma',
        signed: 'Firmados',
      },
      create: {
        title: 'Nuevo evento de conteo',
        preview_title: 'Vista previa',
        to_spawn: '{{count}} ubicaciones recibirán un conteo nuevo',
        watched: '{{count}} ubicaciones ya tienen un conteo activo y se seguirán sin duplicar',
        store_wide_hint: 'Este evento cubre toda la tienda: se mostrará como Wall to Wall.',
        signature_toggle: 'Requiere firma del cliente al ejecutar los ajustes',
        store_wide_signature_locked: 'Obligatoria para eventos de toda la tienda',
        confirm: 'Crear evento',
        created: 'Evento creado.',
      },
      detail: {
        title: 'Evento',
        open_event: 'Evento #{{id}}',
        retry: 'Reintentar',
        load_error_stale: 'No se pudo actualizar; se muestra la última vista cargada.',
        totals: {
          locations: 'Ubicaciones',
          satisfied: 'Cubiertas',
          in_review: 'En revisión',
          assigned: 'Asignadas',
          unassigned: 'Sin asignar',
          uncovered: 'Sin conteo',
        },
        state: { satisfied: 'Cubierta', in_review: 'En revisión', assigned: 'Asignada', unassigned: 'Sin asignar', uncovered: 'Sin conteo' },
        state_filter_all: 'Todas',
        columns: { location: 'Ubicación', state: 'Estado', count: 'Conteo', assigned_to: 'Asignado a' },
        unassigned: 'Sin asignar',
        added_after_snapshot: 'Añadida tras el inicio',
        satisfied_by: 'Cubierta por conteo #{{id}} ({{origin}})',
        tabs: { locations: 'Ubicaciones', differences: 'Diferencias', drift: 'Cambios desde el inicio' },
        close: 'Cerrar evento',
        cancel: 'Cancelar evento',
        closed: 'Evento cerrado.',
        canceled: 'Evento cancelado. Conteos pendientes sin asignar eliminados: {{count}}.',
        confirm_close: '¿Cerrar el evento? Las diferencias quedan registradas; no se ajusta stock en esta fase.',
        confirm_cancel: '¿Cancelar el evento? Se eliminarán solo los conteos de este evento pendientes y sin asignar; los asignados y los iniciados continúan.',
      },
      differences: {
        shortages: 'Faltantes',
        surpluses: 'Sobrantes',
        none: 'Sin diferencias.',
        owned: 'Propio',
        watched: 'Seguido',
        no_declaration: 'Sin declaración',
        columns: {
          origin: 'Origen',
          location: 'Ubicación',
          product: 'Producto',
          lot: 'Lote',
          system: 'Sistema',
          counted: 'Contado',
          difference: 'Diferencia',
          declared: 'Declarado',
          settlement: 'Estado',
          settled_at: 'Resuelto',
        },
        settlement: { unsettled: 'Pendiente en Sobrantes', matched: 'Emparejado', handed_off: 'Ingresado', mixed: 'Emparejado e ingresado' },
        corrected: 'corregido',
        totals:
          'Ubicaciones contadas: {{counted}} · con diferencias: {{with_differences}} · faltan {{short_owned}} propias + {{short_watched}} seguidas · sobran {{surplus_owned}} propias + {{surplus_watched}} seguidas ({{declared}} declaradas, {{settled}} resueltas)',
        view_in_found_stock: 'Ver en Sobrantes',
      },
      drift: {
        empty: 'Ninguna ubicación nueva coincide con los filtros del evento.',
        not_open: 'La verificación de cambios solo aplica a eventos abiertos.',
        add_selected: 'Añadir al evento',
        added: 'Añadidas {{added}} ubicaciones ({{spawned}} conteos nuevos, {{watched}} seguidas, {{satisfied}} ya cubiertas).',
        has_active_count: 'ya tiene conteo activo',
      },
      errors: {
        COVERAGE_EVENTS_DISABLED: 'Los eventos están desactivados en este almacén.',
        FULL_WAREHOUSE_EVENT_RESERVED: 'Elige al menos un filtro; el evento de almacén completo está reservado.',
        COVERAGE_EVENT_NOT_OPEN: 'El evento ya no está abierto. Se actualizó la vista.',
        COVERAGE_INCOMPLETE: 'Cobertura incompleta: {{unassigned}} sin asignar, {{assigned}} asignados, {{in_review}} en revisión, {{uncovered}} sin cubrir.',
        LOCATIONS_NOT_ELIGIBLE: 'Alguna ubicación no es contable en este almacén.',
        FORBIDDEN: 'No tienes acceso a los eventos de este almacén.',
        NOT_FOUND: 'El evento no existe.',
        STORE_NOT_FOUND: 'La tienda seleccionada no atiende este almacén; recarga los filtros.',
        UNEXPECTED: 'Ocurrió un error inesperado.',
        COVERAGE_INCOMPLETE_GENERIC: 'Faltan ubicaciones por cubrir.',
        COVERAGE_EVENT_NOT_RECONCILING: 'El evento no está en conciliación. Se actualizó la vista.',
        PROPOSAL_NOT_FROZEN: 'La propuesta aún se está calculando.',
        PROPOSAL_FINGERPRINT_MISMATCH: 'La propuesta cambió. Revisa la versión actual antes de aprobar.',
        MERCHANT_SIGNATURE_REQUIRED: 'Este evento requiere la firma del cliente antes de ejecutar.',
        EXECUTION_ALREADY_APPROVED: 'La ejecución ya fue aprobada.',
        EXECUTION_IN_PROGRESS: 'La ejecución ya está aprobada; el evento no se puede cancelar.',
        MERCHANT_SIGNATURE_REQUIRED_FOR_STORE_WIDE: 'Un evento de toda la tienda siempre requiere la firma del cliente.',
        SETTLEMENT_AUTHORITY: 'Conciliar requiere permiso de transferencia a LOST en este almacén.',
        NOT_AWAITING_SIGNATURE: 'El evento no está esperando la firma del cliente. Se actualizó la vista.',
        SIGNATURE_NOT_REQUIRED: 'Este evento no requiere la firma del cliente.',
        ALREADY_SIGNED: 'El cliente ya firmó este evento. Se actualizó la vista.',
        EVIDENCE_REQUIRED: 'Adjunta al menos un archivo de evidencia.',
        EVIDENCE_TOO_LARGE: 'Algún archivo supera 25 MB.',
        EVIDENCE_TYPE_NOT_ALLOWED: 'Solo se admiten imágenes o PDF.',
        NOTE_REQUIRED: 'Escribe la nota: quién aprobó y por qué canal.',
      },
      reconciliation: {
        tab: 'Conciliación',
        unavailable: 'La conciliación no está disponible en esta versión del sistema.',
        state: {
          open: 'Abierto',
          computing: 'Calculando la propuesta…',
          frozen: 'Propuesta lista para aprobar',
          pending_approval: 'Esperando firma del cliente',
          signed: 'Firmado por el cliente, listo para aceptar',
          executing: 'Ejecutando ajustes',
          settled: 'Conciliado',
          closed: 'Cerrado sin conciliar',
          canceled: 'Cancelado',
        },
        kind: { write_off: 'Baja a LOST', match: 'Emparejar', handoff: 'Ingresar', removal: 'Remover LOST' },
        outcome: { pending: 'Pendiente', executed: 'Ejecutado', partial: 'Parcial', skipped: 'Omitido', blocked: 'Bloqueado' },
        columns: {
          location: 'Ubicación',
          kind: 'Acción',
          product: 'Producto',
          lot: 'Lote',
          existing: 'Existentes',
          planned: 'Planeado',
          since: 'Desde (aprox.)',
          executed: 'Ejecutado',
          outcome: 'Resultado',
          reason: 'Motivo',
        },
        // W-7: `totals`/`progress` are count-aware via i18next's JSON v4 `_one`/`_other`
        // suffixes rather than a hardcoded plural noun — call i18n.t with `count` set to the
        // driving number (the kind's item rows for totals, the phase total for progress); the
        // adjectives lead the numbers so the `_one` variant stays grammatical.
        totals_one: '{{kind}}: planeadas {{planned}} · ejecutadas {{executed}} · {{count}} fila',
        totals_other: '{{kind}}: planeadas {{planned}} · ejecutadas {{executed}} · {{count}} filas',
        progress_one: 'Fase {{phase}}: {{done}} de {{count}} ajuste',
        progress_other: 'Fase {{phase}}: {{done}} de {{count}} ajustes',
        computing_progress_one: 'Calculando: {{done}} de {{count}} ubicación',
        computing_progress_other: 'Calculando: {{done}} de {{count}} ubicaciones',
        computing_error_hint: 'El cálculo se detuvo; usa Reintentar el cálculo.',
        finalizing: 'Cerrando el evento…',
        no_proposal: 'Este evento se cerró sin propuesta de conciliación.',
        stalled: 'La ejecución no avanza desde {{since}}. Avisa a soporte: la guía de recuperación reanuda la fase pendiente.',
        stalled_since_unknown: 'La ejecución no avanza. Avisa a soporte: la guía de recuperación reanuda la fase pendiente.',
        paused: 'Actualización pausada',
        outcome_unknown: 'No se pudo confirmar el resultado de la ejecución. Reintenta para leer el estado real.',
        outcome_unknown_panel: 'No se pudo confirmar el resultado de la última ejecución. Abre la pestaña Conciliación para leer el estado real.',
        outcome_not_applied: 'La ejecución no se había aplicado; puedes aprobar de nuevo.',
        proposal_outdated: 'Esta página muestra una propuesta anterior. Actualiza antes de aprobar.',
        loading: 'Cargando…',
        last_error_at: 'Último error: {{date}}',
        phases: { write_off: 'Bajas', match: 'Emparejamientos', handoff: 'Ingresos', removal: 'Retiros' },
        approve: 'Aprobar y ejecutar',
        accept: 'Aceptar y ejecutar',
        confirm_approve:
          '¿Aprobar esta propuesta y ejecutar los ajustes? Se darán de baja {{write_off}} piezas, se emparejarán {{match}} y se ingresarán {{handoff}}. No se puede deshacer.',
        confirm_blocked_one: '{{count}} pieza bloqueada queda declarada en Sobrantes.',
        confirm_blocked_other: '{{count}} piezas bloqueadas quedan declaradas en Sobrantes.',
        confirm_blocked_write_off_one: '{{count}} pieza de baja bloqueada (stock movido tras el conteo) no se ajusta.',
        confirm_blocked_write_off_other: '{{count}} piezas de baja bloqueadas (stock movido tras el conteo) no se ajustan.',
        confirm_removal_one: 'Además se retirará hasta {{count}} unidad LOST de la tienda en este almacén.',
        confirm_removal_other: 'Además se retirarán hasta {{count}} unidades LOST de la tienda en este almacén.',
        removal_missing: 'La propuesta incluye un retiro de LOST que esta vista no recibió. Actualiza antes de continuar.',
        approved: 'Ejecución aprobada. Los ajustes se aplican en segundo plano.',
        reconcile: 'Conciliar',
        confirm_reconcile:
          '¿Conciliar el evento? Se calculará la propuesta de ajustes a partir de las diferencias propias; nada se ajusta hasta que se apruebe.',
        retry_reconcile: 'Reintentar el cálculo',
        confirm_retry_reconcile: '¿Reintentar el cálculo de la propuesta? El evento sigue en conciliación.',
        reconciling: 'Evento en conciliación. La propuesta se está calculando.',
        signature_banner: 'Este evento requiere la firma del cliente. Espera la firma en el portal.',
        signature_banner_record: 'Este evento requiere la firma del cliente. Espera la firma en el portal o regístrala aquí con su evidencia.',
        rebaselined: 'La ventana de exactitud de la tienda se reinició con este cierre.',
        blocked_hint: 'Las filas bloqueadas quedan declaradas en Sobrantes.',
        none: 'Sin diferencias propias: no hay ajustes que ejecutar.',
        retry: 'Reintentar',
        view_declaration: 'Ver declaración',
        view_receipt: 'Ver recibo',
        unexecuted_hint: '{{count}} sin ejecutar',
        reasons: {
          insufficient_candidates: 'Menos unidades elegibles que el faltante (stock movido tras el conteo)',
          mid_picking: 'Reservas en picking, no se tocan',
          container_bound: 'Piezas en contenedor, no se tocan',
          units_changed: 'Las unidades cambiaron tras congelar la propuesta',
          insufficient_lost_candidates: 'No hay suficientes perdidos elegibles',
          bay_retired: 'Ubicación retirada',
          location_not_eligible_for_found_stock: 'La ubicación ya no admite sobrantes',
          found_stock_disabled: 'Sobrantes desactivados en el almacén',
          replenishment_invoice_required: 'La tienda factura sus recibos; no se puede ingresar',
          billing_config_missing: 'Falta el servicio de recepción en la configuración de cobro',
          unit_code_product: 'Producto con código de unidad',
          product_missing: 'El producto ya no existe',
          store_missing: 'La tienda ya no existe',
          concurrent_modification: 'Modificación concurrente; reintentado y omitido',
          no_lost_bay: 'El almacén no tiene ubicación LOST',
          error: 'Error inesperado',
          settlement_authority_lost: 'Quien aprobó perdió el permiso de conciliación durante la ejecución',
          multiple_stores: 'Unidades de varias tiendas',
        },
        blocked_reasons: {
          units_changed: 'Stock movido tras el conteo',
        },
        removal: {
          hint: 'Al conciliar se retiran de la tienda todas las unidades LOST recuperables en este almacén: las más antiguas primero y nunca más de lo planeado. La fecha es aproximada.',
          none: 'No hay unidades LOST que retirar.',
        },
        signature: {
          evidence_expired: 'Los enlaces de evidencia caducaron.',
          renew_links: 'Renovar enlaces',
          banner_signed_portal: 'Firmado por el cliente el {{date}} en el portal ({{name}}).',
          banner_signed_staff: 'Firma del cliente registrada el {{date}} por {{name}}.',
          banner_signed: 'Firmado por el cliente el {{date}} ({{name}}).',
          note: 'Nota: {{note}}',
          evidence: 'Evidencia:',
          record_button: 'Registrar firma del cliente',
          dialog_title: 'Registrar la firma del cliente',
          dialog_body:
            'Para marcas fuera del portal: registra la aprobación recibida y adjunta la evidencia. La firma queda ligada a la propuesta tal como se muestra.',
          may_refuse: 'Si el stock se mueve después de la firma, algún ajuste puede rechazarse al ejecutar.',
          note_label: 'Nota: quién aprobó y por qué canal',
          note_placeholder: 'Ej.: aprobado por Ana Gil (Dublinense) por correo el 22/09',
          evidence_label: 'Evidencia (imagen o PDF, hasta 25 MB cada archivo)',
          evidence_hint: 'Adjunta al menos un archivo.',
          evidence_invalid_type: '{{name}}: solo imágenes o PDF.',
          evidence_too_large: '{{name}}: supera 25 MB.',
          submit: 'Registrar firma',
          cancel: 'Cancelar',
          close: 'Cerrar',
          recorded: 'Firma registrada. Ya puedes aceptar y ejecutar la propuesta.',
        },
      },
      pool: {
        capped: 'Se muestran {{shown}} de {{total}} ubicaciones. La asignación tomará todas las del grupo.',
        assigning_chunks: 'Asignando {{done}} de {{total}} conteos…',
        unassigning_chunks: 'Desasignando {{done}} de {{total}} conteos…',
        scope: 'Se asignará toda la bolsa sin asignar del almacén: {{count}} conteos.',
        unassign_scope: 'Se eliminará toda la bolsa sin asignar del almacén: {{count}} conteos.',
        partial: 'Asignados {{done}} de {{total}} conteos antes del error.',
        unassign_partial: 'Desasignados {{done}} de {{total}} conteos antes del error.',
        fallback: 'Esta versión solo asigna las {{count}} ubicaciones listadas.',
        unassign_fallback: 'Esta versión solo desasigna las {{count}} ubicaciones listadas.',
        resolving: 'Calculando el tamaño de la bolsa…',
        mixed_selection: 'Selecciona la bolsa sin asignar sola para actuar sobre todas sus ubicaciones.',
      },
    },
  },
  found_stock: {
    title: 'Sobrantes',
    subtitle: 'Piezas encontradas pendientes de liquidar',
    refresh: 'Actualizar',
    open_by_id_label: 'Abrir declaración #',
    open_by_id_button: 'Abrir',
    dialog_product_label: 'Producto',
    dialog_close: 'Cerrar',
    tabs: {
      queue: 'Sobrantes',
      awaiting: 'Pendientes de acomodo',
    },
    queue: {
      declaration: 'Declaración',
      product: 'Producto',
      lot: 'Lote',
      location: 'Ubicación',
      quantity: 'Cantidad',
      declared_quantity_one: 'declarada: {{count}}',
      declared_quantity_other: 'declaradas: {{count}}',
      declared_by: 'Declarado por',
      source: 'Origen',
      candidates: 'Perdidos elegibles',
      actions: 'Acciones',
      cycle_count: 'Conteo #{{id}}',
      lot_value: 'Lote #{{id}}',
      lot_expires: 'Vence {{date}}',
      no_lot: 'Sin lote',
      product_fallback: 'Producto #{{id}}',
      empty_table: 'Sin sobrantes pendientes.',
      load_error: 'No se pudieron cargar los sobrantes. Reintenta más tarde.',
      forbidden: 'No tienes acceso a los sobrantes de este almacén.',
      match_button: 'Emparejar',
      inbound_button: 'Ingresar',
      correct_button: 'Corregir',
      match_disabled_hint: 'Sin perdidos elegibles; usa Ingresar.',
      retry: 'Reintentar',
      highlight_notice: 'Resaltando los sobrantes del conteo #{{id}}',
      highlight_clear: 'Quitar resaltado',
      filters: {
        location: 'Ubicación',
        declaration: 'Nº de declaración',
        product: 'ID de producto',
      },
    },
    source: {
      AD_HOC: 'Manual',
      CYCLE_COUNT: 'Conteo',
    },
    awaiting: {
      location: 'Ubicación',
      product: 'Producto',
      lot: 'Lote',
      status: 'Estado',
      status_ACTIVE: 'En venta',
      status_HOLDED: 'Pausadas',
      status_FOUND: 'Sobrantes',
      quantity: 'Cantidad',
      empty_table: 'No hay piezas pendientes de acomodo.',
      load_error: 'No se pudo cargar la lista. Reintenta más tarde.',
      hint: 'Estas piezas ya fueron liquidadas y salen de la ubicación FOUND con una transferencia desde el handheld.',
    },
    match_dialog: {
      title: 'Emparejar con perdidos',
      summary: 'Declaración #{{id}} en {{location}}: {{quantity}} piezas pendientes, {{candidates}} perdidos elegibles.',
      quantity_label: 'Piezas a emparejar',
      explanation: 'Cada pieza recupera una unidad perdida del mismo producto y lote; la pieza sobrante se retira.',
      confirm: 'Emparejar',
      cancel: 'Cancelar',
      success_one: 'Se recuperó {{count}} pieza perdida.',
      success_other: 'Se recuperaron {{count}} piezas perdidas.',
      replayed: 'Estas piezas ya estaban liquidadas; la lista se actualizó.',
      replayed_units_one: 'Estas piezas ya estaban liquidadas: {{count}} retirada, {{recovered}} perdidas recuperadas.',
      replayed_units_other: 'Estas piezas ya estaban liquidadas: {{count}} retiradas, {{recovered}} perdidas recuperadas.',
    },
    inbound_dialog: {
      title: 'Ingresar como recibo',
      summary: 'Declaración #{{id}} en {{location}}: {{quantity}} piezas.',
      consequence: 'Se creará un recibo completado a nombre de la tienda, se cobrará la recepción y la tienda recibirá el correo de recibo completado.',
      found_bay_note:
        'Si la ubicación es de tipo FOUND, las piezas quedan ahí hasta que el handheld las transfiera a un anaquel; en un anaquel quedan vendibles de inmediato.',
      confirm: 'Ingresar',
      cancel: 'Cancelar',
      success_one: 'Recibo #{{replenishment_id}} creado con {{count}} pieza.',
      success_other: 'Recibo #{{replenishment_id}} creado con {{count}} piezas.',
      replayed: 'Estas piezas ya estaban liquidadas; la lista se actualizó.',
      replayed_receipt_one: 'Recibo #{{replenishment_id}} ya registrado con {{count}} pieza.',
      replayed_receipt_other: 'Recibo #{{replenishment_id}} ya registrado con {{count}} piezas.',
    },
    correct_dialog: {
      title: 'Corregir cantidad declarada',
      summary: 'Declaración #{{id}} en {{location}}: {{quantity}} piezas pendientes.',
      quantity_label: 'Cantidad correcta',
      quantity_hint: 'Entre 0 y 1000. Cero retira toda la declaración.',
      reason_label: 'Motivo',
      reason_hint: 'Obligatorio, máximo 500 caracteres. Queda en auditoría y no se muestra en pantalla.',
      reason_counter: '{{count}}/500',
      confirm: 'Corregir',
      cancel: 'Cancelar',
      success: 'Cantidad corregida de {{before}} a {{after}}.',
      replayed: 'Cantidad corregida de {{before}} a {{after}} (ya registrada).',
      validation_quantity: 'Ingresa una cantidad entera entre 0 y 1000.',
    },
    detail: {
      title: 'Detalle del sobrante',
      declaration: 'Declaración',
      product: 'Producto',
      lot: 'Lote',
      location: 'Ubicación',
      source: 'Origen',
      declared_by: 'Declarado por',
      declared_quantity: 'Cantidad declarada',
      effective_quantity: 'Cantidad vigente',
      live_quantity: 'Pendientes ahora',
      units_title: 'Piezas por resultado',
      show_ids: 'Ver IDs',
      hide_ids: 'Ocultar IDs',
      corrections_title: 'Correcciones',
      corrections_empty: 'Sin correcciones.',
      correction_when: 'Fecha',
      correction_change: 'Cambio',
      correction_by: 'Usuario',
      correction_units: 'Piezas',
      correction_added_one: '+{{count}} agregada',
      correction_added_other: '+{{count}} agregadas',
      correction_retired_one: '−{{count}} retirada',
      correction_retired_other: '−{{count}} retiradas',
      legs_title: 'Movimientos',
      legs_empty: 'Sin movimientos.',
      leg_when: 'Fecha',
      leg_action: 'Acción',
      leg_location: 'Ubicación',
      leg_change: 'Cantidad',
      leg_by: 'Usuario',
      location_fallback: 'Ubicación #{{id}}',
      user_fallback: 'Usuario #{{id}}',
      load_error: 'No se pudo cargar el detalle.',
    },
    buckets: {
      found: 'Pendientes',
      retired: 'Retiradas por emparejamiento',
      corrected_out: 'Retiradas por corrección',
      converted: 'Ingresadas como recibo',
      recovered: 'Perdidas recuperadas',
    },
    gate: {
      banner_title: 'Sobrantes está desactivado en este almacén.',
      banner_body: 'Las liquidaciones y correcciones no están disponibles hasta que Cubbo lo habilite.',
    },
    errors: {
      UNAUTHORIZED: 'No tienes autorización para liquidar sobrantes.',
      UNKNOWN: 'No se pudo completar la operación ({{code}}).',
      NETWORK: 'No se pudo completar la operación (NETWORK).',
      FOUND_STOCK_DISABLED: 'Sobrantes está desactivado en este almacén.',
      UNITS_ALREADY_SETTLED: 'La página estaba desactualizada: algunas piezas ya fueron liquidadas.',
      UNITS_NOT_FOUND_STOCK: 'Las piezas seleccionadas ya no son sobrantes de este almacén.',
      UNITS_OUTSIDE_WAREHOUSE: 'Las piezas seleccionadas ya no son sobrantes de este almacén.',
      CONCURRENT_MODIFICATION: 'Otra operación movió estas piezas; inténtalo de nuevo.',
      INSUFFICIENT_LOST_CANDIDATES: 'Solo hay {{available}} perdidos elegibles para {{requested}} piezas. Puedes emparejar menos o ingresarlas como recibo.',
      TOO_MANY_DECLARATIONS: 'Solicitud inválida (TOO_MANY_DECLARATIONS).',
      TOO_MANY_UNITS: 'Solicitud inválida (TOO_MANY_UNITS).',
      QUANTITY_INVALID: 'Solicitud inválida (QUANTITY_INVALID).',
      INVALID_PARAMETER: 'Solicitud inválida (INVALID_PARAMETER).',
      MULTIPLE_STORES: 'Las piezas pertenecen a más de una tienda; ingrésalas por separado.',
      STORE_NOT_FOUND: 'No se encontró la tienda de estas piezas.',
      BILLING_CONFIG_MISSING: 'La tienda no tiene servicio de recepción vigente; configura facturación antes de ingresar.',
      DECLARATION_SETTLED: 'La declaración ya fue liquidada; no admite correcciones.',
      DECLARATION_INCONSISTENT: 'La declaración es inconsistente; escala a ingeniería.',
      DECLARATION_NOT_FOUND: 'La declaración ya no existe.',
      PRODUCT_NOT_FOUND: 'El producto ya no existe o se convirtió en padre.',
      LOCATION_NOT_ELIGIBLE_FOR_FOUND_STOCK: 'La ubicación cambió de tipo y ya no admite sobrantes.',
      IDEMPOTENCY_CONFLICT: 'Esta solicitud ya se envió con otros valores. Intenta de nuevo.',
      UNIT_CODE_PRODUCTS_NOT_SUPPORTED: 'Productos con código de unidad no soportados: {{product_ids}}.',
      REPLENISHMENT_INVOICE_REQUIRED:
        'Los ingresos de esta tienda llevan factura; el sobrante no puede ingresarse. Empareja con un faltante o déjalo declarado.',
      INTERNAL_ERROR: 'Error interno del servidor; inténtalo de nuevo.',
      DECLARATION_IN_FROZEN_PROPOSAL: 'La declaración está en una propuesta de conciliación congelada (evento #{{id}}).',
    },
    frozen_proposal: {
      view_event: 'Ver evento',
    },
  },
  packing_camera_notifications: {
    upload_failed_title: 'Error al guardar la grabación',
    upload_failed_description: 'No se pudo subir el video de empaque. Reporta este pedido a tu supervisor.',
    chunk_failed_title: 'Problema al subir el video',
    chunk_failed_description: 'Se detectó una falla intermitente al subir parte del video. Verifica tu conexión.',
  },
  reassign_carrier: {
    scanner: {
      label: 'Número de guía',
      hint: 'Escanea o pega la guía y presiona Enter',
      placeholder: 'Escanea o ingresa una guía',
      counter: '{{count}} / {{max}} guías',
      empty_state: 'Las guías escaneadas aparecerán aquí.',
      limit_reached_title: 'Límite de {{max}} guías alcanzado',
      limit_reached_description: 'Solo puedes escanear hasta {{max}} guías por reasignación. Procesa estas y crea una nueva reasignación para continuar.',
      limit_reached_advice: 'Reasigna estas {{max}} guías a Uber y crea una nueva reasignación para continuar con las siguientes.',
      duplicate_title: 'Guía ya escaneada',
      duplicate_description: 'La guía {{label}} ya está en la lista.',
      remove_label: 'Eliminar guía {{label}}',
    },
    bulk_error_title: 'Error al reasignar',
    bulk_error_description: 'No se pudieron reasignar las guías a Uber. Inténtalo de nuevo.',
    error_cross_warehouse_labels: 'Guías de otros almacenes: {{labels}}',
    error_not_found_labels: 'Guías no encontradas: {{labels}}',
    created_batches_label: 'Lotes creados:',
    failed_labels_header: 'Guías fallidas',
    retry_failed_labels: 'Reintentar guías fallidas',
    error_column: 'Error',
    shipping_number_column: 'N° de guía',
    batch_label_input: 'Etiqueta del lote (opcional)',
    batch_label_placeholder: 'Ej. MORNING-DRIVER-A',
    batch_label_hint_auto: 'Se generará automáticamente',
    batch_label_hint_will_add: 'Se agregará al lote existente {{label}} (ya tiene {{count}} entregas)',
    batch_label_hint_submitted: 'El lote {{label}} ya fue enviado a Uber. Elige otro nombre.',
    batch_label_hint_will_create: 'Se creará un nuevo lote {{label}}',
  },
  uber_batches: {
    list_title: 'Lotes Uber',
    empty_table: 'No hay lotes Uber para mostrar.',
    status: {
      pending: 'Pendiente de agrupación',
      submitted: 'Enviado a Uber',
      route_planned: 'Ruta planificada',
      failed: 'Fallido',
    },
    headers: {
      id: 'ID',
      warehouse: 'Almacén',
      status: 'Estado',
      internal_label: 'Etiqueta interna',
      dispatch_window: 'Ventana de despacho',
      deliveries_count: 'Entregas',
      submitted_at: 'Enviado',
      failed_at: 'Falló',
      actions: 'Acciones',
    },
    filters: {
      status: 'Estado',
      all_statuses: 'Todos los estados',
      created_at: 'Creado entre',
      reset: 'Limpiar filtros',
    },
    actions: {
      view: 'Ver',
      reload: 'Recargar',
      submit_pending: 'Enviar pendientes ahora',
      submit_pending_success_title: 'Lotes enviados',
      submit_pending_success_description: '{{count}} lote(s) pendiente(s) enviados a Uber.',
      retry: 'Reintentar lote',
      retry_success_title: 'Lote reiniciado',
      retry_success_description: 'El lote volvió a pendiente; se enviará en la próxima ventana de despacho o con "Enviar pendientes ahora".',
    },
    errors: {
      no_access: 'No tienes acceso a esta sección.',
      fetch_error: 'Error al cargar los lotes Uber.',
      submit_error_title: 'Error al enviar lotes',
      submit_error: 'No se pudieron enviar los lotes pendientes. Inténtalo de nuevo.',
      retry_error_title: 'Error al reintentar lote',
      retry_error: 'No se pudo reintentar el lote. Inténtalo de nuevo.',
    },
    detail: {
      title: 'Lote Uber #{{id}}',
      back: 'Volver',
      not_found: 'Lote no encontrado.',
      fields: {
        id: 'ID',
        status: 'Estado',
        warehouse: 'Almacén',
        dispatch_window_start: 'Inicio de ventana',
        dispatch_window_end: 'Fin de ventana',
        submitted_at: 'Enviado',
        failed_at: 'Falló',
        deliveries_count: 'Entregas',
        failure_reason: 'Razón del fallo',
        internal_label: 'Etiqueta interna',
        uber_batch_id: 'ID de lote Uber',
        last_webhook_at: 'Último webhook',
      },
      deliveries: {
        title: 'Entregas',
        empty: 'Este lote no tiene entregas.',
        uber_delivery_id: 'ID de entrega Uber',
        shipping_number: 'Número de guía',
        recipient: 'Destinatario',
        shipping_city: 'Ciudad',
        status: 'Estado',
        return_pin_code: 'PIN de devolución',
        failed_reason: 'Motivo del fallo',
        actions: 'Acciones',
        view_order: 'Ver pedido',
      },
    },
  },
  coberturas: {
    createCoverages: {
      title: 'Crear coberturas — {{method}}',
      button: 'Crear coberturas',
      validate: 'Validar',
      create: 'Crear',
      coverageCount: '{{count}} coberturas en el lote',
      addRow: 'Agregar fila',
      queuedRows: '{{count}} filas en cola',
      advancedFields: 'Campos avanzados',
      status: {
        readyToCreate: '· Validado — listo para crear',
        validateFirst: '· Validá para habilitar Crear',
        fixErrors: '· Corrige las filas y vuelve a validar',
      },
      modes: {
        single: 'Una fila',
        csv: 'Pegar CSV',
        range: 'Rango de CP',
      },
      fields: {
        value: 'Código postal',
        zone: 'Zona',
        zoneSuggestions: 'Zonas existentes',
        start: 'Inicio del rango',
        end: 'Fin del rango',
        status: 'Estado',
        cost: 'Costo de envío (por zona)',
        extended_zone: 'Zona extendida',
        po_box_dropoff: 'Entrega en sucursal',
        delivery_sla_in_hours: 'SLA de entrega',
        delivery_sla_offset: 'SLA offset',
        eta_offset: 'ETA offset',
        content_value_fee: 'Tarifa de seguro',
        fee_offset: 'Fee offset',
      },
      see_more: 'Ver más',
      see_less: 'Ver menos',
      status_active: 'Activa',
      status_disabled: 'Desactivada',
      units: {
        hours: 'horas',
        percent: '%',
      },
      fieldHelp: {
        cost: 'Costo base de envío para esta zona. Si la zona ya tiene costo, déjalo vacío.',
        cost_existing: 'Esta zona ya tiene un costo configurado.',
        cost_set: 'Esta zona aún no tiene costo; defínelo aquí.',
        delivery_sla_in_hours: 'Compromiso de la paquetería para entregar.',
        delivery_sla_offset: 'Horas que se suman a la fecha de entrega prometida.',
        eta_offset: 'Horas que se suman al tiempo estimado de llegada.',
        content_value_fee: 'Porcentaje que se cobra sobre el total del pedido.',
        fee_offset: 'Monto fijo que se suma a la tarifa del envío.',
      },
      fieldTip: {
        cost: 'Costo de envío que aplica a toda la zona (no por código postal). Si la zona ya tiene un costo configurado, déjalo vacío para no duplicarlo.',
        po_box_dropoff: 'Si la paquetería no logra entregar en el CP destino, el paquete se entrega en la sucursal de la paquetería más cercana al domicilio.',
        content_value_fee:
          'Porcentaje extra que se cobra sobre el total del pedido (productos + envío + cargos extra − descuentos). Por ejemplo, un 1% sobre un pedido cuyo total es $1,000 suma $10 al costo de envío.',
      },
      csv: {
        help: "Pega un CSV con cabecera que coincida con la plantilla. La primera columna debe ser 'value' y la segunda 'zone'.",
        template: 'Descargar plantilla CSV',
        parse: 'Procesar CSV',
        parseErrors: '{{count}} error(es) de lectura — corrige las líneas e intenta de nuevo',
        parseErrorLine: 'línea {{line}}: {{message}}',
        parseErrorsMore: '…y {{count}} error(es) más.',
        needsHeaderAndRow: 'El CSV necesita una fila de cabecera y al menos una de datos',
        missingRequiredFields: "Faltan los campos obligatorios 'value' o 'zone'",
        preview: 'Vista previa ({{shown}} de {{total}} filas)',
      },
      range: {
        preview: '{{count}} códigos postales serán agregados',
        expand: 'Expandir al borrador',
        error: {
          'same-length-digits': 'El inicio y fin del rango deben ser numéricos y de igual longitud',
          'start-after-end': 'El inicio del rango no puede ser mayor que el fin',
          'too-large': 'Tamaño del rango ({{count}}) excede el límite de {{max}} — reduce el rango',
        },
      },
      preview: {
        clean: 'OK',
        fix: 'corregir',
        remove: 'Quitar',
        errorsColumn: 'Errores',
        prereqsBanner: 'Los prerrequisitos tienen errores — quita los ítems con falla o abre el panel para corregirlos',
        removeBinding: 'Quitar del borrador',
        removeCost: 'Quitar del borrador',
      },
      bindXdock: {
        title: "Vincular '{{zone}}' a un xdock",
        help: "La zona '{{zone}}' no está vinculada a ningún xdock para {{country}}. Elige un xdock abajo; se sumará a este lote y se guardará junto con las coberturas.",
        existingZones: 'Ya atiende',
        alreadyQueued: 'Ya en cola para xdocks {{xdocks}}',
        add: 'Agregar al lote',
      },
      configureCost: {
        title: "Configurar costo de envío para '{{zone}}'",
        help: 'No existe shipping_cost para esta zona en este método. Define el precio abajo; se crea junto con las coberturas.',
        cost: 'Costo',
        maxWeight: 'Peso compuesto máximo (kg)',
        currency: 'Código de moneda',
        alreadyQueued: 'Ya en cola: {{cost}} {{currency}}',
        add: 'Agregar al lote',
      },
      errors: {
        INVALID_VALUE: 'Valor inválido',
        DUPLICATE_VALUE_IN_PAYLOAD: 'Duplicado en el lote',
        COVERAGE_ALREADY_EXISTS: 'Ya existe (id {{id}})',
        ZONE_HAS_NO_XDOCK: 'Sin xdock para esta zona',
        ZONE_HAS_NO_SHIPPING_COST: 'Sin shipping cost para esta zona',
      },
      prereqErrors: {
        XDOCK_NOT_FOUND: 'Xdock no encontrado',
        XDOCK_COUNTRY_MISMATCH: 'El xdock está en un país diferente',
        INVALID_ZONE_NAMES: 'Nombres de zona inválidos',
        ZONE_BOUND_TO_OTHER_XDOCK: 'Zona ya vinculada a otro xdock',
        SHIPPING_COST_ALREADY_EXISTS: 'Ya existe un costo para esta zona',
        SHIPPING_COST_DUPLICATE_IN_PAYLOAD: 'Costo duplicado en este lote',
        INVALID_SHIPPING_COST: 'Valor de costo inválido',
        xdockPrefix: 'Xdock #{{id}}',
        costPrefix: 'Costo para {{zone}}',
      },
      progress: {
        title: 'Creando coberturas',
        processing: 'Creando coberturas…',
        processingHint: 'Esto puede tardar un momento con lotes grandes.',
        successTitle: 'Coberturas creadas',
        successBody: '{{coverages}} coberturas creadas',
        successExtra: ', {{costs}} costos de envío y {{zones}} zonas xdock',
        partialTitle: 'Creación con omisiones',
        partialBody: '{{created}} de {{attempted}} coberturas creadas; {{skipped}} omitidas.',
        failedTitle: 'Error en la creación',
        failedBody: 'El trabajo no pudo completarse. Corrige los errores e intenta de nuevo.',
        failedRowErrors: 'Algunas filas no pasaron la validación.',
        submittedTitle: 'Trabajo enviado',
        submittedBody: 'Las coberturas fueron enviadas para creación. Recarga la página para ver si aparecen en la lista.',
        reload: 'Recargar página',
        hide: 'Ocultar',
      },
    },
    jobProgress: {
      title: 'Progreso del trabajo',
      processing: 'Procesando…',
      processingHint: 'Esto puede tardar unos segundos.',
      successCreate: '{{coverages}} coberturas creadas',
      successCreateExtra: ', {{costs}} costos de envío y {{zones}} zonas xdock',
      partialCreate: '{{created}} de {{attempted}} coberturas creadas; {{skipped}} omitidas.',
      successUpdate: '{{rows}} coberturas actualizadas',
      partialUpdate: '{{updated}} actualizadas, {{failed}} fallidas ({{rows}} filas modificadas).',
      successCosts: '{{succeeded}} tarifas procesadas correctamente',
      partialCosts: '{{succeeded}} de {{attempted}} tarifas procesadas; {{failed}} con error.',
      successTitle: 'Listo',
      partialTitle: 'Listo con algunas omisiones',
      failedTitle: 'Error en el trabajo',
      failedBody: 'El trabajo no pudo completarse. Revisa e intenta de nuevo.',
      failedRowErrors: 'Algunas filas no pasaron la validación.',
      submittedTitle: 'Cambios enviados',
      submittedBody: 'Tus cambios se enviaron correctamente. Si no los ves de inmediato, se reflejarán en unos segundos.',
      unavailableTitle: 'Estado no disponible',
      unavailableBody: 'No pudimos confirmar el resultado del cambio. Revisa las tarifas de la zona para verificar si se aplicó.',
      interruptedTitle: 'Cambio interrumpido',
      interruptedBody:
        'El trabajo se detuvo antes de terminar, así que parte de las coberturas puede haberse actualizado y parte no. Revisa la lista y vuelve a enviarlo si hace falta.',
      reload: 'Recargar página',
      hide: 'Ocultar',
      close: 'Cerrar',
    },
  },
  login: {
    invalid_credentials: 'usuario/contraseña inválidos',
    // The API answers USER_DISABLED only after Auth0 verified the password, so
    // this is never shown to someone who simply mistyped it.
    account_disabled: 'Esta cuenta fue desactivada. Contacta a un administrador para reactivarla.',
    sso_failed: 'No se pudo iniciar sesión con Google. Inténtalo de nuevo.',
    sso_no_account:
      'Tu cuenta de Google es válida, pero no existe un usuario con esa dirección. Contacta a un administrador; es posible que tu usuario use otra dirección.',
    too_many_attempts: 'Demasiados intentos. Espera unos minutos e inténtalo de nuevo.',
  },
  handheld_link: {
    title: 'Vincular HandHeld',
    lead_title: 'Vincula tu HandHeld',
    intro: 'Asocia un dispositivo HandHeld a tu cuenta para empezar a usarlo con tus permisos.',
    step1_title: '1. Ingresa el código del dispositivo',
    code_label: 'Código del dispositivo',
    code_placeholder: 'XXXX-XXXX',
    code_hint: 'Aparece en la pantalla del HandHeld que quieres vincular.',
    lookup_button: 'Buscar',
    lookup_loading: 'Buscando...',
    step2_title: '2. Confirma la vinculación',
    device_label: 'Dispositivo',
    requested_at: 'Solicitado',
    link_to_account: 'Se vinculará a la cuenta de',
    link_button: 'Vincular a mi cuenta',
    link_loading: 'Vinculando...',
    search_another: 'Usar otro código',
    success: 'HandHeld vinculado — vuelve al dispositivo.',
    success_title: 'HandHeld vinculado',
    success_description: 'Regresa al dispositivo HandHeld: ya está listo para usarse con tu cuenta.',
    link_another: 'Vincular otro dispositivo',
    go_to_wms: 'Ir al WMS',
    errors: {
      not_found: 'Código no encontrado o expirado.',
      not_found_hint: 'Revisa que el código sea correcto o genera uno nuevo en el dispositivo, luego inténtalo otra vez.',
      sso_required: 'Solo puedes vincular un HandHeld desde una sesión iniciada con SSO.',
      sso_required_hint: 'Cierra sesión y vuelve a entrar con tu cuenta de Google de Cubbo, luego inténtalo otra vez.',
      identity_mismatch: 'Este código lo solicitó otra cuenta',
      identity_mismatch_hint: 'Pide a la persona que solicitó el código que inicie sesión aquí con su propia cuenta.',
      identity_unbound: 'Este código no indica quién lo pidió',
      identity_unbound_hint:
        'En el HandHeld, vuelve a pedir el código iniciando sesión con tu correo. Si el problema sigue, cierra y abre la app para que se actualice.',
      generic: 'Ocurrió un error. Intenta de nuevo.',
    },
  },

  c2c_receiving: {
    title: 'Cubbitos',
    subtitle: 'Recepción y guía de paquetes C2C',
    loading: 'Cargando…',
    outcome: {
      pending: 'En proceso',
      printed: 'Guía impresa',
      label_unprinted: 'Guía generada, no impresa',
      label_replayed: 'Guía existente — reimpresa',
      label_failed: 'No se pudo generar la guía',
    },
    scan: {
      placeholder: 'Escanea el código del rollo (CBT…)',
      read_only: 'Tu usuario puede ver la cola pero no recibir ni imprimir.',
      status: {
        idle: 'Listo para escanear',
        scanning: 'Recibiendo…',
        labeling: 'Generando guía…',
        printing: 'Imprimiendo…',
        done: 'Listo. Escanea el siguiente paquete',
      },
      scan_replayed: 'Ya estaba recibido',
      fields: {
        roll_code: 'Rollo',
        order_number: 'Pedido',
        arrived_at: 'Llegada',
        shipping_number: 'Guía',
        tracking: 'Ver rastreo',
        no_file: 'Guía sin archivo',
        open_label: 'Abrir guía',
      },
      actions: {
        reprint: 'Reimprimir',
        retry_label: 'Reintentar guía',
        cancel: 'Cancelar y liberar la estación',
      },
      cancelled: 'Estación liberada. Si la guía se generó, aparecerá en Procesados con «Generar guía».',
      print_fallback: 'No se pudo imprimir directamente; la guía se abrió en otra pestaña.',
      print_blocked: 'El navegador bloqueó la ventana de impresión; abre la guía con el enlace.',
      dismiss: 'Cerrar',
      no_result: 'Escanea un paquete para ver sus datos aquí.',
    },
    queue: {
      title: 'Paquetes recibidos sin guía',
      search_placeholder: 'Rollo, número de pedido o destinatario',
      refresh: 'Actualizar',
      empty: 'No hay paquetes pendientes de guía',
      fetch_error: 'No se pudo cargar la cola.',
      retry: 'Reintentar',
      truncated: 'Mostrando {{shown}} de {{total}}. Busca para acotar la lista.',
      forbidden: 'Sin acceso a este almacén.',
      forbidden_hint: 'Si acabas de recibir acceso, reintenta o vuelve a seleccionar el almacén.',
      headers: {
        arrived_at: 'Llegada',
        roll_code: 'Rollo',
        order_number: 'Pedido',
        receiver: 'Destinatario',
        destination: 'Punto destino',
        carrier: 'Paquetería',
        label: 'Guía',
        actions: 'Acción',
      },
      label_state: {
        pending: 'Pendiente',
        existing: 'Existente',
      },
      generate_label: 'Generar e imprimir guía',
    },
    processed: {
      title: 'Procesados en esta sesión',
      reprint: 'Reimprimir',
      generate_label: 'Generar guía',
    },
    notifications: {
      forbidden_action: 'Sin permiso para recibir en este almacén',
    },
    errors: {
      generic: 'Ocurrió un error inesperado.',
      network: 'Sin conexión con la plataforma. Revisa la red e intenta de nuevo.',
      forbidden: 'Sin permiso para recibir en este almacén.',
      timeout: 'La plataforma tardó demasiado en responder. Si el paquete ya tiene guía, usa Reimprimir; si no, vuelve a escanearlo.',
      INVALID_PARAMS: 'Código vacío o inválido.',
      ROLL_CODE_NOT_FOUND: 'Código de rollo no reconocido.',
      NOT_FOUND: 'No se encontró el rollo o el pedido en este almacén.',
      WRONG_WAREHOUSE: 'Este paquete no se recibe en este almacén.',
      NOT_RECEIVABLE: 'El pedido no está en un estado que permita recibirlo (ya enviado o cancelado).',
      NOT_LABELABLE: 'El pedido ya no permite generar guía (¿otro operador la generó?).',
      LABEL_GENERATION_FAILED: 'La paquetería no pudo generar la guía',
      LABEL_GENERATION_IN_PROGRESS: 'Otro operador está generando esta guía; reintenta en unos segundos.',
      CUBBITO_RETURN_NOT_C2C: 'Es una devolución: escanéala en Retornos.',
    },
  },

  crash: {
    title: 'Algo salió mal',
    description: 'La pantalla no pudo cargarse. Ya avisamos al equipo; recarga para continuar.',
    reload: 'Recargar',
    go_home: 'Volver al inicio',
  },
  fulfillment_errors: {
    // Mensajes por código de error (orientados al operador)
    error_codes: {
      INVOICE_NFSE_REJECTED: 'La prefectura rechazó la nota fiscal de servicio',
      CARRIER_ACCOUNT_SUSPENDED: 'La paquetería suspendió la cuenta por facturas vencidas',
      INVOICE_ISSUER_LOCKED: 'El emisor bloqueó el pedido y escondió el motivo real',
      MARKETPLACE_INVOICE_NOT_RECEIVED: 'La nota fiscal no llegó al marketplace',
      MARKETPLACE_ORDER_CANCELLED: 'El marketplace canceló este pedido: no habrá etiqueta',
      SHIPPING_ADDRESS_INVALID: 'La paquetería rechazó la dirección tal y como está escrita',
      CARRIER_ORDER_RESTRICTION: 'La paquetería rechazó este envío por una restricción suya',
      CARRIER_SERVICE_UNAVAILABLE: 'La paquetería no ofreció servicio para este destino',
      CARRIER_WAYBILL_STOCK_DEPLETED: 'La paquetería se quedó sin folios de guía',
      CLICK_AND_COLLECT_CARRIER_MISMATCH: 'El punto de recolección es de otra paquetería',
      INVALID_PARAMETER: 'La pantalla envió un dato inválido. Recárgala',
      INVOICE_FILE_UNAVAILABLE: 'No se pudo descargar el archivo de la nota fiscal',
      INVOICE_FISCAL_CONFIGURATION_MISSING: 'Falta configuración fiscal del producto o la tienda',
      INVOICE_RATE_LIMITED: 'El emisor de notas está saturado y rechazó esta',
      INVOICE_SERVICE_PARAMETER_INVALID: 'La nota de servicio (NFS-e) tiene mal la configuración de la tienda',
      INVOICE_TAX_PARAMETER_INVALID: 'La clasificación tributaria del producto no corresponde a su NCM',
      ORDER_IN_REVIEW: 'Este pedido está en revisión y no se puede empacar',
      ORDER_MISSING_STOCK: 'A este pedido le falta inventario asignado',
      PACKAGES_DO_NOT_MATCH_BOXES: 'Los empaques enviados no son los de las cajas de este pedido',
      PACKING_INCOMPLETE: 'Quedaron piezas sin empacar o alguna caja sin cerrar',
      PROVIDER_TIMEOUT: 'El proveedor no respondió a tiempo',
      SHIPPING_COST_UNAVAILABLE: 'La paquetería no tiene tarifa activa para el peso de este pedido',
      SHIPPING_METHOD_NOT_CONFIGURED: 'El pedido es nacional pero tiene un método de envío internacional',
      T1_ADDRESS_UPDATE_FAILED: 'No se pudo actualizar la dirección con la paquetería',
      UNIT_CODE_VALIDATION_FAILED: 'Algún código de unidad escaneado no corresponde a este pedido',
      CARRIER_API_ERROR: 'Error temporal del carrier. Reintenta en unos momentos',
      CARRIER_CIRCUIT_OPEN: 'La paquetería está caída; dejamos de llamarla un minuto. Se reabre sola',
      CARRIER_TEMPORARY_FAILURE: 'La paquetería no respondió por un problema pasajero. Espera el contador y reintenta',
      CARRIER_NO_COVERAGE: 'La paquetería no da servicio en esta zona',
      CARRIER_ORIGIN_NOT_COVERED: 'La paquetería no llega a este destino desde este almacén',
      DESTINATION_ADDRESS_INVALID: 'La paquetería rechazó el destino: el código postal no existe',
      CARRIER_LABEL_GENERATION_FAILED: 'No se pudo generar la guía de envío',
      CARRIER_PDF_GENERATION_FAILED: 'No se pudo generar el PDF de la guía',
      CARRIER_UNSUPPORTED: 'Carrier no soportado para este pedido',
      INVOICE_CONTINGENCY: 'La factura se generó en modo contingencia',
      INVOICE_PROCESSING: 'La factura está en procesamiento. Reintenta en unos minutos',
      INVOICE_ATTACHMENT_CORRUPT: 'Los archivos de la factura están dañados',
      INVOICE_REJECTED: 'La factura fue rechazada por datos fiscales incorrectos',
      INVOICE_CERTIFICATE_EXPIRED: 'El certificado fiscal de la tienda está vencido',
      INVOICE_SEFAZ_UNAVAILABLE: 'SEFAZ no está disponible. Reintenta en unos minutos',
      INVOICE_CREDENTIALS_MISSING: 'La tienda no tiene credenciales fiscales configuradas',
      SHIPPING_INVOICE_ERROR: 'Error al generar factura de envío',
      SALE_INVOICE_MISSING: 'El pedido no tiene nota fiscal de venta. Fiscal debe emitirla o re-disparar la facturación',
      INVOICE_SERVICE_ERROR: 'Error interno del servicio de facturación',
      IMEI_VALIDATION_FAILED: 'Error en la validación de IMEIs',
      PACKAGE_VALIDATION_FAILED: 'Error en la validación del paquete',
      PACKAGE_NOT_ALLOWED_FOR_STORE: 'Esta caja no está permitida para esta marca',
      MULTIPACKAGE_NOT_SUPPORTED: 'Este carrier no soporta múltiples paquetes',
      SHIPPING_METHOD_INVALID: 'El método de envío no es válido para este pedido',
      ORDER_WRONG_STATUS: 'El pedido no está en un status válido para empacar',
      ORDER_ALREADY_PACKED: 'Este pedido ya fue empacado',
      ORDER_NOT_FOUND: 'Pedido no encontrado',
      ORDER_MISSING_DATA: 'Faltan datos en el pedido',
      EDIT_RESTRICTION: 'No se puede modificar este pedido',
      CLICK_AND_COLLECT_ERROR: 'Error en la reserva de punto de recolección',
      STORE_BILLING_CONFIGURATION_INVALID: 'La tienda tiene más de una configuración de cobro vigente para el mismo servicio',
      STORE_PACKING_DISABLED: 'El empaque está deshabilitado para esta tienda',
      ORDER_AWAITING_FIX: 'El pedido está esperando corrección',
      NOT_AUTHORIZED: 'No tienes permisos para realizar esta acción',
      LABEL_GENERATION_IN_PROGRESS: 'Ya se está generando una guía. Espera unos segundos',
      INVOICE_GENERATION_IN_PROGRESS: 'Ya se está generando una factura. Espera unos segundos',
      UNEXPECTED_ERROR: 'Error inesperado. Si persiste, reporta a soporte',
    },
    // Acción que debe tomar el operador según flag_type
    operator_headline: {
      retry: 'Reintenta ahora',
      wait: 'Espera y reintenta',
      move_on: 'Pasa a la siguiente orden',
      escalate: 'Repórtalo a {{area}}',
      escalate_no_area: 'Avisa a tu supervisor',
    },
    card: {
      order: 'Orden',
      tote: 'Tote',
      order_id: 'ID interno',
      carrier: 'Paquetería',
      destination: 'Destino',
      weight: 'Peso',
      retry_in: 'Reintenta en {{seconds}} s',
      wait_countdown: 'Suele resolverse solo. Reintenta en {{seconds}} s.',
      wait_elapsed: 'Ya puedes reintentar.',
      checking: 'Comprobando si ya se resolvió…',
      checking_short: 'Comprobando…',
      copy_report: 'Copiar reporte',
      copied: 'Copiado',
      report_to: 'Reportar a {{area}}',
      store: 'Tienda',
      report_title: 'Error de empaque',
      detail: 'Detalle',
      technical_detail: 'Detalle técnico',
      attempt: 'Intento {{attempt}} de {{total}}',
      attempts_exhausted: 'No reintentes más: el caso ya está con Tech.',
    },
    operator_action: {
      fix_address: 'Escalar a supervisor — la tienda debe corregir la dirección',
      fix_fiscal: 'Escalar a supervisor — la tienda debe corregir datos fiscales',
      fix_shipping: 'Escalar a supervisor — la tienda debe corregir el método de envío',
      fix_order_data: 'Escalar a supervisor — la tienda debe corregir los datos del pedido',
      contact_support: 'Avisar a la tienda que contacte a soporte',
      wait: 'Esperar unos minutos y reintentar',
      retry: 'Reintentar el empaque',
      move_on: 'Pasar al siguiente pedido — no hay nada que hacer con éste en la mesa',
      validate_address: 'Escalar a supervisor — la tienda debe validar la dirección',
      escalate: 'Sin más reintentos — el caso queda con Tech',
    },
    // Categorías
    category: {
      LAST_MILE: 'Última milla',
      INVOICING: 'Facturación',
      VALIDATION: 'Validación',
      AUTHORIZATION: 'Autorización',
      CONCURRENCY: 'Concurrencia',
      SYSTEM: 'Sistema',
    },
    // Área responsable
    responsible_area: {
      customer: 'Customer',
      cubbo_ops: 'Cubbo Ops',
      lastmile: 'Last Mile',
      tech: 'Tech',
      fiscal: 'Fiscal',
    },
    // Estados del error
    error_status: {
      open: 'Pendiente de corrección',
      pending_retry: 'Listo para reintentar',
      retry_failed: 'Reintento fallido',
      solved: 'Resuelto',
    },
    // Historial de errores en detalle de pedido
    history: {
      title: 'Errores de fulfillment',
      code: 'Código',
      category: 'Categoría',
      responsible: 'Responsable',
      status: 'Estado',
      action: 'Acción',
      message: 'Mensaje',
      date: 'Fecha',
      resolution: 'Resolución',
      no_errors: 'Sin errores de fulfillment',
      go_to_packing: 'Ir a empacar',
      since: 'desde',
      attempt: 'intento {{n}}',
      retry_count_one: '{{count}} reintento del ciclo',
      retry_count_other: '{{count}} reintentos del ciclo',
      collapsed_hint: 'Veces seguidas que se registró este mismo error. Clic para ver cada intento',
    },
    // Resoluciones
    resolution: {
      retried_success: 'Reintento exitoso',
      edited_order: 'Pedido corregido',
      cancelled_order: 'Pedido cancelado',
      externally_solved: 'Resuelto externamente',
      store_config_fixed: 'Configuración de tienda corregida',
      manual_override: 'Resolución manual',
      superseded: 'Reemplazado por error más reciente',
    },
    // Modal de error en empaque
    error_modal: {
      title: 'Error al generar la guía',
      responsible: 'Responsable',
      operator_action: 'Qué hacer',
      close: 'Cerrar',
      retry: 'Reintentar',
    },
    // Banner preventivo en vista de empaque
    packing_banner: {
      title: 'Error de fulfillment',
      pending_retry: 'La tienda ya corrigió este pedido. Puedes reintentar el empaque.',
      generic: 'Este pedido tiene un error de fulfillment pendiente.',
    },
    // Vista dedicada de errores
    page: {
      title: 'Errores de fulfillment',
      empty: 'No hay pedidos con errores activos',
      headers: {
        order_number: 'Pedido',
        store: 'Tienda',
        tote: 'Tote',
        category: 'Categoría',
        responsible_area: 'Responsable',
        operator_action: 'Acción',
        error_status: 'Estado',
        created_at: 'Desde',
      },
      filters: {
        responsible_area: 'Responsable',
        responsible_area_placeholder: 'Filtrar por responsable',
        error_status: 'Estado',
        error_status_placeholder: 'Filtrar por estado',
        tote: 'Tote',
        tote_placeholder: 'Buscar por tote',
        order_number: 'Pedido',
        store: 'Tienda',
      },
    },
  },
  pending_prints: {
    title: 'Impresiones pendientes',
    scan: {
      title: 'Escanea o escribe el código',
      subtitle:
        'Cualquier código generado en la HH que necesite etiqueta llega aquí, sin importar el flujo que lo originó. Escanéalo con la pistola o escríbelo y presiona Enter para mandarlo a la impresora.',
      placeholder: 'Escanea o escribe el código de impresión o del contenedor',
      submit: 'Imprimir',
      printing: 'Imprimiendo…',
    },
    outcome: {
      iframe: '{{code}} enviado a la impresora.',
      fallback: 'Abrimos la etiqueta en una pestaña nueva; imprímela desde ahí.',
      blocked: 'El navegador bloqueó la ventana de impresión. Abre la etiqueta para imprimirla.',
      timeout: 'La etiqueta no llegó a la impresora. Abre la etiqueta para imprimirla.',
      copies: 'Imprime {{count}} copias: elígelas en el diálogo de impresión.',
      open_label: 'Abrir etiqueta',
    },
    history: {
      title: 'Impresiones realizadas',
    },
    table: {
      print_code: 'Código de impresión',
      what: 'Qué se imprime',
      kind: 'Tipo',
      origin: 'Origen',
      store: 'Tienda',
      last_printed: 'Última impresión',
    },
    what: {
      one_label: '1 etiqueta',
    },
    kind: {
      box: 'Caja',
      pallet: 'Pallet',
    },
    origin: {
      replenishment: 'Recibo',
      replenishment_id: '#{{id}}',
    },
    ambiguous: {
      title: 'Este código coincide con varias etiquetas',
      subtitle: 'El código {{code}} coincide con varias etiquetas. Elige la que vas a imprimir.',
      print: 'Imprimir',
      cancel: 'Cancelar',
      new_code: 'Se generará un código de impresión nuevo',
      pieces_per_box: '{{count}} pz/caja',
      sku: 'SKU: {{sku}}',
      lot: 'Lote {{lot}}',
      lot_expires: 'vence {{date}}',
      store: 'Tienda:',
      origin: 'Origen:',
      created: 'Creada:',
      print_code: 'Código de impresión:',
    },
    actions: {
      print: 'Imprimir',
      reprint: 'Reimprimir',
    },
    filters: {
      print_code: 'Código de impresión',
      barcode: 'Código del contenedor',
      store: 'Tienda',
      store_placeholder: 'Nombre de la tienda',
      origin: 'Origen',
      origin_id: 'ID de origen',
      origin_id_placeholder: 'Número, p. ej. 1864',
      kind: 'Tipo',
      unprinted: 'Sin imprimir',
      last_printed: 'Última impresión',
    },
    empty: 'No hay impresiones que mostrar.',
    footer: 'impresiones',
    unavailable: 'Esta pantalla todavía no está disponible.',
    errors: {
      PRINT_JOB_NOT_FOUND: 'El código {{code}} no existe en el sistema.',
      INVALID_PARAMS: 'Escribe o escanea un código',
      FORBIDDEN: 'No tienes acceso a este almacén',
      timeout: 'El servidor tardó demasiado en responder. Intenta de nuevo.',
      network: 'No hay conexión con el servidor. Revisa tu red e intenta de nuevo.',
      generic: 'Algo salió mal. Intenta de nuevo.',
      unprintable_barcode: 'Este código tiene caracteres que no se pueden imprimir en la etiqueta. Avisa a tu supervisor.',
      PRINT_JOB_AMBIGUOUS: 'Este código coincide con varias etiquetas y no pudimos mostrarlas. Intenta de nuevo.',
      time_zone: 'No pudimos cargar la zona horaria del almacén, así que no se puede filtrar por fecha de impresión. Recarga la página.',
    },
  },
  romaneios: {
    title: 'Manifiestos de salida',
    headers: {
      number: 'Manifiesto',
      carrier: 'Paquetería',
      status: 'Estado',
      pickup: 'Recolección',
      boxes: 'Cajas',
      driver: 'Chofer',
      documents: 'Documentos',
    },
    filters: {
      number: 'Número de manifiesto',
      order_number: 'Número de orden',
      carrier: 'Paquetería',
      all_carriers: 'Todas las paqueterías',
      status: 'Estado',
      all_statuses: 'Todos los estados',
      from: 'Desde',
      to: 'Hasta',
    },
    statuses: {
      open: 'Abierto',
      handed_over: 'Entregado',
    },
    overdue: 'Atrasado',
    scheduled: 'Programada',
    picked_up: 'Recolectado',
    boxes_count_one: '{{count}} caja',
    boxes_count_other: '{{count}} cajas',
    orders_count_one: '{{count}} orden',
    orders_count_other: '{{count}} órdenes',
    handed_over_by: 'Entregó: {{name}}',
    opened_by: 'Abrió: {{name}}',
    signed: 'Firmado',
    unsigned: 'Sin firma',
    document: 'PDF',
    partial: 'Parcial {{sequence}}',
    verification: 'Página de verificación',
    no_document_open: 'Aún abierto',
    document_pending: 'Generando PDF',
    companion_of: 'Externos de {{number}} ({{carrier}})',
    companion: 'Externos: {{number}}',
    empty: 'No hay manifiestos de salida con estos filtros',
    error: 'No pudimos cargar los manifiestos. Intenta de nuevo.',
  },
  proof_video_coverage: {
    title: 'Cobertura de video de packing',
    period: {
      group: 'Período',
      previous_month: 'Mes anterior',
      next_month: 'Mes siguiente',
      custom: 'Rango personalizado',
      from: 'Desde',
      to: 'Hasta',
      apply: 'Aplicar',
      range: 'Del {{from}} al {{to}}',
      errors: {
        span_too_long: 'El período no puede superar un mes.',
        to_before_from: 'La fecha final no puede ser anterior a la inicial.',
        to_in_future: 'La fecha final no puede ser posterior a hoy.',
        malformed: 'Ingresa fechas válidas.',
      },
    },
    headline: {
      label: 'Cobertura de video de packing',
      description: 'Pedidos con video de packing guardado y sin intentos fallidos.',
      of_packed_one: 'de {{orders}} pedido empacado',
      of_packed_other: 'de {{orders}} pedidos empacados',
    },
    table: {
      caption: 'Pedidos empacados del {{from}} al {{to}}',
      situation: 'Situación',
      orders: 'Pedidos',
      share: 'Proporción',
      total: 'Total de pedidos empacados',
    },
    slices: {
      covered: { label: 'Con video', description: 'Video de packing guardado.' },
      partial: {
        label: 'Con video tras un intento fallido',
        description: 'Hay video guardado, pero un intento anterior de grabación falló: puede faltar el inicio del packing.',
      },
      salvaged: {
        label: 'Video recuperado',
        description: 'La subida no terminó bien; se guardó lo que alcanzó a subir y el video puede estar incompleto.',
      },
      pending: {
        label: 'Subida en curso',
        description: 'La subida del video aún no se confirma; el sistema la marcará como guardada o perdida.',
      },
      not_stored: { label: 'Video no guardado', description: 'Se inició la grabación, pero ningún intento llegó a guardarse.' },
      no_session: { label: 'Sin grabación', description: 'No hay registro de grabación para este pedido (incluye estaciones sin cámara).' },
    },
    states: {
      loading: 'Cargando cobertura…',
      time_zone_missing: 'No se pudo determinar la zona horaria del almacén, así que no es posible calcular el período.',
      invalid_period: 'El período de la URL no es válido.',
      forbidden: 'No tienes permiso para ver la cobertura de video de este almacén.',
      not_found: 'No encontramos este almacén.',
      rejected: 'El período del {{from}} al {{to}} no fue aceptado.',
      failed: 'No pudimos cargar la cobertura. Intenta de nuevo.',
      empty: 'No hubo pedidos empacados del {{from}} al {{to}}.',
      retry: 'Reintentar',
    },
  },
}
